import * as ze from "react";
import Ps from "react";
function Cs(l) {
  if (l.sheet)
    return l.sheet;
  for (var c = 0; c < document.styleSheets.length; c++)
    if (document.styleSheets[c].ownerNode === l)
      return document.styleSheets[c];
}
function Ts(l) {
  var c = document.createElement("style");
  return c.setAttribute("data-emotion", l.key), l.nonce !== void 0 && c.setAttribute("nonce", l.nonce), c.appendChild(document.createTextNode("")), c.setAttribute("data-s", ""), c;
}
var Ms = /* @__PURE__ */ function() {
  function l(y) {
    var A = this;
    this._insertTag = function(F) {
      var L;
      A.tags.length === 0 ? A.insertionPoint ? L = A.insertionPoint.nextSibling : A.prepend ? L = A.container.firstChild : L = A.before : L = A.tags[A.tags.length - 1].nextSibling, A.container.insertBefore(F, L), A.tags.push(F);
    }, this.isSpeedy = y.speedy === void 0 ? process.env.NODE_ENV === "production" : y.speedy, this.tags = [], this.ctr = 0, this.nonce = y.nonce, this.key = y.key, this.container = y.container, this.prepend = y.prepend, this.insertionPoint = y.insertionPoint, this.before = null;
  }
  var c = l.prototype;
  return c.hydrate = function(A) {
    A.forEach(this._insertTag);
  }, c.insert = function(A) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ts(this));
    var F = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var L = A.charCodeAt(0) === 64 && A.charCodeAt(1) === 105;
      L && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + A + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !L;
    }
    if (this.isSpeedy) {
      var O = Cs(F);
      try {
        O.insertRule(A, O.cssRules.length);
      } catch (R) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(A) && console.error('There was a problem inserting the following rule: "' + A + '"', R);
      }
    } else
      F.appendChild(document.createTextNode(A));
    this.ctr++;
  }, c.flush = function() {
    this.tags.forEach(function(A) {
      return A.parentNode && A.parentNode.removeChild(A);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, l;
}(), qt = "-ms-", ki = "-moz-", bt = "-webkit-", Ji = "comm", Qi = "rule", tr = "decl", Fs = "@import", Dr = "@keyframes", Is = Math.abs, Si = String.fromCharCode, Ls = Object.assign;
function Os(l, c) {
  return (((c << 2 ^ Jt(l, 0)) << 2 ^ Jt(l, 1)) << 2 ^ Jt(l, 2)) << 2 ^ Jt(l, 3);
}
function jr(l) {
  return l.trim();
}
function Rs(l, c) {
  return (l = c.exec(l)) ? l[0] : l;
}
function kt(l, c, y) {
  return l.replace(c, y);
}
function Xi(l, c) {
  return l.indexOf(c);
}
function Jt(l, c) {
  return l.charCodeAt(c) | 0;
}
function ni(l, c, y) {
  return l.slice(c, y);
}
function ge(l) {
  return l.length;
}
function er(l) {
  return l.length;
}
function mi(l, c) {
  return c.push(l), l;
}
function Vs(l, c) {
  return l.map(c).join("");
}
var Ai = 1, Ke = 1, Nr = 0, Qt = 0, Lt = 0, Ze = "";
function Ei(l, c, y, A, F, L, O) {
  return { value: l, root: c, parent: y, type: A, props: F, children: L, line: Ai, column: Ke, length: O, return: "" };
}
function si(l, c) {
  return Ls(Ei("", null, null, "", null, null, 0), l, { length: -l.length }, c);
}
function Bs() {
  return Lt;
}
function Ds() {
  return Lt = Qt > 0 ? Jt(Ze, --Qt) : 0, Ke--, Lt === 10 && (Ke = 1, Ai--), Lt;
}
function se() {
  return Lt = Qt < Nr ? Jt(Ze, Qt++) : 0, Ke++, Lt === 10 && (Ke = 1, Ai++), Lt;
}
function be() {
  return Jt(Ze, Qt);
}
function gi() {
  return Qt;
}
function hi(l, c) {
  return ni(Ze, l, c);
}
function ai(l) {
  switch (l) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function zr(l) {
  return Ai = Ke = 1, Nr = ge(Ze = l), Qt = 0, [];
}
function $r(l) {
  return Ze = "", l;
}
function bi(l) {
  return jr(hi(Qt - 1, Ui(l === 91 ? l + 2 : l === 40 ? l + 1 : l)));
}
function js(l) {
  for (; (Lt = be()) && Lt < 33; )
    se();
  return ai(l) > 2 || ai(Lt) > 3 ? "" : " ";
}
function Ns(l, c) {
  for (; --c && se() && !(Lt < 48 || Lt > 102 || Lt > 57 && Lt < 65 || Lt > 70 && Lt < 97); )
    ;
  return hi(l, gi() + (c < 6 && be() == 32 && se() == 32));
}
function Ui(l) {
  for (; se(); )
    switch (Lt) {
      case l:
        return Qt;
      case 34:
      case 39:
        l !== 34 && l !== 39 && Ui(Lt);
        break;
      case 40:
        l === 41 && Ui(l);
        break;
      case 92:
        se();
        break;
    }
  return Qt;
}
function zs(l, c) {
  for (; se() && l + Lt !== 47 + 10; )
    if (l + Lt === 42 + 42 && be() === 47)
      break;
  return "/*" + hi(c, Qt - 1) + "*" + Si(l === 47 ? l : se());
}
function $s(l) {
  for (; !ai(be()); )
    se();
  return hi(l, Qt);
}
function qs(l) {
  return $r(_i("", null, null, null, [""], l = zr(l), 0, [0], l));
}
function _i(l, c, y, A, F, L, O, R, z) {
  for (var j = 0, Y = 0, rt = O, lt = 0, mt = 0, wt = 0, nt = 1, ht = 1, pt = 1, xt = 0, Mt = "", Yt = F, Ot = L, tt = A, yt = Mt; ht; )
    switch (wt = xt, xt = se()) {
      case 40:
        if (wt != 108 && yt.charCodeAt(rt - 1) == 58) {
          Xi(yt += kt(bi(xt), "&", "&\f"), "&\f") != -1 && (pt = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        yt += bi(xt);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        yt += js(wt);
        break;
      case 92:
        yt += Ns(gi() - 1, 7);
        continue;
      case 47:
        switch (be()) {
          case 42:
          case 47:
            mi(Gs(zs(se(), gi()), c, y), z);
            break;
          default:
            yt += "/";
        }
        break;
      case 123 * nt:
        R[j++] = ge(yt) * pt;
      case 125 * nt:
      case 59:
      case 0:
        switch (xt) {
          case 0:
          case 125:
            ht = 0;
          case 59 + Y:
            mt > 0 && ge(yt) - rt && mi(mt > 32 ? Sr(yt + ";", A, y, rt - 1) : Sr(kt(yt, " ", "") + ";", A, y, rt - 2), z);
            break;
          case 59:
            yt += ";";
          default:
            if (mi(tt = xr(yt, c, y, j, Y, F, R, Mt, Yt = [], Ot = [], rt), L), xt === 123)
              if (Y === 0)
                _i(yt, c, tt, tt, Yt, L, rt, R, Ot);
              else
                switch (lt) {
                  case 100:
                  case 109:
                  case 115:
                    _i(l, tt, tt, A && mi(xr(l, tt, tt, 0, 0, F, R, Mt, F, Yt = [], rt), Ot), F, Ot, rt, R, A ? Yt : Ot);
                    break;
                  default:
                    _i(yt, tt, tt, tt, [""], Ot, 0, R, Ot);
                }
        }
        j = Y = mt = 0, nt = pt = 1, Mt = yt = "", rt = O;
        break;
      case 58:
        rt = 1 + ge(yt), mt = wt;
      default:
        if (nt < 1) {
          if (xt == 123)
            --nt;
          else if (xt == 125 && nt++ == 0 && Ds() == 125)
            continue;
        }
        switch (yt += Si(xt), xt * nt) {
          case 38:
            pt = Y > 0 ? 1 : (yt += "\f", -1);
            break;
          case 44:
            R[j++] = (ge(yt) - 1) * pt, pt = 1;
            break;
          case 64:
            be() === 45 && (yt += bi(se())), lt = be(), Y = rt = ge(Mt = yt += $s(gi())), xt++;
            break;
          case 45:
            wt === 45 && ge(yt) == 2 && (nt = 0);
        }
    }
  return L;
}
function xr(l, c, y, A, F, L, O, R, z, j, Y) {
  for (var rt = F - 1, lt = F === 0 ? L : [""], mt = er(lt), wt = 0, nt = 0, ht = 0; wt < A; ++wt)
    for (var pt = 0, xt = ni(l, rt + 1, rt = Is(nt = O[wt])), Mt = l; pt < mt; ++pt)
      (Mt = jr(nt > 0 ? lt[pt] + " " + xt : kt(xt, /&\f/g, lt[pt]))) && (z[ht++] = Mt);
  return Ei(l, c, y, F === 0 ? Qi : R, z, j, Y);
}
function Gs(l, c, y) {
  return Ei(l, c, y, Ji, Si(Bs()), ni(l, 2, -2), 0);
}
function Sr(l, c, y, A) {
  return Ei(l, c, y, tr, ni(l, 0, A), ni(l, A + 1, -1), A);
}
function qr(l, c) {
  switch (Os(l, c)) {
    case 5103:
      return bt + "print-" + l + l;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return bt + l + l;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return bt + l + ki + l + qt + l + l;
    case 6828:
    case 4268:
      return bt + l + qt + l + l;
    case 6165:
      return bt + l + qt + "flex-" + l + l;
    case 5187:
      return bt + l + kt(l, /(\w+).+(:[^]+)/, bt + "box-$1$2" + qt + "flex-$1$2") + l;
    case 5443:
      return bt + l + qt + "flex-item-" + kt(l, /flex-|-self/, "") + l;
    case 4675:
      return bt + l + qt + "flex-line-pack" + kt(l, /align-content|flex-|-self/, "") + l;
    case 5548:
      return bt + l + qt + kt(l, "shrink", "negative") + l;
    case 5292:
      return bt + l + qt + kt(l, "basis", "preferred-size") + l;
    case 6060:
      return bt + "box-" + kt(l, "-grow", "") + bt + l + qt + kt(l, "grow", "positive") + l;
    case 4554:
      return bt + kt(l, /([^-])(transform)/g, "$1" + bt + "$2") + l;
    case 6187:
      return kt(kt(kt(l, /(zoom-|grab)/, bt + "$1"), /(image-set)/, bt + "$1"), l, "") + l;
    case 5495:
    case 3959:
      return kt(l, /(image-set\([^]*)/, bt + "$1$`$1");
    case 4968:
      return kt(kt(l, /(.+:)(flex-)?(.*)/, bt + "box-pack:$3" + qt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + bt + l + l;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return kt(l, /(.+)-inline(.+)/, bt + "$1$2") + l;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ge(l) - 1 - c > 6)
        switch (Jt(l, c + 1)) {
          case 109:
            if (Jt(l, c + 4) !== 45)
              break;
          case 102:
            return kt(l, /(.+:)(.+)-([^]+)/, "$1" + bt + "$2-$3$1" + ki + (Jt(l, c + 3) == 108 ? "$3" : "$2-$3")) + l;
          case 115:
            return ~Xi(l, "stretch") ? qr(kt(l, "stretch", "fill-available"), c) + l : l;
        }
      break;
    case 4949:
      if (Jt(l, c + 1) !== 115)
        break;
    case 6444:
      switch (Jt(l, ge(l) - 3 - (~Xi(l, "!important") && 10))) {
        case 107:
          return kt(l, ":", ":" + bt) + l;
        case 101:
          return kt(l, /(.+:)([^;!]+)(;|!.+)?/, "$1" + bt + (Jt(l, 14) === 45 ? "inline-" : "") + "box$3$1" + bt + "$2$3$1" + qt + "$2box$3") + l;
      }
      break;
    case 5936:
      switch (Jt(l, c + 11)) {
        case 114:
          return bt + l + qt + kt(l, /[svh]\w+-[tblr]{2}/, "tb") + l;
        case 108:
          return bt + l + qt + kt(l, /[svh]\w+-[tblr]{2}/, "tb-rl") + l;
        case 45:
          return bt + l + qt + kt(l, /[svh]\w+-[tblr]{2}/, "lr") + l;
      }
      return bt + l + qt + l + l;
  }
  return l;
}
function Ue(l, c) {
  for (var y = "", A = er(l), F = 0; F < A; F++)
    y += c(l[F], F, l, c) || "";
  return y;
}
function Ws(l, c, y, A) {
  switch (l.type) {
    case Fs:
    case tr:
      return l.return = l.return || l.value;
    case Ji:
      return "";
    case Dr:
      return l.return = l.value + "{" + Ue(l.children, A) + "}";
    case Qi:
      l.value = l.props.join(",");
  }
  return ge(y = Ue(l.children, A)) ? l.return = l.value + "{" + y + "}" : "";
}
function Ys(l) {
  var c = er(l);
  return function(y, A, F, L) {
    for (var O = "", R = 0; R < c; R++)
      O += l[R](y, A, F, L) || "";
    return O;
  };
}
function Xs(l) {
  return function(c) {
    c.root || (c = c.return) && l(c);
  };
}
function Us(l, c, y, A) {
  if (l.length > -1 && !l.return)
    switch (l.type) {
      case tr:
        l.return = qr(l.value, l.length);
        break;
      case Dr:
        return Ue([si(l, { value: kt(l.value, "@", "@" + bt) })], A);
      case Qi:
        if (l.length)
          return Vs(l.props, function(F) {
            switch (Rs(F, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Ue([si(l, { props: [kt(F, /:(read-\w+)/, ":" + ki + "$1")] })], A);
              case "::placeholder":
                return Ue([
                  si(l, { props: [kt(F, /:(plac\w+)/, ":" + bt + "input-$1")] }),
                  si(l, { props: [kt(F, /:(plac\w+)/, ":" + ki + "$1")] }),
                  si(l, { props: [kt(F, /:(plac\w+)/, qt + "input-$1")] })
                ], A);
            }
            return "";
          });
    }
}
function Hs(l) {
  var c = /* @__PURE__ */ Object.create(null);
  return function(y) {
    return c[y] === void 0 && (c[y] = l(y)), c[y];
  };
}
var Ks = function(c) {
  return c.length ? c[c.length - 1] : null;
}, Zs = function(c, y, A) {
  for (var F = 0, L = 0; F = L, L = be(), F === 38 && L === 12 && (y[A] = 1), !ai(L); )
    se();
  return hi(c, Qt);
}, Js = function(c, y) {
  var A = -1, F = 44;
  do
    switch (ai(F)) {
      case 0:
        F === 38 && be() === 12 && (y[A] = 1), c[A] += Zs(Qt - 1, y, A);
        break;
      case 2:
        c[A] += bi(F);
        break;
      case 4:
        if (F === 44) {
          c[++A] = be() === 58 ? "&\f" : "", y[A] = c[A].length;
          break;
        }
      default:
        c[A] += Si(F);
    }
  while (F = se());
  return c;
}, Qs = function(c, y) {
  return $r(Js(zr(c), y));
}, Ar = /* @__PURE__ */ new WeakMap(), tn = function(c) {
  if (!(c.type !== "rule" || !c.parent || c.length < 1)) {
    for (var y = c.value, A = c.parent, F = c.column === A.column && c.line === A.line; A.type !== "rule"; )
      if (A = A.parent, !A)
        return;
    if (!(c.props.length === 1 && y.charCodeAt(0) !== 58 && !Ar.get(A)) && !F) {
      Ar.set(c, !0);
      for (var L = [], O = Qs(y, L), R = A.props, z = 0, j = 0; z < O.length; z++)
        for (var Y = 0; Y < R.length; Y++, j++)
          c.props[j] = L[z] ? O[z].replace(/&\f/g, R[Y]) : R[Y] + " " + O[z];
    }
  }
}, en = function(c) {
  if (c.type === "decl") {
    var y = c.value;
    y.charCodeAt(0) === 108 && y.charCodeAt(2) === 98 && (c.return = "", c.value = "");
  }
}, rn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", sn = function(c) {
  return !!c && c.type === "comm" && c.children.indexOf(rn) > -1;
}, nn = function(c) {
  return function(y, A, F) {
    if (y.type === "rule") {
      var L = y.value.match(/(:first|:nth|:nth-last)-child/g);
      if (L && c.compat !== !0) {
        var O = A > 0 ? F[A - 1] : null;
        if (O && sn(Ks(O.children)))
          return;
        L.forEach(function(R) {
          console.error('The pseudo class "' + R + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + R.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Gr = function(c) {
  return c.type.charCodeAt(1) === 105 && c.type.charCodeAt(0) === 64;
}, an = function(c, y) {
  for (var A = c - 1; A >= 0; A--)
    if (!Gr(y[A]))
      return !0;
  return !1;
}, Er = function(c) {
  c.type = "", c.value = "", c.return = "", c.children = "", c.props = "";
}, on = function(c, y, A) {
  !Gr(c) || (c.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Er(c)) : an(y, A) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Er(c)));
}, hn = [Us], ln = function(c) {
  var y = c.key;
  if (process.env.NODE_ENV !== "production" && !y)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (y === "css") {
    var A = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(A, function(nt) {
      var ht = nt.getAttribute("data-emotion");
      ht.indexOf(" ") !== -1 && (document.head.appendChild(nt), nt.setAttribute("data-s", ""));
    });
  }
  var F = c.stylisPlugins || hn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(y))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + y + '" was passed');
  var L = {}, O, R = [];
  O = c.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + y + ' "]'), function(nt) {
    for (var ht = nt.getAttribute("data-emotion").split(" "), pt = 1; pt < ht.length; pt++)
      L[ht[pt]] = !0;
    R.push(nt);
  });
  var z, j = [tn, en];
  process.env.NODE_ENV !== "production" && j.push(nn({
    get compat() {
      return wt.compat;
    }
  }), on);
  {
    var Y, rt = [Ws, process.env.NODE_ENV !== "production" ? function(nt) {
      nt.root || (nt.return ? Y.insert(nt.return) : nt.value && nt.type !== Ji && Y.insert(nt.value + "{}"));
    } : Xs(function(nt) {
      Y.insert(nt);
    })], lt = Ys(j.concat(F, rt)), mt = function(ht) {
      return Ue(qs(ht), lt);
    };
    z = function(ht, pt, xt, Mt) {
      Y = xt, process.env.NODE_ENV !== "production" && pt.map !== void 0 && (Y = {
        insert: function(Ot) {
          xt.insert(Ot + pt.map);
        }
      }), mt(ht ? ht + "{" + pt.styles + "}" : pt.styles), Mt && (wt.inserted[pt.name] = !0);
    };
  }
  var wt = {
    key: y,
    sheet: new Ms({
      key: y,
      container: O,
      nonce: c.nonce,
      speedy: c.speedy,
      prepend: c.prepend,
      insertionPoint: c.insertionPoint
    }),
    nonce: c.nonce,
    inserted: L,
    registered: {},
    insert: z
  };
  return wt.sheet.hydrate(R), wt;
};
function fn(l) {
  for (var c = 0, y, A = 0, F = l.length; F >= 4; ++A, F -= 4)
    y = l.charCodeAt(A) & 255 | (l.charCodeAt(++A) & 255) << 8 | (l.charCodeAt(++A) & 255) << 16 | (l.charCodeAt(++A) & 255) << 24, y = (y & 65535) * 1540483477 + ((y >>> 16) * 59797 << 16), y ^= y >>> 24, c = (y & 65535) * 1540483477 + ((y >>> 16) * 59797 << 16) ^ (c & 65535) * 1540483477 + ((c >>> 16) * 59797 << 16);
  switch (F) {
    case 3:
      c ^= (l.charCodeAt(A + 2) & 255) << 16;
    case 2:
      c ^= (l.charCodeAt(A + 1) & 255) << 8;
    case 1:
      c ^= l.charCodeAt(A) & 255, c = (c & 65535) * 1540483477 + ((c >>> 16) * 59797 << 16);
  }
  return c ^= c >>> 13, c = (c & 65535) * 1540483477 + ((c >>> 16) * 59797 << 16), ((c ^ c >>> 15) >>> 0).toString(36);
}
var un = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, wr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, cn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", pn = /[A-Z]|^ms/g, Wr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ir = function(c) {
  return c.charCodeAt(1) === 45;
}, Pr = function(c) {
  return c != null && typeof c != "boolean";
}, Wi = /* @__PURE__ */ Hs(function(l) {
  return ir(l) ? l : l.replace(pn, "-$&").toLowerCase();
}), xi = function(c, y) {
  switch (c) {
    case "animation":
    case "animationName":
      if (typeof y == "string")
        return y.replace(Wr, function(A, F, L) {
          return pe = {
            name: F,
            styles: L,
            next: pe
          }, F;
        });
  }
  return un[c] !== 1 && !ir(c) && typeof y == "number" && y !== 0 ? y + "px" : y;
};
if (process.env.NODE_ENV !== "production") {
  var dn = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, vn = ["normal", "none", "initial", "inherit", "unset"], mn = xi, yn = /^-ms-/, gn = /-(.)/g, Cr = {};
  xi = function(c, y) {
    if (c === "content" && (typeof y != "string" || vn.indexOf(y) === -1 && !dn.test(y) && (y.charAt(0) !== y.charAt(y.length - 1) || y.charAt(0) !== '"' && y.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + y + "\"'`");
    var A = mn(c, y);
    return A !== "" && !ir(c) && c.indexOf("-") !== -1 && Cr[c] === void 0 && (Cr[c] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + c.replace(yn, "ms-").replace(gn, function(F, L) {
      return L.toUpperCase();
    }) + "?")), A;
  };
}
var Yr = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function oi(l, c, y) {
  if (y == null)
    return "";
  if (y.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && y.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Yr);
    return y;
  }
  switch (typeof y) {
    case "boolean":
      return "";
    case "object": {
      if (y.anim === 1)
        return pe = {
          name: y.name,
          styles: y.styles,
          next: pe
        }, y.name;
      if (y.styles !== void 0) {
        var A = y.next;
        if (A !== void 0)
          for (; A !== void 0; )
            pe = {
              name: A.name,
              styles: A.styles,
              next: pe
            }, A = A.next;
        var F = y.styles + ";";
        return process.env.NODE_ENV !== "production" && y.map !== void 0 && (F += y.map), F;
      }
      return bn(l, c, y);
    }
    case "function": {
      if (l !== void 0) {
        var L = pe, O = y(l);
        return pe = L, oi(l, c, O);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var R = [], z = y.replace(Wr, function(Y, rt, lt) {
          var mt = "animation" + R.length;
          return R.push("const " + mt + " = keyframes`" + lt.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + mt + "}";
        });
        R.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(R, ["`" + z + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + z + "`"));
      }
      break;
  }
  if (c == null)
    return y;
  var j = c[y];
  return j !== void 0 ? j : y;
}
function bn(l, c, y) {
  var A = "";
  if (Array.isArray(y))
    for (var F = 0; F < y.length; F++)
      A += oi(l, c, y[F]) + ";";
  else
    for (var L in y) {
      var O = y[L];
      if (typeof O != "object")
        c != null && c[O] !== void 0 ? A += L + "{" + c[O] + "}" : Pr(O) && (A += Wi(L) + ":" + xi(L, O) + ";");
      else {
        if (L === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Yr);
        if (Array.isArray(O) && typeof O[0] == "string" && (c == null || c[O[0]] === void 0))
          for (var R = 0; R < O.length; R++)
            Pr(O[R]) && (A += Wi(L) + ":" + xi(L, O[R]) + ";");
        else {
          var z = oi(l, c, O);
          switch (L) {
            case "animation":
            case "animationName": {
              A += Wi(L) + ":" + z + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && L === "undefined" && console.error(cn), A += L + "{" + z + "}";
          }
        }
      }
    }
  return A;
}
var Tr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Xr;
process.env.NODE_ENV !== "production" && (Xr = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var pe, Yi = function(c, y, A) {
  if (c.length === 1 && typeof c[0] == "object" && c[0] !== null && c[0].styles !== void 0)
    return c[0];
  var F = !0, L = "";
  pe = void 0;
  var O = c[0];
  O == null || O.raw === void 0 ? (F = !1, L += oi(A, y, O)) : (process.env.NODE_ENV !== "production" && O[0] === void 0 && console.error(wr), L += O[0]);
  for (var R = 1; R < c.length; R++)
    L += oi(A, y, c[R]), F && (process.env.NODE_ENV !== "production" && O[R] === void 0 && console.error(wr), L += O[R]);
  var z;
  process.env.NODE_ENV !== "production" && (L = L.replace(Xr, function(lt) {
    return z = lt, "";
  })), Tr.lastIndex = 0;
  for (var j = "", Y; (Y = Tr.exec(L)) !== null; )
    j += "-" + Y[1];
  var rt = fn(L) + j;
  return process.env.NODE_ENV !== "production" ? {
    name: rt,
    styles: L,
    map: z,
    next: pe,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: rt,
    styles: L,
    next: pe
  };
}, _n = !0;
function Ur(l, c, y) {
  var A = "";
  return y.split(" ").forEach(function(F) {
    l[F] !== void 0 ? c.push(l[F] + ";") : A += F + " ";
  }), A;
}
var kn = function(c, y, A) {
  var F = c.key + "-" + y.name;
  (A === !1 || _n === !1) && c.registered[F] === void 0 && (c.registered[F] = y.styles);
}, xn = function(c, y, A) {
  kn(c, y, A);
  var F = c.key + "-" + y.name;
  if (c.inserted[y.name] === void 0) {
    var L = y;
    do
      c.insert(y === L ? "." + F : "", L, c.sheet, !0), L = L.next;
    while (L !== void 0);
  }
};
function Mr(l, c) {
  if (l.inserted[c.name] === void 0)
    return l.insert("", c, l.sheet, !0);
}
function Fr(l, c, y) {
  var A = [], F = Ur(l, A, y);
  return A.length < 2 ? y : F + c(A);
}
var Sn = function(c) {
  var y = ln(c);
  y.sheet.speedy = function(R) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = R;
  }, y.compat = !0;
  var A = function() {
    for (var z = arguments.length, j = new Array(z), Y = 0; Y < z; Y++)
      j[Y] = arguments[Y];
    var rt = Yi(j, y.registered, void 0);
    return xn(y, rt, !1), y.key + "-" + rt.name;
  }, F = function() {
    for (var z = arguments.length, j = new Array(z), Y = 0; Y < z; Y++)
      j[Y] = arguments[Y];
    var rt = Yi(j, y.registered), lt = "animation-" + rt.name;
    return Mr(y, {
      name: rt.name,
      styles: "@keyframes " + lt + "{" + rt.styles + "}"
    }), lt;
  }, L = function() {
    for (var z = arguments.length, j = new Array(z), Y = 0; Y < z; Y++)
      j[Y] = arguments[Y];
    var rt = Yi(j, y.registered);
    Mr(y, rt);
  }, O = function() {
    for (var z = arguments.length, j = new Array(z), Y = 0; Y < z; Y++)
      j[Y] = arguments[Y];
    return Fr(y.registered, A, An(j));
  };
  return {
    css: A,
    cx: O,
    injectGlobal: L,
    keyframes: F,
    hydrate: function(z) {
      z.forEach(function(j) {
        y.inserted[j] = !0;
      });
    },
    flush: function() {
      y.registered = {}, y.inserted = {}, y.sheet.flush();
    },
    sheet: y.sheet,
    cache: y,
    getRegisteredStyles: Ur.bind(null, y.registered),
    merge: Fr.bind(null, y.registered, A)
  };
}, An = function l(c) {
  for (var y = "", A = 0; A < c.length; A++) {
    var F = c[A];
    if (F != null) {
      var L = void 0;
      switch (typeof F) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(F))
            L = l(F);
          else {
            L = "";
            for (var O in F)
              F[O] && O && (L && (L += " "), L += O);
          }
          break;
        }
        default:
          L = F;
      }
      L && (y && (y += " "), y += L);
    }
  }
  return y;
}, Hr = Sn({
  key: "css"
}), En = Hr.cx, Kr = Hr.css, Zr = { exports: {} };
(function(l) {
  typeof navigator < "u" && function(c, y) {
    l.exports ? l.exports = y(c) : (c.lottie = y(c), c.bodymovin = c.lottie);
  }(window || {}, function(c) {
    var y = "http://www.w3.org/2000/svg", A = "", F = -999999, L = !0, O = "", R, z = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), j = Math.pow, Y = Math.sqrt, rt = Math.floor, lt = Math.min, mt = {};
    (function() {
      var t = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], e, i = t.length;
      for (e = 0; e < i; e += 1)
        mt[t[e]] = Math[t[e]];
    })();
    function wt() {
      return {};
    }
    mt.random = Math.random, mt.abs = function(t) {
      var e = typeof t;
      if (e === "object" && t.length) {
        var i = it(t.length), r, o = t.length;
        for (r = 0; r < o; r += 1)
          i[r] = Math.abs(t[r]);
        return i;
      }
      return Math.abs(t);
    };
    var nt = 150, ht = Math.PI / 180, pt = 0.5519;
    function xt(t, e, i, r) {
      this.type = t, this.currentTime = e, this.totalTime = i, this.direction = r < 0 ? -1 : 1;
    }
    function Mt(t, e) {
      this.type = t, this.direction = e < 0 ? -1 : 1;
    }
    function Yt(t, e, i, r) {
      this.type = t, this.currentLoop = i, this.totalLoops = e, this.direction = r < 0 ? -1 : 1;
    }
    function Ot(t, e, i) {
      this.type = t, this.firstFrame = e, this.totalFrames = i;
    }
    function tt(t, e) {
      this.type = t, this.target = e;
    }
    function yt(t, e) {
      this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
    }
    function Ct(t) {
      this.type = "configError", this.nativeError = t;
    }
    var Ft = function() {
      var t = 0;
      return function() {
        return t += 1, O + "__lottie_element_" + t;
      };
    }();
    function de(t, e, i) {
      var r, o, s, m, C, g, M, T;
      switch (m = Math.floor(t * 6), C = t * 6 - m, g = i * (1 - e), M = i * (1 - C * e), T = i * (1 - (1 - C) * e), m % 6) {
        case 0:
          r = i, o = T, s = g;
          break;
        case 1:
          r = M, o = i, s = g;
          break;
        case 2:
          r = g, o = i, s = T;
          break;
        case 3:
          r = g, o = M, s = i;
          break;
        case 4:
          r = T, o = g, s = i;
          break;
        case 5:
          r = i, o = g, s = M;
          break;
      }
      return [
        r,
        o,
        s
      ];
    }
    function Xt(t, e, i) {
      var r = Math.max(t, e, i), o = Math.min(t, e, i), s = r - o, m, C = r === 0 ? 0 : s / r, g = r / 255;
      switch (r) {
        case o:
          m = 0;
          break;
        case t:
          m = e - i + s * (e < i ? 6 : 0), m /= 6 * s;
          break;
        case e:
          m = i - t + s * 2, m /= 6 * s;
          break;
        case i:
          m = t - e + s * 4, m /= 6 * s;
          break;
      }
      return [
        m,
        C,
        g
      ];
    }
    function G(t, e) {
      var i = Xt(t[0] * 255, t[1] * 255, t[2] * 255);
      return i[1] += e, i[1] > 1 ? i[1] = 1 : i[1] <= 0 && (i[1] = 0), de(i[0], i[1], i[2]);
    }
    function Q(t, e) {
      var i = Xt(t[0] * 255, t[1] * 255, t[2] * 255);
      return i[2] += e, i[2] > 1 ? i[2] = 1 : i[2] < 0 && (i[2] = 0), de(i[0], i[1], i[2]);
    }
    function ft(t, e) {
      var i = Xt(t[0] * 255, t[1] * 255, t[2] * 255);
      return i[0] += e / 360, i[0] > 1 ? i[0] -= 1 : i[0] < 0 && (i[0] += 1), de(i[0], i[1], i[2]);
    }
    (function() {
      var t = [], e, i;
      for (e = 0; e < 256; e += 1)
        i = e.toString(16), t[e] = i.length === 1 ? "0" + i : i;
      return function(r, o, s) {
        return r < 0 && (r = 0), o < 0 && (o = 0), s < 0 && (s = 0), "#" + t[r] + t[o] + t[s];
      };
    })();
    function ut() {
    }
    ut.prototype = {
      triggerEvent: function(t, e) {
        if (this._cbs[t])
          for (var i = this._cbs[t], r = 0; r < i.length; r += 1)
            i[r](e);
      },
      addEventListener: function(t, e) {
        return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), function() {
          this.removeEventListener(t, e);
        }.bind(this);
      },
      removeEventListener: function(t, e) {
        if (!e)
          this._cbs[t] = null;
        else if (this._cbs[t]) {
          for (var i = 0, r = this._cbs[t].length; i < r; )
            this._cbs[t][i] === e && (this._cbs[t].splice(i, 1), i -= 1, r -= 1), i += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      }
    };
    var et = function() {
      function t(i, r) {
        var o = 0, s = [], m;
        switch (i) {
          case "int16":
          case "uint8c":
            m = 1;
            break;
          default:
            m = 1.1;
            break;
        }
        for (o = 0; o < r; o += 1)
          s.push(m);
        return s;
      }
      function e(i, r) {
        return i === "float32" ? new Float32Array(r) : i === "int16" ? new Int16Array(r) : i === "uint8c" ? new Uint8ClampedArray(r) : t(i, r);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? e : t;
    }();
    function it(t) {
      return Array.apply(null, { length: t });
    }
    function W(t) {
      return document.createElementNS(y, t);
    }
    function at(t) {
      return document.createElement(t);
    }
    function st() {
    }
    st.prototype = {
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var t, e = this.dynamicProperties.length;
        for (t = 0; t < e; t += 1)
          this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(t) {
        this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var dt = function() {
      var t = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(e) {
        return t[e] || "";
      };
    }(), gt = {
      1: "butt",
      2: "round",
      3: "square"
    }, te = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var At = function() {
      var t = Math.cos, e = Math.sin, i = Math.tan, r = Math.round;
      function o() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function s(w) {
        if (w === 0)
          return this;
        var x = t(w), V = e(w);
        return this._t(x, -V, 0, 0, V, x, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function m(w) {
        if (w === 0)
          return this;
        var x = t(w), V = e(w);
        return this._t(1, 0, 0, 0, 0, x, -V, 0, 0, V, x, 0, 0, 0, 0, 1);
      }
      function C(w) {
        if (w === 0)
          return this;
        var x = t(w), V = e(w);
        return this._t(x, 0, V, 0, 0, 1, 0, 0, -V, 0, x, 0, 0, 0, 0, 1);
      }
      function g(w) {
        if (w === 0)
          return this;
        var x = t(w), V = e(w);
        return this._t(x, -V, 0, 0, V, x, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function M(w, x) {
        return this._t(1, x, w, 1, 0, 0);
      }
      function T(w, x) {
        return this.shear(i(w), i(x));
      }
      function S(w, x) {
        var V = t(x), H = e(x);
        return this._t(V, H, 0, 0, -H, V, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i(w), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(V, -H, 0, 0, H, V, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function k(w, x, V) {
        return !V && V !== 0 && (V = 1), w === 1 && x === 1 && V === 1 ? this : this._t(w, 0, 0, 0, 0, x, 0, 0, 0, 0, V, 0, 0, 0, 0, 1);
      }
      function _(w, x, V, H, N, vt, ct, St, Vt, Nt, Wt, ie, he, $t, Bt, re) {
        return this.props[0] = w, this.props[1] = x, this.props[2] = V, this.props[3] = H, this.props[4] = N, this.props[5] = vt, this.props[6] = ct, this.props[7] = St, this.props[8] = Vt, this.props[9] = Nt, this.props[10] = Wt, this.props[11] = ie, this.props[12] = he, this.props[13] = $t, this.props[14] = Bt, this.props[15] = re, this;
      }
      function P(w, x, V) {
        return V = V || 0, w !== 0 || x !== 0 || V !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, w, x, V, 1) : this;
      }
      function E(w, x, V, H, N, vt, ct, St, Vt, Nt, Wt, ie, he, $t, Bt, re) {
        var J = this.props;
        if (w === 1 && x === 0 && V === 0 && H === 0 && N === 0 && vt === 1 && ct === 0 && St === 0 && Vt === 0 && Nt === 0 && Wt === 1 && ie === 0)
          return J[12] = J[12] * w + J[15] * he, J[13] = J[13] * vt + J[15] * $t, J[14] = J[14] * Wt + J[15] * Bt, J[15] *= re, this._identityCalculated = !1, this;
        var Tt = J[0], ke = J[1], we = J[2], xe = J[3], ye = J[4], Se = J[5], Ae = J[6], Zt = J[7], Pe = J[8], Ce = J[9], ue = J[10], Te = J[11], ce = J[12], Ne = J[13], di = J[14], vi = J[15];
        return J[0] = Tt * w + ke * N + we * Vt + xe * he, J[1] = Tt * x + ke * vt + we * Nt + xe * $t, J[2] = Tt * V + ke * ct + we * Wt + xe * Bt, J[3] = Tt * H + ke * St + we * ie + xe * re, J[4] = ye * w + Se * N + Ae * Vt + Zt * he, J[5] = ye * x + Se * vt + Ae * Nt + Zt * $t, J[6] = ye * V + Se * ct + Ae * Wt + Zt * Bt, J[7] = ye * H + Se * St + Ae * ie + Zt * re, J[8] = Pe * w + Ce * N + ue * Vt + Te * he, J[9] = Pe * x + Ce * vt + ue * Nt + Te * $t, J[10] = Pe * V + Ce * ct + ue * Wt + Te * Bt, J[11] = Pe * H + Ce * St + ue * ie + Te * re, J[12] = ce * w + Ne * N + di * Vt + vi * he, J[13] = ce * x + Ne * vt + di * Nt + vi * $t, J[14] = ce * V + Ne * ct + di * Wt + vi * Bt, J[15] = ce * H + Ne * St + di * ie + vi * re, this._identityCalculated = !1, this;
      }
      function p() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function f(w) {
        for (var x = 0; x < 16; ) {
          if (w.props[x] !== this.props[x])
            return !1;
          x += 1;
        }
        return !0;
      }
      function h(w) {
        var x;
        for (x = 0; x < 16; x += 1)
          w.props[x] = this.props[x];
        return w;
      }
      function a(w) {
        var x;
        for (x = 0; x < 16; x += 1)
          this.props[x] = w[x];
      }
      function n(w, x, V) {
        return {
          x: w * this.props[0] + x * this.props[4] + V * this.props[8] + this.props[12],
          y: w * this.props[1] + x * this.props[5] + V * this.props[9] + this.props[13],
          z: w * this.props[2] + x * this.props[6] + V * this.props[10] + this.props[14]
        };
      }
      function u(w, x, V) {
        return w * this.props[0] + x * this.props[4] + V * this.props[8] + this.props[12];
      }
      function v(w, x, V) {
        return w * this.props[1] + x * this.props[5] + V * this.props[9] + this.props[13];
      }
      function d(w, x, V) {
        return w * this.props[2] + x * this.props[6] + V * this.props[10] + this.props[14];
      }
      function b() {
        var w = this.props[0] * this.props[5] - this.props[1] * this.props[4], x = this.props[5] / w, V = -this.props[1] / w, H = -this.props[4] / w, N = this.props[0] / w, vt = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / w, ct = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / w, St = new At();
        return St.props[0] = x, St.props[1] = V, St.props[4] = H, St.props[5] = N, St.props[12] = vt, St.props[13] = ct, St;
      }
      function B(w) {
        var x = this.getInverseMatrix();
        return x.applyToPointArray(w[0], w[1], w[2] || 0);
      }
      function $(w) {
        var x, V = w.length, H = [];
        for (x = 0; x < V; x += 1)
          H[x] = B(w[x]);
        return H;
      }
      function X(w, x, V) {
        var H = et("float32", 6);
        if (this.isIdentity())
          H[0] = w[0], H[1] = w[1], H[2] = x[0], H[3] = x[1], H[4] = V[0], H[5] = V[1];
        else {
          var N = this.props[0], vt = this.props[1], ct = this.props[4], St = this.props[5], Vt = this.props[12], Nt = this.props[13];
          H[0] = w[0] * N + w[1] * ct + Vt, H[1] = w[0] * vt + w[1] * St + Nt, H[2] = x[0] * N + x[1] * ct + Vt, H[3] = x[0] * vt + x[1] * St + Nt, H[4] = V[0] * N + V[1] * ct + Vt, H[5] = V[0] * vt + V[1] * St + Nt;
        }
        return H;
      }
      function q(w, x, V) {
        var H;
        return this.isIdentity() ? H = [w, x, V] : H = [
          w * this.props[0] + x * this.props[4] + V * this.props[8] + this.props[12],
          w * this.props[1] + x * this.props[5] + V * this.props[9] + this.props[13],
          w * this.props[2] + x * this.props[6] + V * this.props[10] + this.props[14]
        ], H;
      }
      function K(w, x) {
        if (this.isIdentity())
          return w + "," + x;
        var V = this.props;
        return Math.round((w * V[0] + x * V[4] + V[12]) * 100) / 100 + "," + Math.round((w * V[1] + x * V[5] + V[13]) * 100) / 100;
      }
      function U() {
        for (var w = 0, x = this.props, V = "matrix3d(", H = 1e4; w < 16; )
          V += r(x[w] * H) / H, V += w === 15 ? ")" : ",", w += 1;
        return V;
      }
      function Z(w) {
        var x = 1e4;
        return w < 1e-6 && w > 0 || w > -1e-6 && w < 0 ? r(w * x) / x : w;
      }
      function I() {
        var w = this.props, x = Z(w[0]), V = Z(w[1]), H = Z(w[4]), N = Z(w[5]), vt = Z(w[12]), ct = Z(w[13]);
        return "matrix(" + x + "," + V + "," + H + "," + N + "," + vt + "," + ct + ")";
      }
      return function() {
        this.reset = o, this.rotate = s, this.rotateX = m, this.rotateY = C, this.rotateZ = g, this.skew = T, this.skewFromAxis = S, this.shear = M, this.scale = k, this.setTransform = _, this.translate = P, this.transform = E, this.applyToPoint = n, this.applyToX = u, this.applyToY = v, this.applyToZ = d, this.applyToPointArray = q, this.applyToTriplePoints = X, this.applyToPointStringified = K, this.toCSS = U, this.to2dCSS = I, this.clone = h, this.cloneFromProps = a, this.equals = f, this.inversePoints = $, this.inversePoint = B, this.getInverseMatrix = b, this._t = this.transform, this.isIdentity = p, this._identity = !0, this._identityCalculated = !1, this.props = et("float32", 16), this.reset();
      };
    }();
    (function(t, e) {
      var i = this, r = 256, o = 6, s = 52, m = "random", C = e.pow(r, o), g = e.pow(2, s), M = g * 2, T = r - 1, S;
      function k(a, n, u) {
        var v = [];
        n = n === !0 ? { entropy: !0 } : n || {};
        var d = p(E(n.entropy ? [a, h(t)] : a === null ? f() : a, 3), v), b = new _(v), B = function() {
          for (var $ = b.g(o), X = C, q = 0; $ < g; )
            $ = ($ + q) * r, X *= r, q = b.g(1);
          for (; $ >= M; )
            $ /= 2, X /= 2, q >>>= 1;
          return ($ + q) / X;
        };
        return B.int32 = function() {
          return b.g(4) | 0;
        }, B.quick = function() {
          return b.g(4) / 4294967296;
        }, B.double = B, p(h(b.S), t), (n.pass || u || function($, X, q, K) {
          return K && (K.S && P(K, b), $.state = function() {
            return P(b, {});
          }), q ? (e[m] = $, X) : $;
        })(B, d, "global" in n ? n.global : this == e, n.state);
      }
      e["seed" + m] = k;
      function _(a) {
        var n, u = a.length, v = this, d = 0, b = v.i = v.j = 0, B = v.S = [];
        for (u || (a = [u++]); d < r; )
          B[d] = d++;
        for (d = 0; d < r; d++)
          B[d] = B[b = T & b + a[d % u] + (n = B[d])], B[b] = n;
        v.g = function($) {
          for (var X, q = 0, K = v.i, U = v.j, Z = v.S; $--; )
            X = Z[K = T & K + 1], q = q * r + Z[T & (Z[K] = Z[U = T & U + X]) + (Z[U] = X)];
          return v.i = K, v.j = U, q;
        };
      }
      function P(a, n) {
        return n.i = a.i, n.j = a.j, n.S = a.S.slice(), n;
      }
      function E(a, n) {
        var u = [], v = typeof a, d;
        if (n && v == "object")
          for (d in a)
            try {
              u.push(E(a[d], n - 1));
            } catch {
            }
        return u.length ? u : v == "string" ? a : a + "\0";
      }
      function p(a, n) {
        for (var u = a + "", v, d = 0; d < u.length; )
          n[T & d] = T & (v ^= n[T & d] * 19) + u.charCodeAt(d++);
        return h(n);
      }
      function f() {
        try {
          var a = new Uint8Array(r);
          return (i.crypto || i.msCrypto).getRandomValues(a), h(a);
        } catch {
          var n = i.navigator, u = n && n.plugins;
          return [+new Date(), i, u, i.screen, h(t)];
        }
      }
      function h(a) {
        return String.fromCharCode.apply(0, a);
      }
      p(e.random(), t);
    })([], mt);
    var ae = function() {
      var t = {};
      t.getBezierEasing = i;
      var e = {};
      function i(h, a, n, u, v) {
        var d = v || ("bez_" + h + "_" + a + "_" + n + "_" + u).replace(/\./g, "p");
        if (e[d])
          return e[d];
        var b = new f([h, a, n, u]);
        return e[d] = b, b;
      }
      var r = 4, o = 1e-3, s = 1e-7, m = 10, C = 11, g = 1 / (C - 1), M = typeof Float32Array == "function";
      function T(h, a) {
        return 1 - 3 * a + 3 * h;
      }
      function S(h, a) {
        return 3 * a - 6 * h;
      }
      function k(h) {
        return 3 * h;
      }
      function _(h, a, n) {
        return ((T(a, n) * h + S(a, n)) * h + k(a)) * h;
      }
      function P(h, a, n) {
        return 3 * T(a, n) * h * h + 2 * S(a, n) * h + k(a);
      }
      function E(h, a, n, u, v) {
        var d, b, B = 0;
        do
          b = a + (n - a) / 2, d = _(b, u, v) - h, d > 0 ? n = b : a = b;
        while (Math.abs(d) > s && ++B < m);
        return b;
      }
      function p(h, a, n, u) {
        for (var v = 0; v < r; ++v) {
          var d = P(a, n, u);
          if (d === 0)
            return a;
          var b = _(a, n, u) - h;
          a -= b / d;
        }
        return a;
      }
      function f(h) {
        this._p = h, this._mSampleValues = M ? new Float32Array(C) : new Array(C), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return f.prototype = {
        get: function(h) {
          var a = this._p[0], n = this._p[1], u = this._p[2], v = this._p[3];
          return this._precomputed || this._precompute(), a === n && u === v ? h : h === 0 ? 0 : h === 1 ? 1 : _(this._getTForX(h), n, v);
        },
        _precompute: function() {
          var h = this._p[0], a = this._p[1], n = this._p[2], u = this._p[3];
          this._precomputed = !0, (h !== a || n !== u) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var h = this._p[0], a = this._p[2], n = 0; n < C; ++n)
            this._mSampleValues[n] = _(n * g, h, a);
        },
        _getTForX: function(h) {
          for (var a = this._p[0], n = this._p[2], u = this._mSampleValues, v = 0, d = 1, b = C - 1; d !== b && u[d] <= h; ++d)
            v += g;
          --d;
          var B = (h - u[d]) / (u[d + 1] - u[d]), $ = v + B * g, X = P($, a, n);
          return X >= o ? p(h, $, a, n) : X === 0 ? $ : E(h, v, v + g, a, n);
        }
      }, t;
    }();
    (function() {
      for (var t = 0, e = ["ms", "moz", "webkit", "o"], i = 0; i < e.length && !c.requestAnimationFrame; ++i)
        c.requestAnimationFrame = c[e[i] + "RequestAnimationFrame"], c.cancelAnimationFrame = c[e[i] + "CancelAnimationFrame"] || c[e[i] + "CancelRequestAnimationFrame"];
      c.requestAnimationFrame || (c.requestAnimationFrame = function(r) {
        var o = new Date().getTime(), s = Math.max(0, 16 - (o - t)), m = setTimeout(function() {
          r(o + s);
        }, s);
        return t = o + s, m;
      }), c.cancelAnimationFrame || (c.cancelAnimationFrame = function(r) {
        clearTimeout(r);
      });
    })();
    function _t(t, e) {
      var i, r = t.length, o;
      for (i = 0; i < r; i += 1) {
        o = t[i].prototype;
        for (var s in o)
          Object.prototype.hasOwnProperty.call(o, s) && (e.prototype[s] = o[s]);
      }
    }
    function Bi(t) {
      function e() {
      }
      return e.prototype = t, e;
    }
    function Di() {
      var t = Math;
      function e(k, _, P, E, p, f) {
        var h = k * E + _ * p + P * f - p * E - f * k - P * _;
        return h > -1e-3 && h < 1e-3;
      }
      function i(k, _, P, E, p, f, h, a, n) {
        if (P === 0 && f === 0 && n === 0)
          return e(k, _, E, p, h, a);
        var u = t.sqrt(t.pow(E - k, 2) + t.pow(p - _, 2) + t.pow(f - P, 2)), v = t.sqrt(t.pow(h - k, 2) + t.pow(a - _, 2) + t.pow(n - P, 2)), d = t.sqrt(t.pow(h - E, 2) + t.pow(a - p, 2) + t.pow(n - f, 2)), b;
        return u > v ? u > d ? b = u - v - d : b = d - v - u : d > v ? b = d - v - u : b = v - u - d, b > -1e-4 && b < 1e-4;
      }
      var r = function() {
        return function(k, _, P, E) {
          var p = nt, f, h, a, n, u, v = 0, d, b = [], B = [], $ = ur.newElement();
          for (a = P.length, f = 0; f < p; f += 1) {
            for (u = f / (p - 1), d = 0, h = 0; h < a; h += 1)
              n = j(1 - u, 3) * k[h] + 3 * j(1 - u, 2) * u * P[h] + 3 * (1 - u) * j(u, 2) * E[h] + j(u, 3) * _[h], b[h] = n, B[h] !== null && (d += j(b[h] - B[h], 2)), B[h] = b[h];
            d && (d = Y(d), v += d), $.percents[f] = u, $.lengths[f] = v;
          }
          return $.addedLength = v, $;
        };
      }();
      function o(k) {
        var _ = fr.newElement(), P = k.c, E = k.v, p = k.o, f = k.i, h, a = k._length, n = _.lengths, u = 0;
        for (h = 0; h < a - 1; h += 1)
          n[h] = r(E[h], E[h + 1], p[h], f[h + 1]), u += n[h].addedLength;
        return P && a && (n[h] = r(E[h], E[0], p[h], f[0]), u += n[h].addedLength), _.totalLength = u, _;
      }
      function s(k) {
        this.segmentLength = 0, this.points = new Array(k);
      }
      function m(k, _) {
        this.partialLength = k, this.point = _;
      }
      var C = function() {
        var k = {};
        return function(_, P, E, p) {
          var f = (_[0] + "_" + _[1] + "_" + P[0] + "_" + P[1] + "_" + E[0] + "_" + E[1] + "_" + p[0] + "_" + p[1]).replace(/\./g, "p");
          if (!k[f]) {
            var h = nt, a, n, u, v, d, b = 0, B, $, X = null;
            _.length === 2 && (_[0] !== P[0] || _[1] !== P[1]) && e(_[0], _[1], P[0], P[1], _[0] + E[0], _[1] + E[1]) && e(_[0], _[1], P[0], P[1], P[0] + p[0], P[1] + p[1]) && (h = 2);
            var q = new s(h);
            for (u = E.length, a = 0; a < h; a += 1) {
              for ($ = it(u), d = a / (h - 1), B = 0, n = 0; n < u; n += 1)
                v = j(1 - d, 3) * _[n] + 3 * j(1 - d, 2) * d * (_[n] + E[n]) + 3 * (1 - d) * j(d, 2) * (P[n] + p[n]) + j(d, 3) * P[n], $[n] = v, X !== null && (B += j($[n] - X[n], 2));
              B = Y(B), b += B, q.points[a] = new m(B, $), X = $;
            }
            q.segmentLength = b, k[f] = q;
          }
          return k[f];
        };
      }();
      function g(k, _) {
        var P = _.percents, E = _.lengths, p = P.length, f = rt((p - 1) * k), h = k * _.addedLength, a = 0;
        if (f === p - 1 || f === 0 || h === E[f])
          return P[f];
        for (var n = E[f] > h ? -1 : 1, u = !0; u; )
          if (E[f] <= h && E[f + 1] > h ? (a = (h - E[f]) / (E[f + 1] - E[f]), u = !1) : f += n, f < 0 || f >= p - 1) {
            if (f === p - 1)
              return P[f];
            u = !1;
          }
        return P[f] + (P[f + 1] - P[f]) * a;
      }
      function M(k, _, P, E, p, f) {
        var h = g(p, f), a = 1 - h, n = t.round((a * a * a * k[0] + (h * a * a + a * h * a + a * a * h) * P[0] + (h * h * a + a * h * h + h * a * h) * E[0] + h * h * h * _[0]) * 1e3) / 1e3, u = t.round((a * a * a * k[1] + (h * a * a + a * h * a + a * a * h) * P[1] + (h * h * a + a * h * h + h * a * h) * E[1] + h * h * h * _[1]) * 1e3) / 1e3;
        return [n, u];
      }
      var T = et("float32", 8);
      function S(k, _, P, E, p, f, h) {
        p < 0 ? p = 0 : p > 1 && (p = 1);
        var a = g(p, h);
        f = f > 1 ? 1 : f;
        var n = g(f, h), u, v = k.length, d = 1 - a, b = 1 - n, B = d * d * d, $ = a * d * d * 3, X = a * a * d * 3, q = a * a * a, K = d * d * b, U = a * d * b + d * a * b + d * d * n, Z = a * a * b + d * a * n + a * d * n, I = a * a * n, w = d * b * b, x = a * b * b + d * n * b + d * b * n, V = a * n * b + d * n * n + a * b * n, H = a * n * n, N = b * b * b, vt = n * b * b + b * n * b + b * b * n, ct = n * n * b + b * n * n + n * b * n, St = n * n * n;
        for (u = 0; u < v; u += 1)
          T[u * 4] = t.round((B * k[u] + $ * P[u] + X * E[u] + q * _[u]) * 1e3) / 1e3, T[u * 4 + 1] = t.round((K * k[u] + U * P[u] + Z * E[u] + I * _[u]) * 1e3) / 1e3, T[u * 4 + 2] = t.round((w * k[u] + x * P[u] + V * E[u] + H * _[u]) * 1e3) / 1e3, T[u * 4 + 3] = t.round((N * k[u] + vt * P[u] + ct * E[u] + St * _[u]) * 1e3) / 1e3;
        return T;
      }
      return {
        getSegmentsLength: o,
        getNewSegment: S,
        getPointInSegment: M,
        buildBezierData: C,
        pointOnLine2D: e,
        pointOnLine3D: i
      };
    }
    var oe = Di();
    function ji() {
      function t(_, P, E) {
        var p, f, h = _.length, a, n, u, v;
        for (f = 0; f < h; f += 1)
          if (p = _[f], "ks" in p && !p.completed) {
            if (p.completed = !0, p.tt && (_[f - 1].td = p.tt), p.hasMask) {
              var d = p.masksProperties;
              for (n = d.length, a = 0; a < n; a += 1)
                if (d[a].pt.k.i)
                  r(d[a].pt.k);
                else
                  for (v = d[a].pt.k.length, u = 0; u < v; u += 1)
                    d[a].pt.k[u].s && r(d[a].pt.k[u].s[0]), d[a].pt.k[u].e && r(d[a].pt.k[u].e[0]);
            }
            p.ty === 0 ? (p.layers = e(p.refId, P), t(p.layers, P)) : p.ty === 4 ? i(p.shapes) : p.ty === 5 && S(p);
          }
      }
      function e(_, P) {
        for (var E = 0, p = P.length; E < p; ) {
          if (P[E].id === _)
            return P[E].layers.__used ? JSON.parse(JSON.stringify(P[E].layers)) : (P[E].layers.__used = !0, P[E].layers);
          E += 1;
        }
        return null;
      }
      function i(_) {
        var P, E = _.length, p, f;
        for (P = E - 1; P >= 0; P -= 1)
          if (_[P].ty === "sh")
            if (_[P].ks.k.i)
              r(_[P].ks.k);
            else
              for (f = _[P].ks.k.length, p = 0; p < f; p += 1)
                _[P].ks.k[p].s && r(_[P].ks.k[p].s[0]), _[P].ks.k[p].e && r(_[P].ks.k[p].e[0]);
          else
            _[P].ty === "gr" && i(_[P].it);
      }
      function r(_) {
        var P, E = _.i.length;
        for (P = 0; P < E; P += 1)
          _.i[P][0] += _.v[P][0], _.i[P][1] += _.v[P][1], _.o[P][0] += _.v[P][0], _.o[P][1] += _.v[P][1];
      }
      function o(_, P) {
        var E = P ? P.split(".") : [100, 100, 100];
        return _[0] > E[0] ? !0 : E[0] > _[0] ? !1 : _[1] > E[1] ? !0 : E[1] > _[1] ? !1 : _[2] > E[2] ? !0 : E[2] > _[2] ? !1 : null;
      }
      var s = function() {
        var _ = [4, 4, 14];
        function P(p) {
          var f = p.t.d;
          p.t.d = {
            k: [
              {
                s: f,
                t: 0
              }
            ]
          };
        }
        function E(p) {
          var f, h = p.length;
          for (f = 0; f < h; f += 1)
            p[f].ty === 5 && P(p[f]);
        }
        return function(p) {
          if (o(_, p.v) && (E(p.layers), p.assets)) {
            var f, h = p.assets.length;
            for (f = 0; f < h; f += 1)
              p.assets[f].layers && E(p.assets[f].layers);
          }
        };
      }(), m = function() {
        var _ = [4, 7, 99];
        return function(P) {
          if (P.chars && !o(_, P.v)) {
            var E, p = P.chars.length, f, h, a, n;
            for (E = 0; E < p; E += 1)
              if (P.chars[E].data && P.chars[E].data.shapes)
                for (n = P.chars[E].data.shapes[0].it, h = n.length, f = 0; f < h; f += 1)
                  a = n[f].ks.k, a.__converted || (r(n[f].ks.k), a.__converted = !0);
          }
        };
      }(), C = function() {
        var _ = [5, 7, 15];
        function P(p) {
          var f = p.t.p;
          typeof f.a == "number" && (f.a = {
            a: 0,
            k: f.a
          }), typeof f.p == "number" && (f.p = {
            a: 0,
            k: f.p
          }), typeof f.r == "number" && (f.r = {
            a: 0,
            k: f.r
          });
        }
        function E(p) {
          var f, h = p.length;
          for (f = 0; f < h; f += 1)
            p[f].ty === 5 && P(p[f]);
        }
        return function(p) {
          if (o(_, p.v) && (E(p.layers), p.assets)) {
            var f, h = p.assets.length;
            for (f = 0; f < h; f += 1)
              p.assets[f].layers && E(p.assets[f].layers);
          }
        };
      }(), g = function() {
        var _ = [4, 1, 9];
        function P(p) {
          var f, h = p.length, a, n;
          for (f = 0; f < h; f += 1)
            if (p[f].ty === "gr")
              P(p[f].it);
            else if (p[f].ty === "fl" || p[f].ty === "st")
              if (p[f].c.k && p[f].c.k[0].i)
                for (n = p[f].c.k.length, a = 0; a < n; a += 1)
                  p[f].c.k[a].s && (p[f].c.k[a].s[0] /= 255, p[f].c.k[a].s[1] /= 255, p[f].c.k[a].s[2] /= 255, p[f].c.k[a].s[3] /= 255), p[f].c.k[a].e && (p[f].c.k[a].e[0] /= 255, p[f].c.k[a].e[1] /= 255, p[f].c.k[a].e[2] /= 255, p[f].c.k[a].e[3] /= 255);
              else
                p[f].c.k[0] /= 255, p[f].c.k[1] /= 255, p[f].c.k[2] /= 255, p[f].c.k[3] /= 255;
        }
        function E(p) {
          var f, h = p.length;
          for (f = 0; f < h; f += 1)
            p[f].ty === 4 && P(p[f].shapes);
        }
        return function(p) {
          if (o(_, p.v) && (E(p.layers), p.assets)) {
            var f, h = p.assets.length;
            for (f = 0; f < h; f += 1)
              p.assets[f].layers && E(p.assets[f].layers);
          }
        };
      }(), M = function() {
        var _ = [4, 4, 18];
        function P(p) {
          var f, h = p.length, a, n;
          for (f = h - 1; f >= 0; f -= 1)
            if (p[f].ty === "sh")
              if (p[f].ks.k.i)
                p[f].ks.k.c = p[f].closed;
              else
                for (n = p[f].ks.k.length, a = 0; a < n; a += 1)
                  p[f].ks.k[a].s && (p[f].ks.k[a].s[0].c = p[f].closed), p[f].ks.k[a].e && (p[f].ks.k[a].e[0].c = p[f].closed);
            else
              p[f].ty === "gr" && P(p[f].it);
        }
        function E(p) {
          var f, h, a = p.length, n, u, v, d;
          for (h = 0; h < a; h += 1) {
            if (f = p[h], f.hasMask) {
              var b = f.masksProperties;
              for (u = b.length, n = 0; n < u; n += 1)
                if (b[n].pt.k.i)
                  b[n].pt.k.c = b[n].cl;
                else
                  for (d = b[n].pt.k.length, v = 0; v < d; v += 1)
                    b[n].pt.k[v].s && (b[n].pt.k[v].s[0].c = b[n].cl), b[n].pt.k[v].e && (b[n].pt.k[v].e[0].c = b[n].cl);
            }
            f.ty === 4 && P(f.shapes);
          }
        }
        return function(p) {
          if (o(_, p.v) && (E(p.layers), p.assets)) {
            var f, h = p.assets.length;
            for (f = 0; f < h; f += 1)
              p.assets[f].layers && E(p.assets[f].layers);
          }
        };
      }();
      function T(_, P) {
        _.__complete || (g(_), s(_), m(_), C(_), M(_), t(_.layers, _.assets), _.__complete = !0);
      }
      function S(_) {
        _.t.a.length === 0 && !("m" in _.t.p) && (_.singleShape = !0);
      }
      var k = {};
      return k.completeData = T, k.checkColors = g, k.checkChars = m, k.checkPathProperties = C, k.checkShapes = M, k.completeLayers = t, k;
    }
    var li = ji();
    function fi(t) {
      for (var e = t.fStyle ? t.fStyle.split(" ") : [], i = "normal", r = "normal", o = e.length, s, m = 0; m < o; m += 1)
        switch (s = e[m].toLowerCase(), s) {
          case "italic":
            r = "italic";
            break;
          case "bold":
            i = "700";
            break;
          case "black":
            i = "900";
            break;
          case "medium":
            i = "500";
            break;
          case "regular":
          case "normal":
            i = "400";
            break;
          case "light":
          case "thin":
            i = "200";
            break;
        }
      return {
        style: r,
        weight: t.fWeight || i
      };
    }
    var Fe = function() {
      var t = 5e3, e = {
        w: 0,
        size: 0,
        shapes: []
      }, i = [];
      i = i.concat([
        2304,
        2305,
        2306,
        2307,
        2362,
        2363,
        2364,
        2364,
        2366,
        2367,
        2368,
        2369,
        2370,
        2371,
        2372,
        2373,
        2374,
        2375,
        2376,
        2377,
        2378,
        2379,
        2380,
        2381,
        2382,
        2383,
        2387,
        2388,
        2389,
        2390,
        2391,
        2402,
        2403
      ]);
      var r = [
        "d83cdffb",
        "d83cdffc",
        "d83cdffd",
        "d83cdffe",
        "d83cdfff"
      ], o = [65039, 8205];
      function s(n) {
        var u = n.split(","), v, d = u.length, b = [];
        for (v = 0; v < d; v += 1)
          u[v] !== "sans-serif" && u[v] !== "monospace" && b.push(u[v]);
        return b.join(",");
      }
      function m(n, u) {
        var v = at("span");
        v.setAttribute("aria-hidden", !0), v.style.fontFamily = u;
        var d = at("span");
        d.innerText = "giItT1WQy@!-/#", v.style.position = "absolute", v.style.left = "-10000px", v.style.top = "-10000px", v.style.fontSize = "300px", v.style.fontVariant = "normal", v.style.fontStyle = "normal", v.style.fontWeight = "normal", v.style.letterSpacing = "0", v.appendChild(d), document.body.appendChild(v);
        var b = d.offsetWidth;
        return d.style.fontFamily = s(n) + ", " + u, { node: d, w: b, parent: v };
      }
      function C() {
        var n, u = this.fonts.length, v, d, b = u;
        for (n = 0; n < u; n += 1)
          this.fonts[n].loaded ? b -= 1 : this.fonts[n].fOrigin === "n" || this.fonts[n].origin === 0 ? this.fonts[n].loaded = !0 : (v = this.fonts[n].monoCase.node, d = this.fonts[n].monoCase.w, v.offsetWidth !== d ? (b -= 1, this.fonts[n].loaded = !0) : (v = this.fonts[n].sansCase.node, d = this.fonts[n].sansCase.w, v.offsetWidth !== d && (b -= 1, this.fonts[n].loaded = !0)), this.fonts[n].loaded && (this.fonts[n].sansCase.parent.parentNode.removeChild(this.fonts[n].sansCase.parent), this.fonts[n].monoCase.parent.parentNode.removeChild(this.fonts[n].monoCase.parent)));
        b !== 0 && Date.now() - this.initTime < t ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function g(n, u) {
        var v = W("text");
        v.style.fontSize = "100px";
        var d = fi(u);
        v.setAttribute("font-family", u.fFamily), v.setAttribute("font-style", d.style), v.setAttribute("font-weight", d.weight), v.textContent = "1", u.fClass ? (v.style.fontFamily = "inherit", v.setAttribute("class", u.fClass)) : v.style.fontFamily = u.fFamily, n.appendChild(v);
        var b = at("canvas").getContext("2d");
        return b.font = u.fWeight + " " + u.fStyle + " 100px " + u.fFamily, v;
      }
      function M(n, u) {
        if (!n) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = n.list;
          return;
        }
        var v = n.list, d, b = v.length, B = b;
        for (d = 0; d < b; d += 1) {
          var $ = !0, X, q;
          if (v[d].loaded = !1, v[d].monoCase = m(v[d].fFamily, "monospace"), v[d].sansCase = m(v[d].fFamily, "sans-serif"), !v[d].fPath)
            v[d].loaded = !0, B -= 1;
          else if (v[d].fOrigin === "p" || v[d].origin === 3) {
            if (X = document.querySelectorAll('style[f-forigin="p"][f-family="' + v[d].fFamily + '"], style[f-origin="3"][f-family="' + v[d].fFamily + '"]'), X.length > 0 && ($ = !1), $) {
              var K = at("style");
              K.setAttribute("f-forigin", v[d].fOrigin), K.setAttribute("f-origin", v[d].origin), K.setAttribute("f-family", v[d].fFamily), K.type = "text/css", K.innerText = "@font-face {font-family: " + v[d].fFamily + "; font-style: normal; src: url('" + v[d].fPath + "');}", u.appendChild(K);
            }
          } else if (v[d].fOrigin === "g" || v[d].origin === 1) {
            for (X = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), q = 0; q < X.length; q += 1)
              X[q].href.indexOf(v[d].fPath) !== -1 && ($ = !1);
            if ($) {
              var U = at("link");
              U.setAttribute("f-forigin", v[d].fOrigin), U.setAttribute("f-origin", v[d].origin), U.type = "text/css", U.rel = "stylesheet", U.href = v[d].fPath, document.body.appendChild(U);
            }
          } else if (v[d].fOrigin === "t" || v[d].origin === 2) {
            for (X = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), q = 0; q < X.length; q += 1)
              v[d].fPath === X[q].src && ($ = !1);
            if ($) {
              var Z = at("link");
              Z.setAttribute("f-forigin", v[d].fOrigin), Z.setAttribute("f-origin", v[d].origin), Z.setAttribute("rel", "stylesheet"), Z.setAttribute("href", v[d].fPath), u.appendChild(Z);
            }
          }
          v[d].helper = g(u, v[d]), v[d].cache = {}, this.fonts.push(v[d]);
        }
        B === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function T(n) {
        if (!!n) {
          this.chars || (this.chars = []);
          var u, v = n.length, d, b = this.chars.length, B;
          for (u = 0; u < v; u += 1) {
            for (d = 0, B = !1; d < b; )
              this.chars[d].style === n[u].style && this.chars[d].fFamily === n[u].fFamily && this.chars[d].ch === n[u].ch && (B = !0), d += 1;
            B || (this.chars.push(n[u]), b += 1);
          }
        }
      }
      function S(n, u, v) {
        for (var d = 0, b = this.chars.length; d < b; ) {
          if (this.chars[d].ch === n && this.chars[d].style === u && this.chars[d].fFamily === v)
            return this.chars[d];
          d += 1;
        }
        return (typeof n == "string" && n.charCodeAt(0) !== 13 || !n) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", n, u, v)), e;
      }
      function k(n, u, v) {
        var d = this.getFontByName(u), b = n.charCodeAt(0);
        if (!d.cache[b + 1]) {
          var B = d.helper;
          if (n === " ") {
            B.textContent = "|" + n + "|";
            var $ = B.getComputedTextLength();
            B.textContent = "||";
            var X = B.getComputedTextLength();
            d.cache[b + 1] = ($ - X) / 100;
          } else
            B.textContent = n, d.cache[b + 1] = B.getComputedTextLength() / 100;
        }
        return d.cache[b + 1] * v;
      }
      function _(n) {
        for (var u = 0, v = this.fonts.length; u < v; ) {
          if (this.fonts[u].fName === n)
            return this.fonts[u];
          u += 1;
        }
        return this.fonts[0];
      }
      function P(n, u) {
        var v = n.toString(16) + u.toString(16);
        return r.indexOf(v) !== -1;
      }
      function E(n, u) {
        return u ? n === o[0] && u === o[1] : n === o[1];
      }
      function p(n) {
        return i.indexOf(n) !== -1;
      }
      function f() {
        this.isLoaded = !0;
      }
      var h = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      h.isModifier = P, h.isZeroWidthJoiner = E, h.isCombinedCharacter = p;
      var a = {
        addChars: T,
        addFonts: M,
        getCharData: S,
        getFontByName: _,
        measureText: k,
        checkLoadedFonts: C,
        setIsLoaded: f
      };
      return h.prototype = a, h;
    }(), D = function() {
      var t = F, e = Math.abs;
      function i(p, f) {
        var h = this.offsetTime, a;
        this.propType === "multidimensional" && (a = et("float32", this.pv.length));
        for (var n = f.lastIndex, u = n, v = this.keyframes.length - 1, d = !0, b, B; d; ) {
          if (b = this.keyframes[u], B = this.keyframes[u + 1], u === v - 1 && p >= B.t - h) {
            b.h && (b = B), n = 0;
            break;
          }
          if (B.t - h > p) {
            n = u;
            break;
          }
          u < v - 1 ? u += 1 : (n = 0, d = !1);
        }
        var $, X, q, K, U, Z, I = B.t - h, w = b.t - h, x;
        if (b.to) {
          b.bezierData || (b.bezierData = oe.buildBezierData(b.s, B.s || b.e, b.to, b.ti));
          var V = b.bezierData;
          if (p >= I || p < w) {
            var H = p >= I ? V.points.length - 1 : 0;
            for (X = V.points[H].point.length, $ = 0; $ < X; $ += 1)
              a[$] = V.points[H].point[$];
          } else {
            b.__fnct ? Z = b.__fnct : (Z = ae.getBezierEasing(b.o.x, b.o.y, b.i.x, b.i.y, b.n).get, b.__fnct = Z), q = Z((p - w) / (I - w));
            var N = V.segmentLength * q, vt, ct = f.lastFrame < p && f._lastKeyframeIndex === u ? f._lastAddedLength : 0;
            for (U = f.lastFrame < p && f._lastKeyframeIndex === u ? f._lastPoint : 0, d = !0, K = V.points.length; d; ) {
              if (ct += V.points[U].partialLength, N === 0 || q === 0 || U === V.points.length - 1) {
                for (X = V.points[U].point.length, $ = 0; $ < X; $ += 1)
                  a[$] = V.points[U].point[$];
                break;
              } else if (N >= ct && N < ct + V.points[U + 1].partialLength) {
                for (vt = (N - ct) / V.points[U + 1].partialLength, X = V.points[U].point.length, $ = 0; $ < X; $ += 1)
                  a[$] = V.points[U].point[$] + (V.points[U + 1].point[$] - V.points[U].point[$]) * vt;
                break;
              }
              U < K - 1 ? U += 1 : d = !1;
            }
            f._lastPoint = U, f._lastAddedLength = ct - V.points[U].partialLength, f._lastKeyframeIndex = u;
          }
        } else {
          var St, Vt, Nt, Wt, ie;
          if (v = b.s.length, x = B.s || b.e, this.sh && b.h !== 1)
            if (p >= I)
              a[0] = x[0], a[1] = x[1], a[2] = x[2];
            else if (p <= w)
              a[0] = b.s[0], a[1] = b.s[1], a[2] = b.s[2];
            else {
              var he = s(b.s), $t = s(x), Bt = (p - w) / (I - w);
              o(a, r(he, $t, Bt));
            }
          else
            for (u = 0; u < v; u += 1)
              b.h !== 1 && (p >= I ? q = 1 : p < w ? q = 0 : (b.o.x.constructor === Array ? (b.__fnct || (b.__fnct = []), b.__fnct[u] ? Z = b.__fnct[u] : (St = typeof b.o.x[u] > "u" ? b.o.x[0] : b.o.x[u], Vt = typeof b.o.y[u] > "u" ? b.o.y[0] : b.o.y[u], Nt = typeof b.i.x[u] > "u" ? b.i.x[0] : b.i.x[u], Wt = typeof b.i.y[u] > "u" ? b.i.y[0] : b.i.y[u], Z = ae.getBezierEasing(St, Vt, Nt, Wt).get, b.__fnct[u] = Z)) : b.__fnct ? Z = b.__fnct : (St = b.o.x, Vt = b.o.y, Nt = b.i.x, Wt = b.i.y, Z = ae.getBezierEasing(St, Vt, Nt, Wt).get, b.__fnct = Z), q = Z((p - w) / (I - w)))), x = B.s || b.e, ie = b.h === 1 ? b.s[u] : b.s[u] + (x[u] - b.s[u]) * q, this.propType === "multidimensional" ? a[u] = ie : a = ie;
        }
        return f.lastIndex = n, a;
      }
      function r(p, f, h) {
        var a = [], n = p[0], u = p[1], v = p[2], d = p[3], b = f[0], B = f[1], $ = f[2], X = f[3], q, K, U, Z, I;
        return K = n * b + u * B + v * $ + d * X, K < 0 && (K = -K, b = -b, B = -B, $ = -$, X = -X), 1 - K > 1e-6 ? (q = Math.acos(K), U = Math.sin(q), Z = Math.sin((1 - h) * q) / U, I = Math.sin(h * q) / U) : (Z = 1 - h, I = h), a[0] = Z * n + I * b, a[1] = Z * u + I * B, a[2] = Z * v + I * $, a[3] = Z * d + I * X, a;
      }
      function o(p, f) {
        var h = f[0], a = f[1], n = f[2], u = f[3], v = Math.atan2(2 * a * u - 2 * h * n, 1 - 2 * a * a - 2 * n * n), d = Math.asin(2 * h * a + 2 * n * u), b = Math.atan2(2 * h * u - 2 * a * n, 1 - 2 * h * h - 2 * n * n);
        p[0] = v / ht, p[1] = d / ht, p[2] = b / ht;
      }
      function s(p) {
        var f = p[0] * ht, h = p[1] * ht, a = p[2] * ht, n = Math.cos(f / 2), u = Math.cos(h / 2), v = Math.cos(a / 2), d = Math.sin(f / 2), b = Math.sin(h / 2), B = Math.sin(a / 2), $ = n * u * v - d * b * B, X = d * b * v + n * u * B, q = d * u * v + n * b * B, K = n * b * v - d * u * B;
        return [X, q, K, $];
      }
      function m() {
        var p = this.comp.renderedFrame - this.offsetTime, f = this.keyframes[0].t - this.offsetTime, h = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(p === this._caching.lastFrame || this._caching.lastFrame !== t && (this._caching.lastFrame >= h && p >= h || this._caching.lastFrame < f && p < f))) {
          this._caching.lastFrame >= p && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
          var a = this.interpolateValue(p, this._caching);
          this.pv = a;
        }
        return this._caching.lastFrame = p, this.pv;
      }
      function C(p) {
        var f;
        if (this.propType === "unidimensional")
          f = p * this.mult, e(this.v - f) > 1e-5 && (this.v = f, this._mdf = !0);
        else
          for (var h = 0, a = this.v.length; h < a; )
            f = p[h] * this.mult, e(this.v[h] - f) > 1e-5 && (this.v[h] = f, this._mdf = !0), h += 1;
      }
      function g() {
        if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = this._isFirstFrame;
          var p, f = this.effectsSequence.length, h = this.kf ? this.pv : this.data.k;
          for (p = 0; p < f; p += 1)
            h = this.effectsSequence[p](h);
          this.setVValue(h), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function M(p) {
        this.effectsSequence.push(p), this.container.addDynamicProperty(this);
      }
      function T(p, f, h, a) {
        this.propType = "unidimensional", this.mult = h || 1, this.data = f, this.v = h ? f.k * h : f.k, this.pv = f.k, this._mdf = !1, this.elem = p, this.container = a, this.comp = p.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = g, this.setVValue = C, this.addEffect = M;
      }
      function S(p, f, h, a) {
        this.propType = "multidimensional", this.mult = h || 1, this.data = f, this._mdf = !1, this.elem = p, this.container = a, this.comp = p.comp, this.k = !1, this.kf = !1, this.frameId = -1;
        var n, u = f.k.length;
        for (this.v = et("float32", u), this.pv = et("float32", u), this.vel = et("float32", u), n = 0; n < u; n += 1)
          this.v[n] = f.k[n] * this.mult, this.pv[n] = f.k[n];
        this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = g, this.setVValue = C, this.addEffect = M;
      }
      function k(p, f, h, a) {
        this.propType = "unidimensional", this.keyframes = f.k, this.offsetTime = p.data.st, this.frameId = -1, this._caching = {
          lastFrame: t,
          lastIndex: 0,
          value: 0,
          _lastKeyframeIndex: -1
        }, this.k = !0, this.kf = !0, this.data = f, this.mult = h || 1, this.elem = p, this.container = a, this.comp = p.comp, this.v = t, this.pv = t, this._isFirstFrame = !0, this.getValue = g, this.setVValue = C, this.interpolateValue = i, this.effectsSequence = [m.bind(this)], this.addEffect = M;
      }
      function _(p, f, h, a) {
        this.propType = "multidimensional";
        var n, u = f.k.length, v, d, b, B;
        for (n = 0; n < u - 1; n += 1)
          f.k[n].to && f.k[n].s && f.k[n + 1] && f.k[n + 1].s && (v = f.k[n].s, d = f.k[n + 1].s, b = f.k[n].to, B = f.k[n].ti, (v.length === 2 && !(v[0] === d[0] && v[1] === d[1]) && oe.pointOnLine2D(v[0], v[1], d[0], d[1], v[0] + b[0], v[1] + b[1]) && oe.pointOnLine2D(v[0], v[1], d[0], d[1], d[0] + B[0], d[1] + B[1]) || v.length === 3 && !(v[0] === d[0] && v[1] === d[1] && v[2] === d[2]) && oe.pointOnLine3D(v[0], v[1], v[2], d[0], d[1], d[2], v[0] + b[0], v[1] + b[1], v[2] + b[2]) && oe.pointOnLine3D(v[0], v[1], v[2], d[0], d[1], d[2], d[0] + B[0], d[1] + B[1], d[2] + B[2])) && (f.k[n].to = null, f.k[n].ti = null), v[0] === d[0] && v[1] === d[1] && b[0] === 0 && b[1] === 0 && B[0] === 0 && B[1] === 0 && (v.length === 2 || v[2] === d[2] && b[2] === 0 && B[2] === 0) && (f.k[n].to = null, f.k[n].ti = null));
        this.effectsSequence = [m.bind(this)], this.data = f, this.keyframes = f.k, this.offsetTime = p.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = h || 1, this.elem = p, this.container = a, this.comp = p.comp, this.getValue = g, this.setVValue = C, this.interpolateValue = i, this.frameId = -1;
        var $ = f.k[0].s.length;
        for (this.v = et("float32", $), this.pv = et("float32", $), n = 0; n < $; n += 1)
          this.v[n] = t, this.pv[n] = t;
        this._caching = { lastFrame: t, lastIndex: 0, value: et("float32", $) }, this.addEffect = M;
      }
      function P(p, f, h, a, n) {
        var u;
        if (!f.k.length)
          u = new T(p, f, a, n);
        else if (typeof f.k[0] == "number")
          u = new S(p, f, a, n);
        else
          switch (h) {
            case 0:
              u = new k(p, f, a, n);
              break;
            case 1:
              u = new _(p, f, a, n);
              break;
          }
        return u.effectsSequence.length && n.addDynamicProperty(u), u;
      }
      var E = {
        getProp: P
      };
      return E;
    }(), Ie = function() {
      var t = [0, 0];
      function e(g) {
        var M = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || M, this.a && g.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && g.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && g.skewFromAxis(-this.sk.v, this.sa.v), this.r ? g.rotate(-this.r.v) : g.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? g.translate(this.px.v, this.py.v, -this.pz.v) : g.translate(this.px.v, this.py.v, 0) : g.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function i(g) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || g) {
            var M;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var T, S;
              if (M = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (T = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / M, 0), S = this.p.getValueAtTime(this.p.keyframes[0].t / M, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (T = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / M, 0), S = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / M, 0)) : (T = this.p.pv, S = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / M, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                T = [], S = [];
                var k = this.px, _ = this.py;
                k._caching.lastFrame + k.offsetTime <= k.keyframes[0].t ? (T[0] = k.getValueAtTime((k.keyframes[0].t + 0.01) / M, 0), T[1] = _.getValueAtTime((_.keyframes[0].t + 0.01) / M, 0), S[0] = k.getValueAtTime(k.keyframes[0].t / M, 0), S[1] = _.getValueAtTime(_.keyframes[0].t / M, 0)) : k._caching.lastFrame + k.offsetTime >= k.keyframes[k.keyframes.length - 1].t ? (T[0] = k.getValueAtTime(k.keyframes[k.keyframes.length - 1].t / M, 0), T[1] = _.getValueAtTime(_.keyframes[_.keyframes.length - 1].t / M, 0), S[0] = k.getValueAtTime((k.keyframes[k.keyframes.length - 1].t - 0.01) / M, 0), S[1] = _.getValueAtTime((_.keyframes[_.keyframes.length - 1].t - 0.01) / M, 0)) : (T = [k.pv, _.pv], S[0] = k.getValueAtTime((k._caching.lastFrame + k.offsetTime - 0.01) / M, k.offsetTime), S[1] = _.getValueAtTime((_._caching.lastFrame + _.offsetTime - 0.01) / M, _.offsetTime));
              } else
                S = t, T = S;
              this.v.rotate(-Math.atan2(T[1] - S[1], T[0] - S[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function r() {
        if (!this.a.k)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function o() {
      }
      function s(g) {
        this._addDynamicProperty(g), this.elem.addDynamicProperty(g), this._isDirty = !0;
      }
      function m(g, M, T) {
        if (this.elem = g, this.frameId = -1, this.propType = "transform", this.data = M, this.v = new At(), this.pre = new At(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(T || g), M.p && M.p.s ? (this.px = D.getProp(g, M.p.x, 0, 0, this), this.py = D.getProp(g, M.p.y, 0, 0, this), M.p.z && (this.pz = D.getProp(g, M.p.z, 0, 0, this))) : this.p = D.getProp(g, M.p || { k: [0, 0, 0] }, 1, 0, this), M.rx) {
          if (this.rx = D.getProp(g, M.rx, 0, ht, this), this.ry = D.getProp(g, M.ry, 0, ht, this), this.rz = D.getProp(g, M.rz, 0, ht, this), M.or.k[0].ti) {
            var S, k = M.or.k.length;
            for (S = 0; S < k; S += 1)
              M.or.k[S].to = null, M.or.k[S].ti = null;
          }
          this.or = D.getProp(g, M.or, 1, ht, this), this.or.sh = !0;
        } else
          this.r = D.getProp(g, M.r || { k: 0 }, 0, ht, this);
        M.sk && (this.sk = D.getProp(g, M.sk, 0, ht, this), this.sa = D.getProp(g, M.sa, 0, ht, this)), this.a = D.getProp(g, M.a || { k: [0, 0, 0] }, 1, 0, this), this.s = D.getProp(g, M.s || { k: [100, 100, 100] }, 1, 0.01, this), M.o ? this.o = D.getProp(g, M.o, 0, 0.01, g) : this.o = { _mdf: !1, v: 1 }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      m.prototype = {
        applyToMatrix: e,
        getValue: i,
        precalculateMatrix: r,
        autoOrient: o
      }, _t([st], m), m.prototype.addDynamicProperty = s, m.prototype._addDynamicProperty = st.prototype.addDynamicProperty;
      function C(g, M, T) {
        return new m(g, M, T);
      }
      return {
        getTransformProperty: C
      };
    }();
    function ee() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = it(this._maxLength), this.o = it(this._maxLength), this.i = it(this._maxLength);
    }
    ee.prototype.setPathData = function(t, e) {
      this.c = t, this.setLength(e);
      for (var i = 0; i < e; )
        this.v[i] = Re.newElement(), this.o[i] = Re.newElement(), this.i[i] = Re.newElement(), i += 1;
    }, ee.prototype.setLength = function(t) {
      for (; this._maxLength < t; )
        this.doubleArrayLength();
      this._length = t;
    }, ee.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(it(this._maxLength)), this.i = this.i.concat(it(this._maxLength)), this.o = this.o.concat(it(this._maxLength)), this._maxLength *= 2;
    }, ee.prototype.setXYAt = function(t, e, i, r, o) {
      var s;
      switch (this._length = Math.max(this._length, r + 1), this._length >= this._maxLength && this.doubleArrayLength(), i) {
        case "v":
          s = this.v;
          break;
        case "i":
          s = this.i;
          break;
        case "o":
          s = this.o;
          break;
        default:
          s = [];
          break;
      }
      (!s[r] || s[r] && !o) && (s[r] = Re.newElement()), s[r][0] = t, s[r][1] = e;
    }, ee.prototype.setTripleAt = function(t, e, i, r, o, s, m, C) {
      this.setXYAt(t, e, "v", m, C), this.setXYAt(i, r, "o", m, C), this.setXYAt(o, s, "i", m, C);
    }, ee.prototype.reverse = function() {
      var t = new ee();
      t.setPathData(this.c, this._length);
      var e = this.v, i = this.o, r = this.i, o = 0;
      this.c && (t.setTripleAt(e[0][0], e[0][1], r[0][0], r[0][1], i[0][0], i[0][1], 0, !1), o = 1);
      var s = this._length - 1, m = this._length, C;
      for (C = o; C < m; C += 1)
        t.setTripleAt(e[s][0], e[s][1], r[s][0], r[s][1], i[s][0], i[s][1], C, !1), s -= 1;
      return t;
    };
    var Le = function() {
      var t = -999999;
      function e(f, h, a) {
        var n = a.lastIndex, u, v, d, b, B, $, X, q, K, U = this.keyframes;
        if (f < U[0].t - this.offsetTime)
          u = U[0].s[0], d = !0, n = 0;
        else if (f >= U[U.length - 1].t - this.offsetTime)
          u = U[U.length - 1].s ? U[U.length - 1].s[0] : U[U.length - 2].e[0], d = !0;
        else {
          for (var Z = n, I = U.length - 1, w = !0, x, V; w && (x = U[Z], V = U[Z + 1], !(V.t - this.offsetTime > f)); )
            Z < I - 1 ? Z += 1 : w = !1;
          if (d = x.h === 1, n = Z, !d) {
            if (f >= V.t - this.offsetTime)
              q = 1;
            else if (f < x.t - this.offsetTime)
              q = 0;
            else {
              var H;
              x.__fnct ? H = x.__fnct : (H = ae.getBezierEasing(x.o.x, x.o.y, x.i.x, x.i.y).get, x.__fnct = H), q = H((f - (x.t - this.offsetTime)) / (V.t - this.offsetTime - (x.t - this.offsetTime)));
            }
            v = V.s ? V.s[0] : x.e[0];
          }
          u = x.s[0];
        }
        for ($ = h._length, X = u.i[0].length, a.lastIndex = n, b = 0; b < $; b += 1)
          for (B = 0; B < X; B += 1)
            K = d ? u.i[b][B] : u.i[b][B] + (v.i[b][B] - u.i[b][B]) * q, h.i[b][B] = K, K = d ? u.o[b][B] : u.o[b][B] + (v.o[b][B] - u.o[b][B]) * q, h.o[b][B] = K, K = d ? u.v[b][B] : u.v[b][B] + (v.v[b][B] - u.v[b][B]) * q, h.v[b][B] = K;
      }
      function i() {
        var f = this.comp.renderedFrame - this.offsetTime, h = this.keyframes[0].t - this.offsetTime, a = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, n = this._caching.lastFrame;
        return n !== t && (n < h && f < h || n > a && f > a) || (this._caching.lastIndex = n < f ? this._caching.lastIndex : 0, this.interpolateShape(f, this.pv, this._caching)), this._caching.lastFrame = f, this.pv;
      }
      function r() {
        this.paths = this.localShapeCollection;
      }
      function o(f, h) {
        if (f._length !== h._length || f.c !== h.c)
          return !1;
        var a, n = f._length;
        for (a = 0; a < n; a += 1)
          if (f.v[a][0] !== h.v[a][0] || f.v[a][1] !== h.v[a][1] || f.o[a][0] !== h.o[a][0] || f.o[a][1] !== h.o[a][1] || f.i[a][0] !== h.i[a][0] || f.i[a][1] !== h.i[a][1])
            return !1;
        return !0;
      }
      function s(f) {
        o(this.v, f) || (this.v = Ut.clone(f), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function m() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var f;
          this.kf ? f = this.pv : this.data.ks ? f = this.data.ks.k : f = this.data.pt.k;
          var h, a = this.effectsSequence.length;
          for (h = 0; h < a; h += 1)
            f = this.effectsSequence[h](f);
          this.setVValue(f), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function C(f, h, a) {
        this.propType = "shape", this.comp = f.comp, this.container = f, this.elem = f, this.data = h, this.k = !1, this.kf = !1, this._mdf = !1;
        var n = a === 3 ? h.pt.k : h.ks.k;
        this.v = Ut.clone(n), this.pv = Ut.clone(this.v), this.localShapeCollection = qe.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = [];
      }
      function g(f) {
        this.effectsSequence.push(f), this.container.addDynamicProperty(this);
      }
      C.prototype.interpolateShape = e, C.prototype.getValue = m, C.prototype.setVValue = s, C.prototype.addEffect = g;
      function M(f, h, a) {
        this.propType = "shape", this.comp = f.comp, this.elem = f, this.container = f, this.offsetTime = f.data.st, this.keyframes = a === 3 ? h.pt.k : h.ks.k, this.k = !0, this.kf = !0;
        var n = this.keyframes[0].s[0].i.length;
        this.v = Ut.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, n), this.pv = Ut.clone(this.v), this.localShapeCollection = qe.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t, this.reset = r, this._caching = { lastFrame: t, lastIndex: 0 }, this.effectsSequence = [i.bind(this)];
      }
      M.prototype.getValue = m, M.prototype.interpolateShape = e, M.prototype.setVValue = s, M.prototype.addEffect = g;
      var T = function() {
        var f = pt;
        function h(a, n) {
          this.v = Ut.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = qe.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = n.d, this.elem = a, this.comp = a.comp, this.frameId = -1, this.initDynamicPropertyContainer(a), this.p = D.getProp(a, n.p, 1, 0, this), this.s = D.getProp(a, n.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return h.prototype = {
          reset: r,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var a = this.p.v[0], n = this.p.v[1], u = this.s.v[0] / 2, v = this.s.v[1] / 2, d = this.d !== 3, b = this.v;
            b.v[0][0] = a, b.v[0][1] = n - v, b.v[1][0] = d ? a + u : a - u, b.v[1][1] = n, b.v[2][0] = a, b.v[2][1] = n + v, b.v[3][0] = d ? a - u : a + u, b.v[3][1] = n, b.i[0][0] = d ? a - u * f : a + u * f, b.i[0][1] = n - v, b.i[1][0] = d ? a + u : a - u, b.i[1][1] = n - v * f, b.i[2][0] = d ? a + u * f : a - u * f, b.i[2][1] = n + v, b.i[3][0] = d ? a - u : a + u, b.i[3][1] = n + v * f, b.o[0][0] = d ? a + u * f : a - u * f, b.o[0][1] = n - v, b.o[1][0] = d ? a + u : a - u, b.o[1][1] = n + v * f, b.o[2][0] = d ? a - u * f : a + u * f, b.o[2][1] = n + v, b.o[3][0] = d ? a - u : a + u, b.o[3][1] = n - v * f;
          }
        }, _t([st], h), h;
      }(), S = function() {
        function f(h, a) {
          this.v = Ut.newElement(), this.v.setPathData(!0, 0), this.elem = h, this.comp = h.comp, this.data = a, this.frameId = -1, this.d = a.d, this.initDynamicPropertyContainer(h), a.sy === 1 ? (this.ir = D.getProp(h, a.ir, 0, 0, this), this.is = D.getProp(h, a.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = D.getProp(h, a.pt, 0, 0, this), this.p = D.getProp(h, a.p, 1, 0, this), this.r = D.getProp(h, a.r, 0, ht, this), this.or = D.getProp(h, a.or, 0, 0, this), this.os = D.getProp(h, a.os, 0, 0.01, this), this.localShapeCollection = qe.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return f.prototype = {
          reset: r,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var h = Math.floor(this.pt.v) * 2, a = Math.PI * 2 / h, n = !0, u = this.or.v, v = this.ir.v, d = this.os.v, b = this.is.v, B = 2 * Math.PI * u / (h * 2), $ = 2 * Math.PI * v / (h * 2), X, q, K, U, Z = -Math.PI / 2;
            Z += this.r.v;
            var I = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, X = 0; X < h; X += 1) {
              q = n ? u : v, K = n ? d : b, U = n ? B : $;
              var w = q * Math.cos(Z), x = q * Math.sin(Z), V = w === 0 && x === 0 ? 0 : x / Math.sqrt(w * w + x * x), H = w === 0 && x === 0 ? 0 : -w / Math.sqrt(w * w + x * x);
              w += +this.p.v[0], x += +this.p.v[1], this.v.setTripleAt(w, x, w - V * U * K * I, x - H * U * K * I, w + V * U * K * I, x + H * U * K * I, X, !0), n = !n, Z += a * I;
            }
          },
          convertPolygonToPath: function() {
            var h = Math.floor(this.pt.v), a = Math.PI * 2 / h, n = this.or.v, u = this.os.v, v = 2 * Math.PI * n / (h * 4), d, b = -Math.PI * 0.5, B = this.data.d === 3 ? -1 : 1;
            for (b += this.r.v, this.v._length = 0, d = 0; d < h; d += 1) {
              var $ = n * Math.cos(b), X = n * Math.sin(b), q = $ === 0 && X === 0 ? 0 : X / Math.sqrt($ * $ + X * X), K = $ === 0 && X === 0 ? 0 : -$ / Math.sqrt($ * $ + X * X);
              $ += +this.p.v[0], X += +this.p.v[1], this.v.setTripleAt($, X, $ - q * v * u * B, X - K * v * u * B, $ + q * v * u * B, X + K * v * u * B, d, !0), b += a * B;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, _t([st], f), f;
      }(), k = function() {
        function f(h, a) {
          this.v = Ut.newElement(), this.v.c = !0, this.localShapeCollection = qe.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = h, this.comp = h.comp, this.frameId = -1, this.d = a.d, this.initDynamicPropertyContainer(h), this.p = D.getProp(h, a.p, 1, 0, this), this.s = D.getProp(h, a.s, 1, 0, this), this.r = D.getProp(h, a.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return f.prototype = {
          convertRectToPath: function() {
            var h = this.p.v[0], a = this.p.v[1], n = this.s.v[0] / 2, u = this.s.v[1] / 2, v = lt(n, u, this.r.v), d = v * (1 - pt);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(h + n, a - u + v, h + n, a - u + v, h + n, a - u + d, 0, !0), this.v.setTripleAt(h + n, a + u - v, h + n, a + u - d, h + n, a + u - v, 1, !0), v !== 0 ? (this.v.setTripleAt(h + n - v, a + u, h + n - v, a + u, h + n - d, a + u, 2, !0), this.v.setTripleAt(h - n + v, a + u, h - n + d, a + u, h - n + v, a + u, 3, !0), this.v.setTripleAt(h - n, a + u - v, h - n, a + u - v, h - n, a + u - d, 4, !0), this.v.setTripleAt(h - n, a - u + v, h - n, a - u + d, h - n, a - u + v, 5, !0), this.v.setTripleAt(h - n + v, a - u, h - n + v, a - u, h - n + d, a - u, 6, !0), this.v.setTripleAt(h + n - v, a - u, h + n - d, a - u, h + n - v, a - u, 7, !0)) : (this.v.setTripleAt(h - n, a + u, h - n + d, a + u, h - n, a + u, 2), this.v.setTripleAt(h - n, a - u, h - n, a - u + d, h - n, a - u, 3))) : (this.v.setTripleAt(h + n, a - u + v, h + n, a - u + d, h + n, a - u + v, 0, !0), v !== 0 ? (this.v.setTripleAt(h + n - v, a - u, h + n - v, a - u, h + n - d, a - u, 1, !0), this.v.setTripleAt(h - n + v, a - u, h - n + d, a - u, h - n + v, a - u, 2, !0), this.v.setTripleAt(h - n, a - u + v, h - n, a - u + v, h - n, a - u + d, 3, !0), this.v.setTripleAt(h - n, a + u - v, h - n, a + u - d, h - n, a + u - v, 4, !0), this.v.setTripleAt(h - n + v, a + u, h - n + v, a + u, h - n + d, a + u, 5, !0), this.v.setTripleAt(h + n - v, a + u, h + n - d, a + u, h + n - v, a + u, 6, !0), this.v.setTripleAt(h + n, a + u - v, h + n, a + u - v, h + n, a + u - d, 7, !0)) : (this.v.setTripleAt(h - n, a - u, h - n + d, a - u, h - n, a - u, 1, !0), this.v.setTripleAt(h - n, a + u, h - n, a + u - d, h - n, a + u, 2, !0), this.v.setTripleAt(h + n, a + u, h + n - d, a + u, h + n, a + u, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: r
        }, _t([st], f), f;
      }();
      function _(f, h, a) {
        var n;
        if (a === 3 || a === 4) {
          var u = a === 3 ? h.pt : h.ks, v = u.k;
          v.length ? n = new M(f, h, a) : n = new C(f, h, a);
        } else
          a === 5 ? n = new k(f, h) : a === 6 ? n = new T(f, h) : a === 7 && (n = new S(f, h));
        return n.k && f.addDynamicProperty(n), n;
      }
      function P() {
        return C;
      }
      function E() {
        return M;
      }
      var p = {};
      return p.getShapeProp = _, p.getConstructorFunction = P, p.getKeyframedConstructorFunction = E, p;
    }(), $e = function() {
      var t = {}, e = {};
      t.registerModifier = i, t.getModifier = r;
      function i(o, s) {
        e[o] || (e[o] = s);
      }
      function r(o, s, m) {
        return new e[o](s, m);
      }
      return t;
    }();
    function ve() {
    }
    ve.prototype.initModifierProperties = function() {
    }, ve.prototype.addShapeToModifier = function() {
    }, ve.prototype.addShape = function(t) {
      if (!this.closed) {
        t.sh.container.addDynamicProperty(t.sh);
        var e = { shape: t.sh, data: t, localShapeCollection: qe.newShapeCollection() };
        this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
      }
    }, ve.prototype.init = function(t, e) {
      this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = F, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ve.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, _t([st], ve);
    function le() {
    }
    _t([ve], le), le.prototype.initModifierProperties = function(t, e) {
      this.s = D.getProp(t, e.s, 0, 0.01, this), this.e = D.getProp(t, e.e, 0, 0.01, this), this.o = D.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, le.prototype.addShapeToModifier = function(t) {
      t.pathsData = [];
    }, le.prototype.calculateShapeEdges = function(t, e, i, r, o) {
      var s = [];
      e <= 1 ? s.push({
        s: t,
        e
      }) : t >= 1 ? s.push({
        s: t - 1,
        e: e - 1
      }) : (s.push({
        s: t,
        e: 1
      }), s.push({
        s: 0,
        e: e - 1
      }));
      var m = [], C, g = s.length, M;
      for (C = 0; C < g; C += 1)
        if (M = s[C], !(M.e * o < r || M.s * o > r + i)) {
          var T, S;
          M.s * o <= r ? T = 0 : T = (M.s * o - r) / i, M.e * o >= r + i ? S = 1 : S = (M.e * o - r) / i, m.push([T, S]);
        }
      return m.length || m.push([0, 0]), m;
    }, le.prototype.releasePathsData = function(t) {
      var e, i = t.length;
      for (e = 0; e < i; e += 1)
        fr.release(t[e]);
      return t.length = 0, t;
    }, le.prototype.processShapes = function(t) {
      var e, i;
      if (this._mdf || t) {
        var r = this.o.v % 360 / 360;
        if (r < 0 && (r += 1), this.s.v > 1 ? e = 1 + r : this.s.v < 0 ? e = 0 + r : e = this.s.v + r, this.e.v > 1 ? i = 1 + r : this.e.v < 0 ? i = 0 + r : i = this.e.v + r, e > i) {
          var o = e;
          e = i, i = o;
        }
        e = Math.round(e * 1e4) * 1e-4, i = Math.round(i * 1e4) * 1e-4, this.sValue = e, this.eValue = i;
      } else
        e = this.sValue, i = this.eValue;
      var s, m, C = this.shapes.length, g, M, T, S, k, _ = 0;
      if (i === e)
        for (m = 0; m < C; m += 1)
          this.shapes[m].localShapeCollection.releaseShapes(), this.shapes[m].shape._mdf = !0, this.shapes[m].shape.paths = this.shapes[m].localShapeCollection, this._mdf && (this.shapes[m].pathsData.length = 0);
      else if (i === 1 && e === 0 || i === 0 && e === 1) {
        if (this._mdf)
          for (m = 0; m < C; m += 1)
            this.shapes[m].pathsData.length = 0, this.shapes[m].shape._mdf = !0;
      } else {
        var P = [], E, p;
        for (m = 0; m < C; m += 1)
          if (E = this.shapes[m], !E.shape._mdf && !this._mdf && !t && this.m !== 2)
            E.shape.paths = E.localShapeCollection;
          else {
            if (s = E.shape.paths, M = s._length, k = 0, !E.shape._mdf && E.pathsData.length)
              k = E.totalShapeLength;
            else {
              for (T = this.releasePathsData(E.pathsData), g = 0; g < M; g += 1)
                S = oe.getSegmentsLength(s.shapes[g]), T.push(S), k += S.totalLength;
              E.totalShapeLength = k, E.pathsData = T;
            }
            _ += k, E.shape._mdf = !0;
          }
        var f = e, h = i, a = 0, n;
        for (m = C - 1; m >= 0; m -= 1)
          if (E = this.shapes[m], E.shape._mdf) {
            for (p = E.localShapeCollection, p.releaseShapes(), this.m === 2 && C > 1 ? (n = this.calculateShapeEdges(e, i, E.totalShapeLength, a, _), a += E.totalShapeLength) : n = [[f, h]], M = n.length, g = 0; g < M; g += 1) {
              f = n[g][0], h = n[g][1], P.length = 0, h <= 1 ? P.push({
                s: E.totalShapeLength * f,
                e: E.totalShapeLength * h
              }) : f >= 1 ? P.push({
                s: E.totalShapeLength * (f - 1),
                e: E.totalShapeLength * (h - 1)
              }) : (P.push({
                s: E.totalShapeLength * f,
                e: E.totalShapeLength
              }), P.push({
                s: 0,
                e: E.totalShapeLength * (h - 1)
              }));
              var u = this.addShapes(E, P[0]);
              if (P[0].s !== P[0].e) {
                if (P.length > 1) {
                  var v = E.shape.paths.shapes[E.shape.paths._length - 1];
                  if (v.c) {
                    var d = u.pop();
                    this.addPaths(u, p), u = this.addShapes(E, P[1], d);
                  } else
                    this.addPaths(u, p), u = this.addShapes(E, P[1]);
                }
                this.addPaths(u, p);
              }
            }
            E.shape.paths = p;
          }
      }
    }, le.prototype.addPaths = function(t, e) {
      var i, r = t.length;
      for (i = 0; i < r; i += 1)
        e.addShape(t[i]);
    }, le.prototype.addSegment = function(t, e, i, r, o, s, m) {
      o.setXYAt(e[0], e[1], "o", s), o.setXYAt(i[0], i[1], "i", s + 1), m && o.setXYAt(t[0], t[1], "v", s), o.setXYAt(r[0], r[1], "v", s + 1);
    }, le.prototype.addSegmentFromArray = function(t, e, i, r) {
      e.setXYAt(t[1], t[5], "o", i), e.setXYAt(t[2], t[6], "i", i + 1), r && e.setXYAt(t[0], t[4], "v", i), e.setXYAt(t[3], t[7], "v", i + 1);
    }, le.prototype.addShapes = function(t, e, i) {
      var r = t.pathsData, o = t.shape.paths.shapes, s, m = t.shape.paths._length, C, g, M = 0, T, S, k, _, P = [], E, p = !0;
      for (i ? (S = i._length, E = i._length) : (i = Ut.newElement(), S = 0, E = 0), P.push(i), s = 0; s < m; s += 1) {
        for (k = r[s].lengths, i.c = o[s].c, g = o[s].c ? k.length : k.length + 1, C = 1; C < g; C += 1)
          if (T = k[C - 1], M + T.addedLength < e.s)
            M += T.addedLength, i.c = !1;
          else if (M > e.e) {
            i.c = !1;
            break;
          } else
            e.s <= M && e.e >= M + T.addedLength ? (this.addSegment(o[s].v[C - 1], o[s].o[C - 1], o[s].i[C], o[s].v[C], i, S, p), p = !1) : (_ = oe.getNewSegment(o[s].v[C - 1], o[s].v[C], o[s].o[C - 1], o[s].i[C], (e.s - M) / T.addedLength, (e.e - M) / T.addedLength, k[C - 1]), this.addSegmentFromArray(_, i, S, p), p = !1, i.c = !1), M += T.addedLength, S += 1;
        if (o[s].c && k.length) {
          if (T = k[C - 1], M <= e.e) {
            var f = k[C - 1].addedLength;
            e.s <= M && e.e >= M + f ? (this.addSegment(o[s].v[C - 1], o[s].o[C - 1], o[s].i[0], o[s].v[0], i, S, p), p = !1) : (_ = oe.getNewSegment(o[s].v[C - 1], o[s].v[0], o[s].o[C - 1], o[s].i[0], (e.s - M) / f, (e.e - M) / f, k[C - 1]), this.addSegmentFromArray(_, i, S, p), p = !1, i.c = !1);
          } else
            i.c = !1;
          M += T.addedLength, S += 1;
        }
        if (i._length && (i.setXYAt(i.v[E][0], i.v[E][1], "i", E), i.setXYAt(i.v[i._length - 1][0], i.v[i._length - 1][1], "o", i._length - 1)), M > e.e)
          break;
        s < m - 1 && (i = Ut.newElement(), p = !0, P.push(i), S = 0);
      }
      return P;
    }, $e.registerModifier("tm", le);
    function Je() {
    }
    _t([ve], Je), Je.prototype.initModifierProperties = function(t, e) {
      this.getValue = this.processKeys, this.rd = D.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, Je.prototype.processPath = function(t, e) {
      var i = Ut.newElement();
      i.c = t.c;
      var r, o = t._length, s, m, C, g, M, T, S = 0, k, _, P, E, p, f;
      for (r = 0; r < o; r += 1)
        s = t.v[r], C = t.o[r], m = t.i[r], s[0] === C[0] && s[1] === C[1] && s[0] === m[0] && s[1] === m[1] ? (r === 0 || r === o - 1) && !t.c ? (i.setTripleAt(s[0], s[1], C[0], C[1], m[0], m[1], S), S += 1) : (r === 0 ? g = t.v[o - 1] : g = t.v[r - 1], M = Math.sqrt(Math.pow(s[0] - g[0], 2) + Math.pow(s[1] - g[1], 2)), T = M ? Math.min(M / 2, e) / M : 0, p = s[0] + (g[0] - s[0]) * T, k = p, f = s[1] - (s[1] - g[1]) * T, _ = f, P = k - (k - s[0]) * pt, E = _ - (_ - s[1]) * pt, i.setTripleAt(k, _, P, E, p, f, S), S += 1, r === o - 1 ? g = t.v[0] : g = t.v[r + 1], M = Math.sqrt(Math.pow(s[0] - g[0], 2) + Math.pow(s[1] - g[1], 2)), T = M ? Math.min(M / 2, e) / M : 0, P = s[0] + (g[0] - s[0]) * T, k = P, E = s[1] + (g[1] - s[1]) * T, _ = E, p = k - (k - s[0]) * pt, f = _ - (_ - s[1]) * pt, i.setTripleAt(k, _, P, E, p, f, S), S += 1) : (i.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], S), S += 1);
      return i;
    }, Je.prototype.processShapes = function(t) {
      var e, i, r = this.shapes.length, o, s, m = this.rd.v;
      if (m !== 0) {
        var C, g;
        for (i = 0; i < r; i += 1) {
          if (C = this.shapes[i], g = C.localShapeCollection, !(!C.shape._mdf && !this._mdf && !t))
            for (g.releaseShapes(), C.shape._mdf = !0, e = C.shape.paths.shapes, s = C.shape.paths._length, o = 0; o < s; o += 1)
              g.addShape(this.processPath(e[o], m));
          C.shape.paths = C.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    }, $e.registerModifier("rd", Je);
    function Qe() {
    }
    _t([ve], Qe), Qe.prototype.initModifierProperties = function(t, e) {
      this.getValue = this.processKeys, this.amount = D.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, Qe.prototype.processPath = function(t, e) {
      var i = e / 100, r = [0, 0], o = t._length, s = 0;
      for (s = 0; s < o; s += 1)
        r[0] += t.v[s][0], r[1] += t.v[s][1];
      r[0] /= o, r[1] /= o;
      var m = Ut.newElement();
      m.c = t.c;
      var C, g, M, T, S, k;
      for (s = 0; s < o; s += 1)
        C = t.v[s][0] + (r[0] - t.v[s][0]) * i, g = t.v[s][1] + (r[1] - t.v[s][1]) * i, M = t.o[s][0] + (r[0] - t.o[s][0]) * -i, T = t.o[s][1] + (r[1] - t.o[s][1]) * -i, S = t.i[s][0] + (r[0] - t.i[s][0]) * -i, k = t.i[s][1] + (r[1] - t.i[s][1]) * -i, m.setTripleAt(C, g, M, T, S, k, s);
      return m;
    }, Qe.prototype.processShapes = function(t) {
      var e, i, r = this.shapes.length, o, s, m = this.amount.v;
      if (m !== 0) {
        var C, g;
        for (i = 0; i < r; i += 1) {
          if (C = this.shapes[i], g = C.localShapeCollection, !(!C.shape._mdf && !this._mdf && !t))
            for (g.releaseShapes(), C.shape._mdf = !0, e = C.shape.paths.shapes, s = C.shape.paths._length, o = 0; o < s; o += 1)
              g.addShape(this.processPath(e[o], m));
          C.shape.paths = C.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    }, $e.registerModifier("pb", Qe);
    function me() {
    }
    _t([ve], me), me.prototype.initModifierProperties = function(t, e) {
      this.getValue = this.processKeys, this.c = D.getProp(t, e.c, 0, null, this), this.o = D.getProp(t, e.o, 0, null, this), this.tr = Ie.getTransformProperty(t, e.tr, this), this.so = D.getProp(t, e.tr.so, 0, 0.01, this), this.eo = D.getProp(t, e.tr.eo, 0, 0.01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new At(), this.rMatrix = new At(), this.sMatrix = new At(), this.tMatrix = new At(), this.matrix = new At();
    }, me.prototype.applyTransforms = function(t, e, i, r, o, s) {
      var m = s ? -1 : 1, C = r.s.v[0] + (1 - r.s.v[0]) * (1 - o), g = r.s.v[1] + (1 - r.s.v[1]) * (1 - o);
      t.translate(r.p.v[0] * m * o, r.p.v[1] * m * o, r.p.v[2]), e.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]), e.rotate(-r.r.v * m * o), e.translate(r.a.v[0], r.a.v[1], r.a.v[2]), i.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]), i.scale(s ? 1 / C : C, s ? 1 / g : g), i.translate(r.a.v[0], r.a.v[1], r.a.v[2]);
    }, me.prototype.init = function(t, e, i, r) {
      for (this.elem = t, this.arr = e, this.pos = i, this.elemsData = r, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[i]); i > 0; )
        i -= 1, this._elements.unshift(e[i]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, me.prototype.resetElements = function(t) {
      var e, i = t.length;
      for (e = 0; e < i; e += 1)
        t[e]._processed = !1, t[e].ty === "gr" && this.resetElements(t[e].it);
    }, me.prototype.cloneElements = function(t) {
      var e = JSON.parse(JSON.stringify(t));
      return this.resetElements(e), e;
    }, me.prototype.changeGroupRender = function(t, e) {
      var i, r = t.length;
      for (i = 0; i < r; i += 1)
        t[i]._render = e, t[i].ty === "gr" && this.changeGroupRender(t[i].it, e);
    }, me.prototype.processShapes = function(t) {
      var e, i, r, o, s, m = !1;
      if (this._mdf || t) {
        var C = Math.ceil(this.c.v);
        if (this._groups.length < C) {
          for (; this._groups.length < C; ) {
            var g = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            g.it.push({
              a: { a: 0, ix: 1, k: [0, 0] },
              nm: "Transform",
              o: { a: 0, ix: 7, k: 100 },
              p: { a: 0, ix: 2, k: [0, 0] },
              r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] },
              s: { a: 0, ix: 3, k: [100, 100] },
              sa: { a: 0, ix: 5, k: 0 },
              sk: { a: 0, ix: 4, k: 0 },
              ty: "tr"
            }), this.arr.splice(0, 0, g), this._groups.splice(0, 0, g), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), m = !0;
        }
        s = 0;
        var M;
        for (r = 0; r <= this._groups.length - 1; r += 1) {
          if (M = s < C, this._groups[r]._render = M, this.changeGroupRender(this._groups[r].it, M), !M) {
            var T = this.elemsData[r].it, S = T[T.length - 1];
            S.transform.op.v !== 0 ? (S.transform.op._mdf = !0, S.transform.op.v = 0) : S.transform.op._mdf = !1;
          }
          s += 1;
        }
        this._currentCopies = C;
        var k = this.o.v, _ = k % 1, P = k > 0 ? Math.floor(k) : Math.ceil(k), E = this.pMatrix.props, p = this.rMatrix.props, f = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var h = 0;
        if (k > 0) {
          for (; h < P; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), h += 1;
          _ && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, _, !1), h += _);
        } else if (k < 0) {
          for (; h > P; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), h -= 1;
          _ && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -_, !0), h -= _);
        }
        r = this.data.m === 1 ? 0 : this._currentCopies - 1, o = this.data.m === 1 ? 1 : -1, s = this._currentCopies;
        for (var a, n; s; ) {
          if (e = this.elemsData[r].it, i = e[e.length - 1].transform.mProps.v.props, n = i.length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (r / (this._currentCopies - 1)), h !== 0) {
            for ((r !== 0 && o === 1 || r !== this._currentCopies - 1 && o === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(p[0], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8], p[9], p[10], p[11], p[12], p[13], p[14], p[15]), this.matrix.transform(f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7], f[8], f[9], f[10], f[11], f[12], f[13], f[14], f[15]), this.matrix.transform(E[0], E[1], E[2], E[3], E[4], E[5], E[6], E[7], E[8], E[9], E[10], E[11], E[12], E[13], E[14], E[15]), a = 0; a < n; a += 1)
              i[a] = this.matrix.props[a];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), a = 0; a < n; a += 1)
              i[a] = this.matrix.props[a];
          h += 1, s -= 1, r += o;
        }
      } else
        for (s = this._currentCopies, r = 0, o = 1; s; )
          e = this.elemsData[r].it, i = e[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, s -= 1, r += o;
      return m;
    }, me.prototype.addShape = function() {
    }, $e.registerModifier("rp", me);
    function Ni() {
      this._length = 0, this._maxLength = 4, this.shapes = it(this._maxLength);
    }
    Ni.prototype.addShape = function(t) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(it(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
    }, Ni.prototype.releaseShapes = function() {
      var t;
      for (t = 0; t < this._length; t += 1)
        Ut.release(this.shapes[t]);
      this._length = 0;
    };
    function ui(t, e, i, r) {
      this.elem = t, this.frameId = -1, this.dataProps = it(e.length), this.renderer = i, this.k = !1, this.dashStr = "", this.dashArray = et("float32", e.length ? e.length - 1 : 0), this.dashoffset = et("float32", 1), this.initDynamicPropertyContainer(r);
      var o, s = e.length || 0, m;
      for (o = 0; o < s; o += 1)
        m = D.getProp(t, e[o].v, 0, 0, this), this.k = m.k || this.k, this.dataProps[o] = { n: e[o].n, p: m };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    ui.prototype.getValue = function(t) {
      if (!(this.elem.globalData.frameId === this.frameId && !t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
        var e = 0, i = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), e = 0; e < i; e += 1)
          this.dataProps[e].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
      }
    }, _t([st], ui);
    function ti(t, e, i) {
      this.data = e, this.c = et("uint8c", e.p * 4);
      var r = e.k.k[0].s ? e.k.k[0].s.length - e.p * 4 : e.k.k.length - e.p * 4;
      this.o = et("float32", r), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = r, this.initDynamicPropertyContainer(i), this.prop = D.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    ti.prototype.comparePoints = function(t, e) {
      for (var i = 0, r = this.o.length / 2, o; i < r; ) {
        if (o = Math.abs(t[i * 4] - t[e * 4 + i * 2]), o > 0.01)
          return !1;
        i += 1;
      }
      return !0;
    }, ti.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var t = 0, e = this.data.k.k.length; t < e; ) {
          if (!this.comparePoints(this.data.k.k[t].s, this.data.p))
            return !1;
          t += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, ti.prototype.getValue = function(t) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
        var e, i = this.data.p * 4, r, o;
        for (e = 0; e < i; e += 1)
          r = e % 4 === 0 ? 100 : 255, o = Math.round(this.prop.v[e] * r), this.c[e] !== o && (this.c[e] = o, this._cmdf = !t);
        if (this.o.length)
          for (i = this.prop.v.length, e = this.data.p * 4; e < i; e += 1)
            r = e % 2 === 0 ? 100 : 1, o = e % 2 === 0 ? Math.round(this.prop.v[e] * 100) : this.prop.v[e], this.o[e - this.data.p * 4] !== o && (this.o[e - this.data.p * 4] = o, this._omdf = !t);
        this._mdf = !t;
      }
    }, _t([st], ti);
    var or = function(t, e, i, r) {
      if (e === 0)
        return "";
      var o = t.o, s = t.i, m = t.v, C, g = " M" + r.applyToPointStringified(m[0][0], m[0][1]);
      for (C = 1; C < e; C += 1)
        g += " C" + r.applyToPointStringified(o[C - 1][0], o[C - 1][1]) + " " + r.applyToPointStringified(s[C][0], s[C][1]) + " " + r.applyToPointStringified(m[C][0], m[C][1]);
      return i && e && (g += " C" + r.applyToPointStringified(o[C - 1][0], o[C - 1][1]) + " " + r.applyToPointStringified(s[0][0], s[0][1]) + " " + r.applyToPointStringified(m[0][0], m[0][1]), g += "z"), g;
    }, rs = function() {
      function t(e) {
        this.audios = [], this.audioFactory = e, this._volume = 1, this._isMuted = !1;
      }
      return t.prototype = {
        addAudio: function(e) {
          this.audios.push(e);
        },
        pause: function() {
          var e, i = this.audios.length;
          for (e = 0; e < i; e += 1)
            this.audios[e].pause();
        },
        resume: function() {
          var e, i = this.audios.length;
          for (e = 0; e < i; e += 1)
            this.audios[e].resume();
        },
        setRate: function(e) {
          var i, r = this.audios.length;
          for (i = 0; i < r; i += 1)
            this.audios[i].setRate(e);
        },
        createAudio: function(e) {
          return this.audioFactory ? this.audioFactory(e) : Howl ? new Howl({
            src: [e]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(e) {
          this.audioFactory = e;
        },
        setVolume: function(e) {
          this._volume = e, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var e, i = this.audios.length;
          for (e = 0; e < i; e += 1)
            this.audios[e].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new t();
      };
    }(), ss = function() {
      var t = function() {
        var f = at("canvas");
        f.width = 1, f.height = 1;
        var h = f.getContext("2d");
        return h.fillStyle = "rgba(0,0,0,0)", h.fillRect(0, 0, 1, 1), f;
      }();
      function e() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function i() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function r(f, h, a) {
        var n = "";
        if (f.e)
          n = f.p;
        else if (h) {
          var u = f.p;
          u.indexOf("images/") !== -1 && (u = u.split("/")[1]), n = h + u;
        } else
          n = a, n += f.u ? f.u : "", n += f.p;
        return n;
      }
      function o(f) {
        var h = 0, a = setInterval(function() {
          var n = f.getBBox();
          (n.width || h > 500) && (this._imageLoaded(), clearInterval(a)), h += 1;
        }.bind(this), 50);
      }
      function s(f) {
        var h = r(f, this.assetsPath, this.path), a = W("image");
        z ? this.testImageLoaded(a) : a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", function() {
          n.img = t, this._imageLoaded();
        }.bind(this), !1), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", h), this._elementHelper.append ? this._elementHelper.append(a) : this._elementHelper.appendChild(a);
        var n = {
          img: a,
          assetData: f
        };
        return n;
      }
      function m(f) {
        var h = r(f, this.assetsPath, this.path), a = at("img");
        a.crossOrigin = "anonymous", a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", function() {
          n.img = t, this._imageLoaded();
        }.bind(this), !1), a.src = h;
        var n = {
          img: a,
          assetData: f
        };
        return n;
      }
      function C(f) {
        var h = {
          assetData: f
        }, a = r(f, this.assetsPath, this.path);
        return zi.load(a, function(n) {
          h.img = n, this._footageLoaded();
        }.bind(this), function() {
          h.img = {}, this._footageLoaded();
        }.bind(this)), h;
      }
      function g(f, h) {
        this.imagesLoadedCb = h;
        var a, n = f.length;
        for (a = 0; a < n; a += 1)
          f[a].layers || (!f[a].t || f[a].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(f[a]))) : f[a].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(f[a]))));
      }
      function M(f) {
        this.path = f || "";
      }
      function T(f) {
        this.assetsPath = f || "";
      }
      function S(f) {
        for (var h = 0, a = this.images.length; h < a; ) {
          if (this.images[h].assetData === f)
            return this.images[h].img;
          h += 1;
        }
        return null;
      }
      function k() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function _() {
        return this.totalImages === this.loadedAssets;
      }
      function P() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function E(f, h) {
        f === "svg" ? (this._elementHelper = h, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function p() {
        this._imageLoaded = e.bind(this), this._footageLoaded = i.bind(this), this.testImageLoaded = o.bind(this), this.createFootageData = C.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return p.prototype = {
        loadAssets: g,
        setAssetsPath: T,
        setPath: M,
        loadedImages: _,
        loadedFootages: P,
        destroy: k,
        getAsset: S,
        createImgData: m,
        createImageData: s,
        imageLoaded: e,
        footageLoaded: i,
        setCacheType: E
      }, p;
    }(), hr = function() {
      var t = {
        maskType: !0
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), t;
    }(), ci = function() {
      var t = {};
      t.createFilter = e, t.createAlphaToLuminanceFilter = i;
      function e(r, o) {
        var s = W("filter");
        return s.setAttribute("id", r), o !== !0 && (s.setAttribute("filterUnits", "objectBoundingBox"), s.setAttribute("x", "0%"), s.setAttribute("y", "0%"), s.setAttribute("width", "100%"), s.setAttribute("height", "100%")), s;
      }
      function i() {
        var r = W("feColorMatrix");
        return r.setAttribute("type", "matrix"), r.setAttribute("color-interpolation-filters", "sRGB"), r.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), r;
      }
      return t;
    }(), zi = function() {
      function t(i) {
        return i.response && typeof i.response == "object" ? i.response : i.response && typeof i.response == "string" ? JSON.parse(i.response) : i.responseText ? JSON.parse(i.responseText) : null;
      }
      function e(i, r, o) {
        var s, m = new XMLHttpRequest();
        try {
          m.responseType = "json";
        } catch {
        }
        m.onreadystatechange = function() {
          if (m.readyState === 4)
            if (m.status === 200)
              s = t(m), r(s);
            else
              try {
                s = t(m), r(s);
              } catch (C) {
                o && o(C);
              }
        }, m.open("GET", i, !0), m.send();
      }
      return {
        load: e
      };
    }();
    function Oe(t, e, i) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = i, this._animatorsData = it(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(i);
    }
    Oe.prototype.searchProperties = function() {
      var t, e = this._textData.a.length, i, r = D.getProp;
      for (t = 0; t < e; t += 1)
        i = this._textData.a[t], this._animatorsData[t] = new ns(this._elem, i, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: r(this._elem, this._textData.p.a, 0, 0, this),
        f: r(this._elem, this._textData.p.f, 0, 0, this),
        l: r(this._elem, this._textData.p.l, 0, 0, this),
        r: r(this._elem, this._textData.p.r, 0, 0, this),
        p: r(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = r(this._elem, this._textData.m.a, 1, 0, this);
    }, Oe.prototype.getMeasures = function(t, e) {
      if (this.lettersChangedFlag = e, !(!this._mdf && !this._isFirstFrame && !e && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var i = this._moreOptions.alignment.v, r = this._animatorsData, o = this._textData, s = this.mHelper, m = this._renderType, C = this.renderedLetters.length, g, M, T, S, k = t.l, _, P, E, p, f, h, a, n, u, v, d, b, B, $, X;
        if (this._hasMaskedPath) {
          if (X = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var q = X.v;
            this._pathData.r.v && (q = q.reverse()), _ = {
              tLength: 0,
              segments: []
            }, S = q._length - 1;
            var K;
            for (b = 0, T = 0; T < S; T += 1)
              K = oe.buildBezierData(q.v[T], q.v[T + 1], [q.o[T][0] - q.v[T][0], q.o[T][1] - q.v[T][1]], [q.i[T + 1][0] - q.v[T + 1][0], q.i[T + 1][1] - q.v[T + 1][1]]), _.tLength += K.segmentLength, _.segments.push(K), b += K.segmentLength;
            T = S, X.v.c && (K = oe.buildBezierData(q.v[T], q.v[0], [q.o[T][0] - q.v[T][0], q.o[T][1] - q.v[T][1]], [q.i[0][0] - q.v[0][0], q.i[0][1] - q.v[0][1]]), _.tLength += K.segmentLength, _.segments.push(K), b += K.segmentLength), this._pathData.pi = _;
          }
          if (_ = this._pathData.pi, P = this._pathData.f.v, a = 0, h = 1, p = 0, f = !0, v = _.segments, P < 0 && X.v.c)
            for (_.tLength < Math.abs(P) && (P = -Math.abs(P) % _.tLength), a = v.length - 1, u = v[a].points, h = u.length - 1; P < 0; )
              P += u[h].partialLength, h -= 1, h < 0 && (a -= 1, u = v[a].points, h = u.length - 1);
          u = v[a].points, n = u[h - 1], E = u[h], d = E.partialLength;
        }
        S = k.length, g = 0, M = 0;
        var U = t.finalSize * 1.2 * 0.714, Z = !0, I, w, x, V, H;
        V = r.length;
        var N, vt = -1, ct, St, Vt, Nt = P, Wt = a, ie = h, he = -1, $t, Bt, re, J, Tt, ke, we, xe, ye = "", Se = this.defaultPropsArray, Ae;
        if (t.j === 2 || t.j === 1) {
          var Zt = 0, Pe = 0, Ce = t.j === 2 ? -0.5 : -1, ue = 0, Te = !0;
          for (T = 0; T < S; T += 1)
            if (k[T].n) {
              for (Zt && (Zt += Pe); ue < T; )
                k[ue].animatorJustifyOffset = Zt, ue += 1;
              Zt = 0, Te = !0;
            } else {
              for (x = 0; x < V; x += 1)
                I = r[x].a, I.t.propType && (Te && t.j === 2 && (Pe += I.t.v * Ce), w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), N.length ? Zt += I.t.v * N[0] * Ce : Zt += I.t.v * N * Ce);
              Te = !1;
            }
          for (Zt && (Zt += Pe); ue < T; )
            k[ue].animatorJustifyOffset = Zt, ue += 1;
        }
        for (T = 0; T < S; T += 1) {
          if (s.reset(), $t = 1, k[T].n)
            g = 0, M += t.yOffset, M += Z ? 1 : 0, P = Nt, Z = !1, this._hasMaskedPath && (a = Wt, h = ie, u = v[a].points, n = u[h - 1], E = u[h], d = E.partialLength, p = 0), ye = "", xe = "", ke = "", Ae = "", Se = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (he !== k[T].line) {
                switch (t.j) {
                  case 1:
                    P += b - t.lineWidths[k[T].line];
                    break;
                  case 2:
                    P += (b - t.lineWidths[k[T].line]) / 2;
                    break;
                }
                he = k[T].line;
              }
              vt !== k[T].ind && (k[vt] && (P += k[vt].extra), P += k[T].an / 2, vt = k[T].ind), P += i[0] * k[T].an * 5e-3;
              var ce = 0;
              for (x = 0; x < V; x += 1)
                I = r[x].a, I.p.propType && (w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), N.length ? ce += I.p.v[0] * N[0] : ce += I.p.v[0] * N), I.a.propType && (w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), N.length ? ce += I.a.v[0] * N[0] : ce += I.a.v[0] * N);
              for (f = !0, this._pathData.a.v && (P = k[0].an * 0.5 + (b - this._pathData.f.v - k[0].an * 0.5 - k[k.length - 1].an * 0.5) * vt / (S - 1), P += this._pathData.f.v); f; )
                p + d >= P + ce || !u ? (B = (P + ce - p) / E.partialLength, St = n.point[0] + (E.point[0] - n.point[0]) * B, Vt = n.point[1] + (E.point[1] - n.point[1]) * B, s.translate(-i[0] * k[T].an * 5e-3, -(i[1] * U) * 0.01), f = !1) : u && (p += E.partialLength, h += 1, h >= u.length && (h = 0, a += 1, v[a] ? u = v[a].points : X.v.c ? (h = 0, a = 0, u = v[a].points) : (p -= E.partialLength, u = null)), u && (n = E, E = u[h], d = E.partialLength));
              ct = k[T].an / 2 - k[T].add, s.translate(-ct, 0, 0);
            } else
              ct = k[T].an / 2 - k[T].add, s.translate(-ct, 0, 0), s.translate(-i[0] * k[T].an * 5e-3, -i[1] * U * 0.01, 0);
            for (x = 0; x < V; x += 1)
              I = r[x].a, I.t.propType && (w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), (g !== 0 || t.j !== 0) && (this._hasMaskedPath ? N.length ? P += I.t.v * N[0] : P += I.t.v * N : N.length ? g += I.t.v * N[0] : g += I.t.v * N));
            for (t.strokeWidthAnim && (re = t.sw || 0), t.strokeColorAnim && (t.sc ? Bt = [t.sc[0], t.sc[1], t.sc[2]] : Bt = [0, 0, 0]), t.fillColorAnim && t.fc && (J = [t.fc[0], t.fc[1], t.fc[2]]), x = 0; x < V; x += 1)
              I = r[x].a, I.a.propType && (w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), N.length ? s.translate(-I.a.v[0] * N[0], -I.a.v[1] * N[1], I.a.v[2] * N[2]) : s.translate(-I.a.v[0] * N, -I.a.v[1] * N, I.a.v[2] * N));
            for (x = 0; x < V; x += 1)
              I = r[x].a, I.s.propType && (w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), N.length ? s.scale(1 + (I.s.v[0] - 1) * N[0], 1 + (I.s.v[1] - 1) * N[1], 1) : s.scale(1 + (I.s.v[0] - 1) * N, 1 + (I.s.v[1] - 1) * N, 1));
            for (x = 0; x < V; x += 1) {
              if (I = r[x].a, w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), I.sk.propType && (N.length ? s.skewFromAxis(-I.sk.v * N[0], I.sa.v * N[1]) : s.skewFromAxis(-I.sk.v * N, I.sa.v * N)), I.r.propType && (N.length ? s.rotateZ(-I.r.v * N[2]) : s.rotateZ(-I.r.v * N)), I.ry.propType && (N.length ? s.rotateY(I.ry.v * N[1]) : s.rotateY(I.ry.v * N)), I.rx.propType && (N.length ? s.rotateX(I.rx.v * N[0]) : s.rotateX(I.rx.v * N)), I.o.propType && (N.length ? $t += (I.o.v * N[0] - $t) * N[0] : $t += (I.o.v * N - $t) * N), t.strokeWidthAnim && I.sw.propType && (N.length ? re += I.sw.v * N[0] : re += I.sw.v * N), t.strokeColorAnim && I.sc.propType)
                for (Tt = 0; Tt < 3; Tt += 1)
                  N.length ? Bt[Tt] += (I.sc.v[Tt] - Bt[Tt]) * N[0] : Bt[Tt] += (I.sc.v[Tt] - Bt[Tt]) * N;
              if (t.fillColorAnim && t.fc) {
                if (I.fc.propType)
                  for (Tt = 0; Tt < 3; Tt += 1)
                    N.length ? J[Tt] += (I.fc.v[Tt] - J[Tt]) * N[0] : J[Tt] += (I.fc.v[Tt] - J[Tt]) * N;
                I.fh.propType && (N.length ? J = ft(J, I.fh.v * N[0]) : J = ft(J, I.fh.v * N)), I.fs.propType && (N.length ? J = G(J, I.fs.v * N[0]) : J = G(J, I.fs.v * N)), I.fb.propType && (N.length ? J = Q(J, I.fb.v * N[0]) : J = Q(J, I.fb.v * N));
              }
            }
            for (x = 0; x < V; x += 1)
              I = r[x].a, I.p.propType && (w = r[x].s, N = w.getMult(k[T].anIndexes[x], o.a[x].s.totalChars), this._hasMaskedPath ? N.length ? s.translate(0, I.p.v[1] * N[0], -I.p.v[2] * N[1]) : s.translate(0, I.p.v[1] * N, -I.p.v[2] * N) : N.length ? s.translate(I.p.v[0] * N[0], I.p.v[1] * N[1], -I.p.v[2] * N[2]) : s.translate(I.p.v[0] * N, I.p.v[1] * N, -I.p.v[2] * N));
            if (t.strokeWidthAnim && (ke = re < 0 ? 0 : re), t.strokeColorAnim && (we = "rgb(" + Math.round(Bt[0] * 255) + "," + Math.round(Bt[1] * 255) + "," + Math.round(Bt[2] * 255) + ")"), t.fillColorAnim && t.fc && (xe = "rgb(" + Math.round(J[0] * 255) + "," + Math.round(J[1] * 255) + "," + Math.round(J[2] * 255) + ")"), this._hasMaskedPath) {
              if (s.translate(0, -t.ls), s.translate(0, i[1] * U * 0.01 + M, 0), this._pathData.p.v) {
                $ = (E.point[1] - n.point[1]) / (E.point[0] - n.point[0]);
                var Ne = Math.atan($) * 180 / Math.PI;
                E.point[0] < n.point[0] && (Ne += 180), s.rotate(-Ne * Math.PI / 180);
              }
              s.translate(St, Vt, 0), P -= i[0] * k[T].an * 5e-3, k[T + 1] && vt !== k[T + 1].ind && (P += k[T].an / 2, P += t.tr * 1e-3 * t.finalSize);
            } else {
              switch (s.translate(g, M, 0), t.ps && s.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
                case 1:
                  s.translate(k[T].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[k[T].line]), 0, 0);
                  break;
                case 2:
                  s.translate(k[T].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[k[T].line]) / 2, 0, 0);
                  break;
              }
              s.translate(0, -t.ls), s.translate(ct, 0, 0), s.translate(i[0] * k[T].an * 5e-3, i[1] * U * 0.01, 0), g += k[T].l + t.tr * 1e-3 * t.finalSize;
            }
            m === "html" ? ye = s.toCSS() : m === "svg" ? ye = s.to2dCSS() : Se = [s.props[0], s.props[1], s.props[2], s.props[3], s.props[4], s.props[5], s.props[6], s.props[7], s.props[8], s.props[9], s.props[10], s.props[11], s.props[12], s.props[13], s.props[14], s.props[15]], Ae = $t;
          }
          C <= T ? (H = new $i(Ae, ke, we, xe, ye, Se), this.renderedLetters.push(H), C += 1, this.lettersChangedFlag = !0) : (H = this.renderedLetters[T], this.lettersChangedFlag = H.update(Ae, ke, we, xe, ye, Se) || this.lettersChangedFlag);
        }
      }
    }, Oe.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, Oe.prototype.mHelper = new At(), Oe.prototype.defaultPropsArray = [], _t([st], Oe);
    function ns(t, e, i) {
      var r = { propType: !1 }, o = D.getProp, s = e.a;
      this.a = {
        r: s.r ? o(t, s.r, 0, ht, i) : r,
        rx: s.rx ? o(t, s.rx, 0, ht, i) : r,
        ry: s.ry ? o(t, s.ry, 0, ht, i) : r,
        sk: s.sk ? o(t, s.sk, 0, ht, i) : r,
        sa: s.sa ? o(t, s.sa, 0, ht, i) : r,
        s: s.s ? o(t, s.s, 1, 0.01, i) : r,
        a: s.a ? o(t, s.a, 1, 0, i) : r,
        o: s.o ? o(t, s.o, 0, 0.01, i) : r,
        p: s.p ? o(t, s.p, 1, 0, i) : r,
        sw: s.sw ? o(t, s.sw, 0, 0, i) : r,
        sc: s.sc ? o(t, s.sc, 1, 0, i) : r,
        fc: s.fc ? o(t, s.fc, 1, 0, i) : r,
        fh: s.fh ? o(t, s.fh, 0, 0, i) : r,
        fs: s.fs ? o(t, s.fs, 0, 0.01, i) : r,
        fb: s.fb ? o(t, s.fb, 0, 0.01, i) : r,
        t: s.t ? o(t, s.t, 0, 0, i) : r
      }, this.s = as.getTextSelectorProp(t, e.s, i), this.s.t = e.s.t;
    }
    function $i(t, e, i, r, o, s) {
      this.o = t, this.sw = e, this.sc = i, this.fc = r, this.m = o, this.p = s, this._mdf = {
        o: !0,
        sw: !!e,
        sc: !!i,
        fc: !!r,
        m: !0,
        p: !0
      };
    }
    $i.prototype.update = function(t, e, i, r, o, s) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var m = !1;
      return this.o !== t && (this.o = t, this._mdf.o = !0, m = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, m = !0), this.sc !== i && (this.sc = i, this._mdf.sc = !0, m = !0), this.fc !== r && (this.fc = r, this._mdf.fc = !0, m = !0), this.m !== o && (this.m = o, this._mdf.m = !0, m = !0), s.length && (this.p[0] !== s[0] || this.p[1] !== s[1] || this.p[4] !== s[4] || this.p[5] !== s[5] || this.p[12] !== s[12] || this.p[13] !== s[13]) && (this.p = s, this._mdf.p = !0, m = !0), m;
    };
    function Gt(t, e) {
      this._frameId = F, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    Gt.prototype.defaultBoxWidth = [0, 0], Gt.prototype.copyData = function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      return t;
    }, Gt.prototype.setCurrentData = function(t) {
      t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, Gt.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, Gt.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, Gt.prototype.addEffect = function(t) {
      this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
    }, Gt.prototype.getValue = function(t) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !t)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var e = this.currentData, i = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var r, o = this.effectsSequence.length, s = t || this.data.d.k[this.keysIndex].s;
        for (r = 0; r < o; r += 1)
          i !== this.keysIndex ? s = this.effectsSequence[r](s, s.t) : s = this.effectsSequence[r](this.currentData, s.t);
        e !== s && this.setCurrentData(s), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, Gt.prototype.getKeyframeValue = function() {
      for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, i = 0, r = t.length; i <= r - 1 && !(i === r - 1 || t[i + 1].t > e); )
        i += 1;
      return this.keysIndex !== i && (this.keysIndex = i), this.data.d.k[this.keysIndex].s;
    }, Gt.prototype.buildFinalText = function(t) {
      for (var e = [], i = 0, r = t.length, o, s, m = !1; i < r; )
        o = t.charCodeAt(i), Fe.isCombinedCharacter(o) ? e[e.length - 1] += t.charAt(i) : o >= 55296 && o <= 56319 ? (s = t.charCodeAt(i + 1), s >= 56320 && s <= 57343 ? (m || Fe.isModifier(o, s) ? (e[e.length - 1] += t.substr(i, 2), m = !1) : e.push(t.substr(i, 2)), i += 1) : e.push(t.charAt(i))) : o > 56319 ? (s = t.charCodeAt(i + 1), Fe.isZeroWidthJoiner(o, s) ? (m = !0, e[e.length - 1] += t.substr(i, 2), i += 1) : e.push(t.charAt(i))) : Fe.isZeroWidthJoiner(o) ? (e[e.length - 1] += t.charAt(i), m = !0) : e.push(t.charAt(i)), i += 1;
      return e;
    }, Gt.prototype.completeTextData = function(t) {
      t.__complete = !0;
      var e = this.elem.globalData.fontManager, i = this.data, r = [], o, s, m, C = 0, g, M = i.m.g, T = 0, S = 0, k = 0, _ = [], P = 0, E = 0, p, f, h = e.getFontByName(t.f), a, n = 0, u = fi(h);
      t.fWeight = u.weight, t.fStyle = u.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), s = t.finalText.length, t.finalLineHeight = t.lh;
      var v = t.tr / 1e3 * t.finalSize, d;
      if (t.sz)
        for (var b = !0, B = t.sz[0], $ = t.sz[1], X, q; b; ) {
          q = this.buildFinalText(t.t), X = 0, P = 0, s = q.length, v = t.tr / 1e3 * t.finalSize;
          var K = -1;
          for (o = 0; o < s; o += 1)
            d = q[o].charCodeAt(0), m = !1, q[o] === " " ? K = o : (d === 13 || d === 3) && (P = 0, m = !0, X += t.finalLineHeight || t.finalSize * 1.2), e.chars ? (a = e.getCharData(q[o], h.fStyle, h.fFamily), n = m ? 0 : a.w * t.finalSize / 100) : n = e.measureText(q[o], t.f, t.finalSize), P + n > B && q[o] !== " " ? (K === -1 ? s += 1 : o = K, X += t.finalLineHeight || t.finalSize * 1.2, q.splice(o, K === o ? 1 : 0, "\r"), K = -1, P = 0) : (P += n, P += v);
          X += h.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && $ < X ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = q, s = t.finalText.length, b = !1);
        }
      P = -v, n = 0;
      var U = 0, Z;
      for (o = 0; o < s; o += 1)
        if (m = !1, Z = t.finalText[o], d = Z.charCodeAt(0), d === 13 || d === 3 ? (U = 0, _.push(P), E = P > E ? P : E, P = -2 * v, g = "", m = !0, k += 1) : g = Z, e.chars ? (a = e.getCharData(Z, h.fStyle, e.getFontByName(t.f).fFamily), n = m ? 0 : a.w * t.finalSize / 100) : n = e.measureText(g, t.f, t.finalSize), Z === " " ? U += n + v : (P += n + v + U, U = 0), r.push({
          l: n,
          an: n,
          add: T,
          n: m,
          anIndexes: [],
          val: g,
          line: k,
          animatorJustifyOffset: 0
        }), M == 2) {
          if (T += n, g === "" || g === " " || o === s - 1) {
            for ((g === "" || g === " ") && (T -= n); S <= o; )
              r[S].an = T, r[S].ind = C, r[S].extra = n, S += 1;
            C += 1, T = 0;
          }
        } else if (M == 3) {
          if (T += n, g === "" || o === s - 1) {
            for (g === "" && (T -= n); S <= o; )
              r[S].an = T, r[S].ind = C, r[S].extra = n, S += 1;
            T = 0, C += 1;
          }
        } else
          r[C].ind = C, r[C].extra = 0, C += 1;
      if (t.l = r, E = P > E ? P : E, _.push(P), t.sz)
        t.boxWidth = t.sz[0], t.justifyOffset = 0;
      else
        switch (t.boxWidth = E, t.j) {
          case 1:
            t.justifyOffset = -t.boxWidth;
            break;
          case 2:
            t.justifyOffset = -t.boxWidth / 2;
            break;
          default:
            t.justifyOffset = 0;
        }
      t.lineWidths = _;
      var I = i.a, w, x;
      f = I.length;
      var V, H, N = [];
      for (p = 0; p < f; p += 1) {
        for (w = I[p], w.a.sc && (t.strokeColorAnim = !0), w.a.sw && (t.strokeWidthAnim = !0), (w.a.fc || w.a.fh || w.a.fs || w.a.fb) && (t.fillColorAnim = !0), H = 0, V = w.s.b, o = 0; o < s; o += 1)
          x = r[o], x.anIndexes[p] = H, (V == 1 && x.val !== "" || V == 2 && x.val !== "" && x.val !== " " || V == 3 && (x.n || x.val == " " || o == s - 1) || V == 4 && (x.n || o == s - 1)) && (w.s.rn === 1 && N.push(H), H += 1);
        i.a[p].s.totalChars = H;
        var vt = -1, ct;
        if (w.s.rn === 1)
          for (o = 0; o < s; o += 1)
            x = r[o], vt != x.anIndexes[p] && (vt = x.anIndexes[p], ct = N.splice(Math.floor(Math.random() * N.length), 1)[0]), x.anIndexes[p] = ct;
      }
      t.yOffset = t.finalLineHeight || t.finalSize * 1.2, t.ls = t.ls || 0, t.ascent = h.ascent * t.finalSize / 100;
    }, Gt.prototype.updateDocumentData = function(t, e) {
      e = e === void 0 ? this.keysIndex : e;
      var i = this.copyData({}, this.data.d.k[e].s);
      i = this.copyData(i, t), this.data.d.k[e].s = i, this.recalculate(e), this.elem.addDynamicProperty(this);
    }, Gt.prototype.recalculate = function(t) {
      var e = this.data.d.k[t].s;
      e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
    }, Gt.prototype.canResizeFont = function(t) {
      this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, Gt.prototype.setMinimumFontSize = function(t) {
      this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var as = function() {
      var t = Math.max, e = Math.min, i = Math.floor;
      function r(s, m) {
        this._currentTextLength = -1, this.k = !1, this.data = m, this.elem = s, this.comp = s.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(s), this.s = D.getProp(s, m.s || { k: 0 }, 0, 0, this), "e" in m ? this.e = D.getProp(s, m.e, 0, 0, this) : this.e = { v: 100 }, this.o = D.getProp(s, m.o || { k: 0 }, 0, 0, this), this.xe = D.getProp(s, m.xe || { k: 0 }, 0, 0, this), this.ne = D.getProp(s, m.ne || { k: 0 }, 0, 0, this), this.sm = D.getProp(s, m.sm || { k: 100 }, 0, 0, this), this.a = D.getProp(s, m.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      r.prototype = {
        getMult: function(s) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var m = 0, C = 0, g = 1, M = 1;
          this.ne.v > 0 ? m = this.ne.v / 100 : C = -this.ne.v / 100, this.xe.v > 0 ? g = 1 - this.xe.v / 100 : M = 1 + this.xe.v / 100;
          var T = ae.getBezierEasing(m, C, g, M).get, S = 0, k = this.finalS, _ = this.finalE, P = this.data.sh;
          if (P === 2)
            _ === k ? S = s >= _ ? 1 : 0 : S = t(0, e(0.5 / (_ - k) + (s - k) / (_ - k), 1)), S = T(S);
          else if (P === 3)
            _ === k ? S = s >= _ ? 0 : 1 : S = 1 - t(0, e(0.5 / (_ - k) + (s - k) / (_ - k), 1)), S = T(S);
          else if (P === 4)
            _ === k ? S = 0 : (S = t(0, e(0.5 / (_ - k) + (s - k) / (_ - k), 1)), S < 0.5 ? S *= 2 : S = 1 - 2 * (S - 0.5)), S = T(S);
          else if (P === 5) {
            if (_ === k)
              S = 0;
            else {
              var E = _ - k;
              s = e(t(0, s + 0.5 - k), _ - k);
              var p = -E / 2 + s, f = E / 2;
              S = Math.sqrt(1 - p * p / (f * f));
            }
            S = T(S);
          } else
            P === 6 ? (_ === k ? S = 0 : (s = e(t(0, s + 0.5 - k), _ - k), S = (1 + Math.cos(Math.PI + Math.PI * 2 * s / (_ - k))) / 2), S = T(S)) : (s >= i(k) && (s - k < 0 ? S = t(0, e(e(_, 1) - (k - s), 1)) : S = t(0, e(_ - s, 1))), S = T(S));
          if (this.sm.v !== 100) {
            var h = this.sm.v * 0.01;
            h === 0 && (h = 1e-8);
            var a = 0.5 - h * 0.5;
            S < a ? S = 0 : (S = (S - a) / h, S > 1 && (S = 1));
          }
          return S * this.a.v;
        },
        getValue: function(s) {
          this.iterateDynamicProperties(), this._mdf = s || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, s && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var m = this.data.r === 2 ? 1 : 100 / this.data.totalChars, C = this.o.v / m, g = this.s.v / m + C, M = this.e.v / m + C;
          if (g > M) {
            var T = g;
            g = M, M = T;
          }
          this.finalS = g, this.finalE = M;
        }
      }, _t([st], r);
      function o(s, m, C) {
        return new r(s, m);
      }
      return {
        getTextSelectorProp: o
      };
    }(), pi = function() {
      return function(t, e, i) {
        var r = 0, o = t, s = it(o), m = {
          newElement: C,
          release: g
        };
        function C() {
          var M;
          return r ? (r -= 1, M = s[r]) : M = e(), M;
        }
        function g(M) {
          r === o && (s = lr.double(s), o *= 2), i && i(M), s[r] = M, r += 1;
        }
        return m;
      };
    }(), lr = function() {
      function t(e) {
        return e.concat(it(e.length));
      }
      return {
        double: t
      };
    }(), Re = function() {
      function t() {
        return et("float32", 2);
      }
      return pi(8, t);
    }(), Ut = function() {
      function t() {
        return new ee();
      }
      function e(o) {
        var s = o._length, m;
        for (m = 0; m < s; m += 1)
          Re.release(o.v[m]), Re.release(o.i[m]), Re.release(o.o[m]), o.v[m] = null, o.i[m] = null, o.o[m] = null;
        o._length = 0, o.c = !1;
      }
      function i(o) {
        var s = r.newElement(), m, C = o._length === void 0 ? o.v.length : o._length;
        for (s.setLength(C), s.c = o.c, m = 0; m < C; m += 1)
          s.setTripleAt(o.v[m][0], o.v[m][1], o.o[m][0], o.o[m][1], o.i[m][0], o.i[m][1], m);
        return s;
      }
      var r = pi(4, t, e);
      return r.clone = i, r;
    }(), qe = function() {
      var t = {
        newShapeCollection: o,
        release: s
      }, e = 0, i = 4, r = it(i);
      function o() {
        var m;
        return e ? (e -= 1, m = r[e]) : m = new Ni(), m;
      }
      function s(m) {
        var C, g = m._length;
        for (C = 0; C < g; C += 1)
          Ut.release(m.shapes[C]);
        m._length = 0, e === i && (r = lr.double(r), i *= 2), r[e] = m, e += 1;
      }
      return t;
    }(), fr = function() {
      function t() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function e(i) {
        var r, o = i.lengths.length;
        for (r = 0; r < o; r += 1)
          ur.release(i.lengths[r]);
        i.lengths.length = 0;
      }
      return pi(8, t, e);
    }(), ur = function() {
      function t() {
        return {
          addedLength: 0,
          percents: et("float32", nt),
          lengths: et("float32", nt)
        };
      }
      return pi(8, t);
    }(), os = function() {
      function t(e) {
        for (var i = e.split(`\r
`), r = {}, o, s = 0, m = 0; m < i.length; m += 1)
          o = i[m].split(":"), o.length === 2 && (r[o[0]] = o[1].trim(), s += 1);
        if (s === 0)
          throw new Error();
        return r;
      }
      return function(e) {
        for (var i = [], r = 0; r < e.length; r += 1) {
          var o = e[r], s = {
            time: o.tm,
            duration: o.dr
          };
          try {
            s.payload = JSON.parse(e[r].cm);
          } catch {
            try {
              s.payload = t(e[r].cm);
            } catch {
              s.payload = {
                name: e[r]
              };
            }
          }
          i.push(s);
        }
        return i;
      };
    }();
    function Ht() {
    }
    Ht.prototype.checkLayers = function(t) {
      var e, i = this.layers.length, r;
      for (this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)
        this.elements[e] || (r = this.layers[e], r.ip - r.st <= t - this.layers[e].st && r.op - r.st > t - this.layers[e].st && this.buildItem(e)), this.completeLayers = this.elements[e] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, Ht.prototype.createItem = function(t) {
      switch (t.ty) {
        case 2:
          return this.createImage(t);
        case 0:
          return this.createComp(t);
        case 1:
          return this.createSolid(t);
        case 3:
          return this.createNull(t);
        case 4:
          return this.createShape(t);
        case 5:
          return this.createText(t);
        case 6:
          return this.createAudio(t);
        case 13:
          return this.createCamera(t);
        case 15:
          return this.createFootage(t);
        default:
          return this.createNull(t);
      }
    }, Ht.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, Ht.prototype.createAudio = function(t) {
      return new Kt(t, this.globalData, this);
    }, Ht.prototype.createFootage = function(t) {
      return new FootageElement(t, this.globalData, this);
    }, Ht.prototype.buildAllItems = function() {
      var t, e = this.layers.length;
      for (t = 0; t < e; t += 1)
        this.buildItem(t);
      this.checkPendingElements();
    }, Ht.prototype.includeLayers = function(t) {
      this.completeLayers = !1;
      var e, i = t.length, r, o = this.layers.length;
      for (e = 0; e < i; e += 1)
        for (r = 0; r < o; ) {
          if (this.layers[r].id === t[e].id) {
            this.layers[r] = t[e];
            break;
          }
          r += 1;
        }
    }, Ht.prototype.setProjectInterface = function(t) {
      this.globalData.projectInterface = t;
    }, Ht.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, Ht.prototype.buildElementParenting = function(t, e, i) {
      for (var r = this.elements, o = this.layers, s = 0, m = o.length; s < m; )
        o[s].ind == e && (!r[s] || r[s] === !0 ? (this.buildItem(s), this.addPendingElement(t)) : (i.push(r[s]), r[s].setAsParent(), o[s].parent !== void 0 ? this.buildElementParenting(t, o[s].parent, i) : t.setHierarchy(i))), s += 1;
    }, Ht.prototype.addPendingElement = function(t) {
      this.pendingElements.push(t);
    }, Ht.prototype.searchExtraCompositions = function(t) {
      var e, i = t.length;
      for (e = 0; e < i; e += 1)
        if (t[e].xt) {
          var r = this.createComp(t[e]);
          r.initExpressions(), this.globalData.projectInterface.registerComposition(r);
        }
    }, Ht.prototype.setupGlobalData = function(t, e) {
      this.globalData.fontManager = new Fe(), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
        w: t.w,
        h: t.h
      };
    };
    function Dt(t, e) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = W("svg");
      var i = "";
      if (e && e.title) {
        var r = W("title"), o = Ft();
        r.setAttribute("id", o), r.textContent = e.title, this.svgElement.appendChild(r), i += o;
      }
      if (e && e.description) {
        var s = W("desc"), m = Ft();
        s.setAttribute("id", m), s.textContent = e.description, this.svgElement.appendChild(s), i += " " + m;
      }
      i && this.svgElement.setAttribute("aria-labelledby", i);
      var C = W("defs");
      this.svgElement.appendChild(C);
      var g = W("g");
      this.svgElement.appendChild(g), this.layerElement = g, this.renderConfig = {
        preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
        progressiveLoad: e && e.progressiveLoad || !1,
        hideOnTransparent: !(e && e.hideOnTransparent === !1),
        viewBoxOnly: e && e.viewBoxOnly || !1,
        viewBoxSize: e && e.viewBoxSize || !1,
        className: e && e.className || "",
        id: e && e.id || "",
        focusable: e && e.focusable,
        filterSize: {
          width: e && e.filterSize && e.filterSize.width || "100%",
          height: e && e.filterSize && e.filterSize.height || "100%",
          x: e && e.filterSize && e.filterSize.x || "0%",
          y: e && e.filterSize && e.filterSize.y || "0%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: C,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    _t([Ht], Dt), Dt.prototype.createNull = function(t) {
      return new Ee(t, this.globalData, this);
    }, Dt.prototype.createShape = function(t) {
      return new Rt(t, this.globalData, this);
    }, Dt.prototype.createText = function(t) {
      return new je(t, this.globalData, this);
    }, Dt.prototype.createImage = function(t) {
      return new ri(t, this.globalData, this);
    }, Dt.prototype.createComp = function(t) {
      return new gr(t, this.globalData, this);
    }, Dt.prototype.createSolid = function(t) {
      return new Gi(t, this.globalData, this);
    }, Dt.prototype.configAnimation = function(t) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)"), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var e = this.globalData.defs;
      this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
      var i = W("clipPath"), r = W("rect");
      r.setAttribute("width", t.w), r.setAttribute("height", t.h), r.setAttribute("x", 0), r.setAttribute("y", 0);
      var o = Ft();
      i.setAttribute("id", o), i.appendChild(r), this.layerElement.setAttribute("clip-path", "url(" + A + "#" + o + ")"), e.appendChild(i), this.layers = t.layers, this.elements = it(t.layers.length);
    }, Dt.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var t, e = this.layers ? this.layers.length : 0;
      for (t = 0; t < e; t += 1)
        this.elements[t] && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, Dt.prototype.updateContainerSize = function() {
    }, Dt.prototype.buildItem = function(t) {
      var e = this.elements;
      if (!(e[t] || this.layers[t].ty === 99)) {
        e[t] = !0;
        var i = this.createItem(this.layers[t]);
        e[t] = i, R && (this.layers[t].ty === 0 && this.globalData.projectInterface.registerComposition(i), i.initExpressions()), this.appendElementInPos(i, t), this.layers[t].tt && (!this.elements[t - 1] || this.elements[t - 1] === !0 ? (this.buildItem(t - 1), this.addPendingElement(i)) : i.setMatte(e[t - 1].layerId));
      }
    }, Dt.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var t = this.pendingElements.pop();
        if (t.checkParenting(), t.data.tt)
          for (var e = 0, i = this.elements.length; e < i; ) {
            if (this.elements[e] === t) {
              t.setMatte(this.elements[e - 1].layerId);
              break;
            }
            e += 1;
          }
      }
    }, Dt.prototype.renderFrame = function(t) {
      if (!(this.renderedFrame === t || this.destroyed)) {
        t === null ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
        var e, i = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), e = i - 1; e >= 0; e -= 1)
          (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
        if (this.globalData._mdf)
          for (e = 0; e < i; e += 1)
            (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
      }
    }, Dt.prototype.appendElementInPos = function(t, e) {
      var i = t.getBaseElement();
      if (!!i) {
        for (var r = 0, o; r < e; )
          this.elements[r] && this.elements[r] !== !0 && this.elements[r].getBaseElement() && (o = this.elements[r].getBaseElement()), r += 1;
        o ? this.layerElement.insertBefore(i, o) : this.layerElement.appendChild(i);
      }
    }, Dt.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, Dt.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function Ve(t, e, i) {
      this.data = t, this.element = e, this.globalData = i, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var r = this.globalData.defs, o, s = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = it(s), this.solidPath = "";
      var m, C = this.masksProperties, g = 0, M = [], T, S, k = Ft(), _, P, E, p, f = "clipPath", h = "clip-path";
      for (o = 0; o < s; o += 1)
        if ((C[o].mode !== "a" && C[o].mode !== "n" || C[o].inv || C[o].o.k !== 100 || C[o].o.x) && (f = "mask", h = "mask"), (C[o].mode === "s" || C[o].mode === "i") && g === 0 ? (_ = W("rect"), _.setAttribute("fill", "#ffffff"), _.setAttribute("width", this.element.comp.data.w || 0), _.setAttribute("height", this.element.comp.data.h || 0), M.push(_)) : _ = null, m = W("path"), C[o].mode === "n")
          this.viewData[o] = {
            op: D.getProp(this.element, C[o].o, 0, 0.01, this.element),
            prop: Le.getShapeProp(this.element, C[o], 3),
            elem: m,
            lastPath: ""
          }, r.appendChild(m);
        else {
          g += 1, m.setAttribute("fill", C[o].mode === "s" ? "#000000" : "#ffffff"), m.setAttribute("clip-rule", "nonzero");
          var a;
          if (C[o].x.k !== 0 ? (f = "mask", h = "mask", p = D.getProp(this.element, C[o].x, 0, null, this.element), a = Ft(), P = W("filter"), P.setAttribute("id", a), E = W("feMorphology"), E.setAttribute("operator", "erode"), E.setAttribute("in", "SourceGraphic"), E.setAttribute("radius", "0"), P.appendChild(E), r.appendChild(P), m.setAttribute("stroke", C[o].mode === "s" ? "#000000" : "#ffffff")) : (E = null, p = null), this.storedData[o] = {
            elem: m,
            x: p,
            expan: E,
            lastPath: "",
            lastOperator: "",
            filterId: a,
            lastRadius: 0
          }, C[o].mode === "i") {
            S = M.length;
            var n = W("g");
            for (T = 0; T < S; T += 1)
              n.appendChild(M[T]);
            var u = W("mask");
            u.setAttribute("mask-type", "alpha"), u.setAttribute("id", k + "_" + g), u.appendChild(m), r.appendChild(u), n.setAttribute("mask", "url(" + A + "#" + k + "_" + g + ")"), M.length = 0, M.push(n);
          } else
            M.push(m);
          C[o].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[o] = {
            elem: m,
            lastPath: "",
            op: D.getProp(this.element, C[o].o, 0, 0.01, this.element),
            prop: Le.getShapeProp(this.element, C[o], 3),
            invRect: _
          }, this.viewData[o].prop.k || this.drawPath(C[o], this.viewData[o].prop.v, this.viewData[o]);
        }
      for (this.maskElement = W(f), s = M.length, o = 0; o < s; o += 1)
        this.maskElement.appendChild(M[o]);
      g > 0 && (this.maskElement.setAttribute("id", k), this.element.maskedElement.setAttribute(h, "url(" + A + "#" + k + ")"), r.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    Ve.prototype.getMaskProperty = function(t) {
      return this.viewData[t].prop;
    }, Ve.prototype.renderFrame = function(t) {
      var e = this.element.finalTransform.mat, i, r = this.masksProperties.length;
      for (i = 0; i < r; i += 1)
        if ((this.viewData[i].prop._mdf || t) && this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]), (this.viewData[i].op._mdf || t) && this.viewData[i].elem.setAttribute("fill-opacity", this.viewData[i].op.v), this.masksProperties[i].mode !== "n" && (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[i].invRect.setAttribute("transform", e.getInverseMatrix().to2dCSS()), this.storedData[i].x && (this.storedData[i].x._mdf || t))) {
          var o = this.storedData[i].expan;
          this.storedData[i].x.v < 0 ? (this.storedData[i].lastOperator !== "erode" && (this.storedData[i].lastOperator = "erode", this.storedData[i].elem.setAttribute("filter", "url(" + A + "#" + this.storedData[i].filterId + ")")), o.setAttribute("radius", -this.storedData[i].x.v)) : (this.storedData[i].lastOperator !== "dilate" && (this.storedData[i].lastOperator = "dilate", this.storedData[i].elem.setAttribute("filter", null)), this.storedData[i].elem.setAttribute("stroke-width", this.storedData[i].x.v * 2));
        }
    }, Ve.prototype.getMaskelement = function() {
      return this.maskElement;
    }, Ve.prototype.createLayerSolidPath = function() {
      var t = "M0,0 ";
      return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ", t;
    }, Ve.prototype.drawPath = function(t, e, i) {
      var r = " M" + e.v[0][0] + "," + e.v[0][1], o, s;
      for (s = e._length, o = 1; o < s; o += 1)
        r += " C" + e.o[o - 1][0] + "," + e.o[o - 1][1] + " " + e.i[o][0] + "," + e.i[o][1] + " " + e.v[o][0] + "," + e.v[o][1];
      if (e.c && s > 1 && (r += " C" + e.o[o - 1][0] + "," + e.o[o - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), i.lastPath !== r) {
        var m = "";
        i.elem && (e.c && (m = t.inv ? this.solidPath + r : r), i.elem.setAttribute("d", m)), i.lastPath = r;
      }
    }, Ve.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    function Ge() {
    }
    Ge.prototype = {
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      setHierarchy: function(t) {
        this.hierarchy = t;
      },
      setAsParent: function() {
        this._isParent = !0;
      },
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function Be() {
    }
    Be.prototype = {
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      prepareProperties: function(t, e) {
        var i, r = this.dynamicProperties.length;
        for (i = 0; i < r; i += 1)
          (e || this._isParent && this.dynamicProperties[i].propType === "transform") && (this.dynamicProperties[i].getValue(), this.dynamicProperties[i]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
      }
    };
    function We() {
    }
    We.prototype = {
      initTransform: function() {
        this.finalTransform = {
          mProp: this.data.ks ? Ie.getTransformProperty(this, this.data.ks, this) : { o: 0 },
          _matMdf: !1,
          _opMdf: !1,
          mat: new At()
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var t, e = this.finalTransform.mat, i = 0, r = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; i < r; ) {
              if (this.hierarchy[i].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              i += 1;
            }
          if (this.finalTransform._matMdf)
            for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), i = 0; i < r; i += 1)
              t = this.hierarchy[i].finalTransform.mProp.v.props, e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
        }
      },
      globalToLocal: function(t) {
        var e = [];
        e.push(this.finalTransform);
        for (var i = !0, r = this.comp; i; )
          r.finalTransform ? (r.data.hasMask && e.splice(0, 0, r.finalTransform), r = r.comp) : i = !1;
        var o, s = e.length, m;
        for (o = 0; o < s; o += 1)
          m = e[o].mat.applyToPointArray(0, 0, 0), t = [t[0] - m[0], t[1] - m[1], 0];
        return t;
      },
      mHelper: new At()
    };
    function qi() {
    }
    qi.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
      },
      removeRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
      },
      prepareRenderableFrame: function(t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      checkLayerLimits: function(t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var t, e = this.renderableComponents.length;
        for (t = 0; t < e; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
      }
    };
    function ei() {
    }
    (function() {
      var t = {
        initElement: function(e, i, r) {
          this.initFrame(), this.initBaseData(e, i, r), this.initTransform(e, i, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var e = this.baseElement || this.layerElement;
            e.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var e = this.baseElement || this.layerElement;
              e.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(e) {
          this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      _t([qi, Bi(t)], ei);
    })();
    function hs(t, e) {
      this.elem = t, this.pos = e;
    }
    function cr(t, e) {
      this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = t.hd === !0, this.pElem = W("path"), this.msElem = null;
    }
    cr.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function pr(t, e, i) {
      this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = i, this.lvl = e, this._isAnimated = !!i.k;
      for (var r = 0, o = t.length; r < o; ) {
        if (t[r].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        r += 1;
      }
    }
    pr.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function ls(t, e, i) {
      this.transform = {
        mProps: t,
        op: e,
        container: i
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    function dr(t, e, i) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = D.getProp(t, e.o, 0, 0.01, this), this.w = D.getProp(t, e.w, 0, null, this), this.d = new ui(t, e.d || {}, "svg", this), this.c = D.getProp(t, e.c, 1, 255, this), this.style = i, this._isAnimated = !!this._isAnimated;
    }
    _t([st], dr);
    function vr(t, e, i) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = D.getProp(t, e.o, 0, 0.01, this), this.c = D.getProp(t, e.c, 1, 255, this), this.style = i;
    }
    _t([st], vr);
    function Ye(t, e, i) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, i);
    }
    Ye.prototype.initGradientData = function(t, e, i) {
      this.o = D.getProp(t, e.o, 0, 0.01, this), this.s = D.getProp(t, e.s, 1, null, this), this.e = D.getProp(t, e.e, 1, null, this), this.h = D.getProp(t, e.h || { k: 0 }, 0, 0.01, this), this.a = D.getProp(t, e.a || { k: 0 }, 0, ht, this), this.g = new ti(t, e.g, this), this.style = i, this.stops = [], this.setGradientData(i.pElem, e), this.setGradientOpacity(e, i), this._isAnimated = !!this._isAnimated;
    }, Ye.prototype.setGradientData = function(t, e) {
      var i = Ft(), r = W(e.t === 1 ? "linearGradient" : "radialGradient");
      r.setAttribute("id", i), r.setAttribute("spreadMethod", "pad"), r.setAttribute("gradientUnits", "userSpaceOnUse");
      var o = [], s, m, C;
      for (C = e.g.p * 4, m = 0; m < C; m += 4)
        s = W("stop"), r.appendChild(s), o.push(s);
      t.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + A + "#" + i + ")"), this.gf = r, this.cst = o;
    }, Ye.prototype.setGradientOpacity = function(t, e) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var i, r, o, s = W("mask"), m = W("path");
        s.appendChild(m);
        var C = Ft(), g = Ft();
        s.setAttribute("id", g);
        var M = W(t.t === 1 ? "linearGradient" : "radialGradient");
        M.setAttribute("id", C), M.setAttribute("spreadMethod", "pad"), M.setAttribute("gradientUnits", "userSpaceOnUse"), o = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
        var T = this.stops;
        for (r = t.g.p * 4; r < o; r += 2)
          i = W("stop"), i.setAttribute("stop-color", "rgb(255,255,255)"), M.appendChild(i), T.push(i);
        m.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + A + "#" + C + ")"), t.ty === "gs" && (m.setAttribute("stroke-linecap", gt[t.lc || 2]), m.setAttribute("stroke-linejoin", te[t.lj || 2]), t.lj === 1 && m.setAttribute("stroke-miterlimit", t.ml)), this.of = M, this.ms = s, this.ost = T, this.maskId = g, e.msElem = m;
      }
    }, _t([st], Ye);
    function mr(t, e, i) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = D.getProp(t, e.w, 0, null, this), this.d = new ui(t, e.d || {}, "svg", this), this.initGradientData(t, e, i), this._isAnimated = !!this._isAnimated;
    }
    _t([Ye, st], mr);
    function fs() {
      this.it = [], this.prevViewData = [], this.gr = W("g");
    }
    var us = function() {
      var t = new At(), e = new At(), i = {
        createRenderFunction: r
      };
      function r(T) {
        switch (T.ty) {
          case "fl":
            return m;
          case "gf":
            return g;
          case "gs":
            return C;
          case "st":
            return M;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return s;
          case "tr":
            return o;
          default:
            return null;
        }
      }
      function o(T, S, k) {
        (k || S.transform.op._mdf) && S.transform.container.setAttribute("opacity", S.transform.op.v), (k || S.transform.mProps._mdf) && S.transform.container.setAttribute("transform", S.transform.mProps.v.to2dCSS());
      }
      function s(T, S, k) {
        var _, P, E, p, f, h, a = S.styles.length, n = S.lvl, u, v, d, b, B;
        for (h = 0; h < a; h += 1) {
          if (p = S.sh._mdf || k, S.styles[h].lvl < n) {
            for (v = e.reset(), b = n - S.styles[h].lvl, B = S.transformers.length - 1; !p && b > 0; )
              p = S.transformers[B].mProps._mdf || p, b -= 1, B -= 1;
            if (p)
              for (b = n - S.styles[h].lvl, B = S.transformers.length - 1; b > 0; )
                d = S.transformers[B].mProps.v.props, v.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]), b -= 1, B -= 1;
          } else
            v = t;
          if (u = S.sh.paths, P = u._length, p) {
            for (E = "", _ = 0; _ < P; _ += 1)
              f = u.shapes[_], f && f._length && (E += or(f, f._length, f.c, v));
            S.caches[h] = E;
          } else
            E = S.caches[h];
          S.styles[h].d += T.hd === !0 ? "" : E, S.styles[h]._mdf = p || S.styles[h]._mdf;
        }
      }
      function m(T, S, k) {
        var _ = S.style;
        (S.c._mdf || k) && _.pElem.setAttribute("fill", "rgb(" + rt(S.c.v[0]) + "," + rt(S.c.v[1]) + "," + rt(S.c.v[2]) + ")"), (S.o._mdf || k) && _.pElem.setAttribute("fill-opacity", S.o.v);
      }
      function C(T, S, k) {
        g(T, S, k), M(T, S, k);
      }
      function g(T, S, k) {
        var _ = S.gf, P = S.g._hasOpacity, E = S.s.v, p = S.e.v;
        if (S.o._mdf || k) {
          var f = T.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          S.style.pElem.setAttribute(f, S.o.v);
        }
        if (S.s._mdf || k) {
          var h = T.t === 1 ? "x1" : "cx", a = h === "x1" ? "y1" : "cy";
          _.setAttribute(h, E[0]), _.setAttribute(a, E[1]), P && !S.g._collapsable && (S.of.setAttribute(h, E[0]), S.of.setAttribute(a, E[1]));
        }
        var n, u, v, d;
        if (S.g._cmdf || k) {
          n = S.cst;
          var b = S.g.c;
          for (v = n.length, u = 0; u < v; u += 1)
            d = n[u], d.setAttribute("offset", b[u * 4] + "%"), d.setAttribute("stop-color", "rgb(" + b[u * 4 + 1] + "," + b[u * 4 + 2] + "," + b[u * 4 + 3] + ")");
        }
        if (P && (S.g._omdf || k)) {
          var B = S.g.o;
          for (S.g._collapsable ? n = S.cst : n = S.ost, v = n.length, u = 0; u < v; u += 1)
            d = n[u], S.g._collapsable || d.setAttribute("offset", B[u * 2] + "%"), d.setAttribute("stop-opacity", B[u * 2 + 1]);
        }
        if (T.t === 1)
          (S.e._mdf || k) && (_.setAttribute("x2", p[0]), _.setAttribute("y2", p[1]), P && !S.g._collapsable && (S.of.setAttribute("x2", p[0]), S.of.setAttribute("y2", p[1])));
        else {
          var $;
          if ((S.s._mdf || S.e._mdf || k) && ($ = Math.sqrt(Math.pow(E[0] - p[0], 2) + Math.pow(E[1] - p[1], 2)), _.setAttribute("r", $), P && !S.g._collapsable && S.of.setAttribute("r", $)), S.e._mdf || S.h._mdf || S.a._mdf || k) {
            $ || ($ = Math.sqrt(Math.pow(E[0] - p[0], 2) + Math.pow(E[1] - p[1], 2)));
            var X = Math.atan2(p[1] - E[1], p[0] - E[0]), q = S.h.v;
            q >= 1 ? q = 0.99 : q <= -1 && (q = -0.99);
            var K = $ * q, U = Math.cos(X + S.a.v) * K + E[0], Z = Math.sin(X + S.a.v) * K + E[1];
            _.setAttribute("fx", U), _.setAttribute("fy", Z), P && !S.g._collapsable && (S.of.setAttribute("fx", U), S.of.setAttribute("fy", Z));
          }
        }
      }
      function M(T, S, k) {
        var _ = S.style, P = S.d;
        P && (P._mdf || k) && P.dashStr && (_.pElem.setAttribute("stroke-dasharray", P.dashStr), _.pElem.setAttribute("stroke-dashoffset", P.dashoffset[0])), S.c && (S.c._mdf || k) && _.pElem.setAttribute("stroke", "rgb(" + rt(S.c.v[0]) + "," + rt(S.c.v[1]) + "," + rt(S.c.v[2]) + ")"), (S.o._mdf || k) && _.pElem.setAttribute("stroke-opacity", S.o.v), (S.w._mdf || k) && (_.pElem.setAttribute("stroke-width", S.w.v), _.msElem && _.msElem.setAttribute("stroke-width", S.w.v));
      }
      return i;
    }();
    function De() {
    }
    De.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
          if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1)
            return !0;
          t += 1;
        }
        return !1;
      },
      initExpressions: function() {
        this.layerInterface = LayerExpressionInterface(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
        var t = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(t), this.data.ty === 0 || this.data.xt ? this.compInterface = CompExpressionInterface(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = TextExpressionInterface(this), this.layerInterface.text = this.layerInterface.textInterface);
      },
      setBlendMode: function() {
        var t = dt(this.data.bm), e = this.baseElement || this.layerElement;
        e.style["mix-blend-mode"] = t;
      },
      initBaseData: function(t, e, i) {
        this.globalData = e, this.comp = i, this.data = t, this.layerId = Ft(), this.data.sr || (this.data.sr = 1), this.effectsManager = new ps(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function Ee(t, e, i) {
      this.initFrame(), this.initBaseData(t, e, i), this.initFrame(), this.initTransform(t, e, i), this.initHierarchy();
    }
    Ee.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, Ee.prototype.renderFrame = function() {
    }, Ee.prototype.getBaseElement = function() {
      return null;
    }, Ee.prototype.destroy = function() {
    }, Ee.prototype.sourceRectAtTime = function() {
    }, Ee.prototype.hide = function() {
    }, _t([De, We, Ge, Be], Ee);
    function ii() {
    }
    ii.prototype = {
      initRendererElement: function() {
        this.layerElement = W("g");
      },
      createContainerElements: function() {
        this.matteElement = W("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var t = null, e, i, r;
        if (this.data.td) {
          if (this.data.td == 3 || this.data.td == 1) {
            var o = W("mask");
            o.setAttribute("id", this.layerId), o.setAttribute("mask-type", this.data.td == 3 ? "luminance" : "alpha"), o.appendChild(this.layerElement), t = o, this.globalData.defs.appendChild(o), !hr.maskType && this.data.td == 1 && (o.setAttribute("mask-type", "luminance"), e = Ft(), i = ci.createFilter(e), this.globalData.defs.appendChild(i), i.appendChild(ci.createAlphaToLuminanceFilter()), r = W("g"), r.appendChild(this.layerElement), t = r, o.appendChild(r), r.setAttribute("filter", "url(" + A + "#" + e + ")"));
          } else if (this.data.td == 2) {
            var s = W("mask");
            s.setAttribute("id", this.layerId), s.setAttribute("mask-type", "alpha");
            var m = W("g");
            s.appendChild(m), e = Ft(), i = ci.createFilter(e);
            var C = W("feComponentTransfer");
            C.setAttribute("in", "SourceGraphic"), i.appendChild(C);
            var g = W("feFuncA");
            g.setAttribute("type", "table"), g.setAttribute("tableValues", "1.0 0.0"), C.appendChild(g), this.globalData.defs.appendChild(i);
            var M = W("rect");
            M.setAttribute("width", this.comp.data.w), M.setAttribute("height", this.comp.data.h), M.setAttribute("x", "0"), M.setAttribute("y", "0"), M.setAttribute("fill", "#ffffff"), M.setAttribute("opacity", "0"), m.setAttribute("filter", "url(" + A + "#" + e + ")"), m.appendChild(M), m.appendChild(this.layerElement), t = m, hr.maskType || (s.setAttribute("mask-type", "luminance"), i.appendChild(ci.createAlphaToLuminanceFilter()), r = W("g"), m.appendChild(M), r.appendChild(this.layerElement), t = r, m.appendChild(r)), this.globalData.defs.appendChild(s);
          }
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var T = W("clipPath"), S = W("path");
          S.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var k = Ft();
          if (T.setAttribute("id", k), T.appendChild(S), this.globalData.defs.appendChild(T), this.checkMasks()) {
            var _ = W("g");
            _.setAttribute("clip-path", "url(" + A + "#" + k + ")"), _.appendChild(this.layerElement), this.transformedElement = _, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + A + "#" + k + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new Ve(this.data, this, this.globalData), this.renderableEffectsManager = new cs();
      },
      setMatte: function(t) {
        !this.matteElement || this.matteElement.setAttribute("mask", "url(" + A + "#" + t + ")");
      }
    };
    function yr() {
    }
    yr.prototype = {
      addShapeToModifiers: function(t) {
        var e, i = this.shapeModifiers.length;
        for (e = 0; e < i; e += 1)
          this.shapeModifiers[e].addShape(t);
      },
      isShapeInAnimatedModifiers: function(t) {
        for (var e = 0, i = this.shapeModifiers.length; e < i; )
          if (this.shapeModifiers[e].isAnimatedWithShape(t))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (!!this.shapeModifiers.length) {
          var t, e = this.shapes.length;
          for (t = 0; t < e; t += 1)
            this.shapes[t].sh.reset();
          e = this.shapeModifiers.length;
          var i;
          for (t = e - 1; t >= 0 && (i = this.shapeModifiers[t].processShapes(this._isFirstFrame), !i); t -= 1)
            ;
        }
      },
      searchProcessedElement: function(t) {
        for (var e = this.processedElements, i = 0, r = e.length; i < r; ) {
          if (e[i].elem === t)
            return e[i].pos;
          i += 1;
        }
        return 0;
      },
      addProcessedElement: function(t, e) {
        for (var i = this.processedElements, r = i.length; r; )
          if (r -= 1, i[r].elem === t) {
            i[r].pos = e;
            return;
          }
        i.push(new hs(t, e));
      },
      prepareFrame: function(t) {
        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
      }
    };
    function fe() {
    }
    fe.prototype.initElement = function(t, e, i) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, i), this.textProperty = new Gt(this, t.t, this.dynamicProperties), this.textAnimator = new Oe(t.t, this.renderType, this), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, fe.prototype.prepareFrame = function(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    }, fe.prototype.createPathShape = function(t, e) {
      var i, r = e.length, o, s = "";
      for (i = 0; i < r; i += 1)
        o = e[i].ks.k, s += or(o, o.i.length, !0, t);
      return s;
    }, fe.prototype.updateDocumentData = function(t, e) {
      this.textProperty.updateDocumentData(t, e);
    }, fe.prototype.canResizeFont = function(t) {
      this.textProperty.canResizeFont(t);
    }, fe.prototype.setMinimumFontSize = function(t) {
      this.textProperty.setMinimumFontSize(t);
    }, fe.prototype.applyTextPropertiesToMatrix = function(t, e, i, r, o) {
      switch (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j) {
        case 1:
          e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]), 0, 0);
          break;
        case 2:
          e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]) / 2, 0, 0);
          break;
      }
      e.translate(r, o, 0);
    }, fe.prototype.buildColor = function(t) {
      return "rgb(" + Math.round(t[0] * 255) + "," + Math.round(t[1] * 255) + "," + Math.round(t[2] * 255) + ")";
    }, fe.prototype.emptyProp = new $i(), fe.prototype.destroy = function() {
    };
    function _e() {
    }
    _t([De, We, Ge, Be, ei], _e), _e.prototype.initElement = function(t, e, i) {
      this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !e.progressiveLoad) && this.buildAllItems(), this.hide();
    }, _e.prototype.prepareFrame = function(t) {
      if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = t / this.data.sr;
        else {
          var e = this.tm.v;
          e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
        }
        var i, r = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), i = r - 1; i >= 0; i -= 1)
          (this.completeLayers || this.elements[i]) && (this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st), this.elements[i]._mdf && (this._mdf = !0));
      }
    }, _e.prototype.renderInnerContent = function() {
      var t, e = this.layers.length;
      for (t = 0; t < e; t += 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, _e.prototype.setElements = function(t) {
      this.elements = t;
    }, _e.prototype.getElements = function() {
      return this.elements;
    }, _e.prototype.destroyElements = function() {
      var t, e = this.layers.length;
      for (t = 0; t < e; t += 1)
        this.elements[t] && this.elements[t].destroy();
    }, _e.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function ri(t, e, i) {
      this.assetData = e.getAssetData(t.refId), this.initElement(t, e, i), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    _t([De, We, ii, Ge, Be, ei], ri), ri.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = W("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
    }, ri.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function Gi(t, e, i) {
      this.initElement(t, e, i);
    }
    _t([ri], Gi), Gi.prototype.createContent = function() {
      var t = W("rect");
      t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
    };
    function Kt(t, e, i) {
      this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, i), this._isPlaying = !1, this._canPlay = !1;
      var r = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(r), this._currentTime = 0, this.globalData.audioController.addAudio(this), this.tm = t.tm ? D.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 };
    }
    Kt.prototype.prepareFrame = function(t) {
      if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder)
        this._currentTime = t / this.data.sr;
      else {
        var e = this.tm.v;
        this._currentTime = e;
      }
    }, _t([qi, De, Be], Kt), Kt.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, Kt.prototype.show = function() {
    }, Kt.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, Kt.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, Kt.prototype.resume = function() {
      this._canPlay = !0;
    }, Kt.prototype.setRate = function(t) {
      this.audio.rate(t);
    }, Kt.prototype.volume = function(t) {
      this.audio.volume(t);
    }, Kt.prototype.getBaseElement = function() {
      return null;
    }, Kt.prototype.destroy = function() {
    }, Kt.prototype.sourceRectAtTime = function() {
    }, Kt.prototype.initExpressions = function() {
    };
    function gr(t, e, i) {
      this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? it(this.layers.length) : [], this.initElement(t, e, i), this.tm = t.tm ? D.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 };
    }
    _t([Dt, _e, ii], gr);
    function je(t, e, i) {
      this.textSpans = [], this.renderType = "svg", this.initElement(t, e, i);
    }
    _t([De, We, ii, Ge, Be, ei, fe], je), je.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = W("text"));
    }, je.prototype.buildTextContents = function(t) {
      for (var e = 0, i = t.length, r = [], o = ""; e < i; )
        t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (r.push(o), o = "") : o += t[e], e += 1;
      return r.push(o), r;
    }, je.prototype.buildNewText = function() {
      var t, e, i = this.textProperty.currentData;
      this.renderedLetters = it(i ? i.l.length : 0), i.fc ? this.layerElement.setAttribute("fill", this.buildColor(i.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), i.sc && (this.layerElement.setAttribute("stroke", this.buildColor(i.sc)), this.layerElement.setAttribute("stroke-width", i.sw)), this.layerElement.setAttribute("font-size", i.finalSize);
      var r = this.globalData.fontManager.getFontByName(i.f);
      if (r.fClass)
        this.layerElement.setAttribute("class", r.fClass);
      else {
        this.layerElement.setAttribute("font-family", r.fFamily);
        var o = i.fWeight, s = i.fStyle;
        this.layerElement.setAttribute("font-style", s), this.layerElement.setAttribute("font-weight", o);
      }
      this.layerElement.setAttribute("aria-label", i.t);
      var m = i.l || [], C = !!this.globalData.fontManager.chars;
      e = m.length;
      var g, M = this.mHelper, T, S = "", k = this.data.singleShape, _ = 0, P = 0, E = !0, p = i.tr * 1e-3 * i.finalSize;
      if (k && !C && !i.sz) {
        var f = this.textContainer, h = "start";
        switch (i.j) {
          case 1:
            h = "end";
            break;
          case 2:
            h = "middle";
            break;
          default:
            h = "start";
            break;
        }
        f.setAttribute("text-anchor", h), f.setAttribute("letter-spacing", p);
        var a = this.buildTextContents(i.finalText);
        for (e = a.length, P = i.ps ? i.ps[1] + i.ascent : 0, t = 0; t < e; t += 1)
          g = this.textSpans[t] || W("tspan"), g.textContent = a[t], g.setAttribute("x", 0), g.setAttribute("y", P), g.style.display = "inherit", f.appendChild(g), this.textSpans[t] = g, P += i.finalLineHeight;
        this.layerElement.appendChild(f);
      } else {
        var n = this.textSpans.length, u, v;
        for (t = 0; t < e; t += 1)
          (!C || !k || t === 0) && (g = n > t ? this.textSpans[t] : W(C ? "path" : "text"), n <= t && (g.setAttribute("stroke-linecap", "butt"), g.setAttribute("stroke-linejoin", "round"), g.setAttribute("stroke-miterlimit", "4"), this.textSpans[t] = g, this.layerElement.appendChild(g)), g.style.display = "inherit"), M.reset(), M.scale(i.finalSize / 100, i.finalSize / 100), k && (m[t].n && (_ = -p, P += i.yOffset, P += E ? 1 : 0, E = !1), this.applyTextPropertiesToMatrix(i, M, m[t].line, _, P), _ += m[t].l || 0, _ += p), C ? (v = this.globalData.fontManager.getCharData(i.finalText[t], r.fStyle, this.globalData.fontManager.getFontByName(i.f).fFamily), u = v && v.data || {}, T = u.shapes ? u.shapes[0].it : [], k ? S += this.createPathShape(M, T) : g.setAttribute("d", this.createPathShape(M, T))) : (k && g.setAttribute("transform", "translate(" + M.props[12] + "," + M.props[13] + ")"), g.textContent = m[t].val, g.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"));
        k && g && g.setAttribute("d", S);
      }
      for (; t < this.textSpans.length; )
        this.textSpans[t].style.display = "none", t += 1;
      this._sizeChanged = !0;
    }, je.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var t = this.layerElement.getBBox();
        this.bbox = {
          top: t.y,
          left: t.x,
          width: t.width,
          height: t.height
        };
      }
      return this.bbox;
    }, je.prototype.renderInnerContent = function() {
      if (!this.data.singleShape && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var t, e, i = this.textAnimator.renderedLetters, r = this.textProperty.currentData.l;
        e = r.length;
        var o, s;
        for (t = 0; t < e; t += 1)
          r[t].n || (o = i[t], s = this.textSpans[t], o._mdf.m && s.setAttribute("transform", o.m), o._mdf.o && s.setAttribute("opacity", o.o), o._mdf.sw && s.setAttribute("stroke-width", o.sw), o._mdf.sc && s.setAttribute("stroke", o.sc), o._mdf.fc && s.setAttribute("fill", o.fc));
      }
    };
    function Rt(t, e, i) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, i), this.prevViewData = [];
    }
    _t([De, We, ii, yr, Ge, Be, ei], Rt), Rt.prototype.initSecondaryElement = function() {
    }, Rt.prototype.identityMatrix = new At(), Rt.prototype.buildExpressionInterface = function() {
    }, Rt.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, Rt.prototype.filterUniqueShapes = function() {
      var t, e = this.shapes.length, i, r, o = this.stylesList.length, s, m = [], C = !1;
      for (r = 0; r < o; r += 1) {
        for (s = this.stylesList[r], C = !1, m.length = 0, t = 0; t < e; t += 1)
          i = this.shapes[t], i.styles.indexOf(s) !== -1 && (m.push(i), C = i._isAnimated || C);
        m.length > 1 && C && this.setShapesAsAnimated(m);
      }
    }, Rt.prototype.setShapesAsAnimated = function(t) {
      var e, i = t.length;
      for (e = 0; e < i; e += 1)
        t[e].setAsAnimated();
    }, Rt.prototype.createStyleElement = function(t, e) {
      var i, r = new cr(t, e), o = r.pElem;
      if (t.ty === "st")
        i = new dr(this, t, r);
      else if (t.ty === "fl")
        i = new vr(this, t, r);
      else if (t.ty === "gf" || t.ty === "gs") {
        var s = t.ty === "gf" ? Ye : mr;
        i = new s(this, t, r), this.globalData.defs.appendChild(i.gf), i.maskId && (this.globalData.defs.appendChild(i.ms), this.globalData.defs.appendChild(i.of), o.setAttribute("mask", "url(" + A + "#" + i.maskId + ")"));
      }
      return (t.ty === "st" || t.ty === "gs") && (o.setAttribute("stroke-linecap", gt[t.lc || 2]), o.setAttribute("stroke-linejoin", te[t.lj || 2]), o.setAttribute("fill-opacity", "0"), t.lj === 1 && o.setAttribute("stroke-miterlimit", t.ml)), t.r === 2 && o.setAttribute("fill-rule", "evenodd"), t.ln && o.setAttribute("id", t.ln), t.cl && o.setAttribute("class", t.cl), t.bm && (o.style["mix-blend-mode"] = dt(t.bm)), this.stylesList.push(r), this.addToAnimatedContents(t, i), i;
    }, Rt.prototype.createGroupElement = function(t) {
      var e = new fs();
      return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = dt(t.bm)), e;
    }, Rt.prototype.createTransformElement = function(t, e) {
      var i = Ie.getTransformProperty(this, t, this), r = new ls(i, i.o, e);
      return this.addToAnimatedContents(t, r), r;
    }, Rt.prototype.createShapeElement = function(t, e, i) {
      var r = 4;
      t.ty === "rc" ? r = 5 : t.ty === "el" ? r = 6 : t.ty === "sr" && (r = 7);
      var o = Le.getShapeProp(this, t, r, this), s = new pr(e, i, o);
      return this.shapes.push(s), this.addShapeToModifiers(s), this.addToAnimatedContents(t, s), s;
    }, Rt.prototype.addToAnimatedContents = function(t, e) {
      for (var i = 0, r = this.animatedContents.length; i < r; ) {
        if (this.animatedContents[i].element === e)
          return;
        i += 1;
      }
      this.animatedContents.push({
        fn: us.createRenderFunction(t),
        element: e,
        data: t
      });
    }, Rt.prototype.setElementStyles = function(t) {
      var e = t.styles, i, r = this.stylesList.length;
      for (i = 0; i < r; i += 1)
        this.stylesList[i].closed || e.push(this.stylesList[i]);
    }, Rt.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var t, e = this.itemsData.length;
      for (t = 0; t < e; t += 1)
        this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)
        this.dynamicProperties[t].getValue();
      this.renderModifiers();
    }, Rt.prototype.searchShapes = function(t, e, i, r, o, s, m) {
      var C = [].concat(s), g, M = t.length - 1, T, S, k = [], _ = [], P, E, p;
      for (g = M; g >= 0; g -= 1) {
        if (p = this.searchProcessedElement(t[g]), p ? e[g] = i[p - 1] : t[g]._render = m, t[g].ty === "fl" || t[g].ty === "st" || t[g].ty === "gf" || t[g].ty === "gs")
          p ? e[g].style.closed = !1 : e[g] = this.createStyleElement(t[g], o), t[g]._render && r.appendChild(e[g].style.pElem), k.push(e[g].style);
        else if (t[g].ty === "gr") {
          if (!p)
            e[g] = this.createGroupElement(t[g]);
          else
            for (S = e[g].it.length, T = 0; T < S; T += 1)
              e[g].prevViewData[T] = e[g].it[T];
          this.searchShapes(t[g].it, e[g].it, e[g].prevViewData, e[g].gr, o + 1, C, m), t[g]._render && r.appendChild(e[g].gr);
        } else
          t[g].ty === "tr" ? (p || (e[g] = this.createTransformElement(t[g], r)), P = e[g].transform, C.push(P)) : t[g].ty === "sh" || t[g].ty === "rc" || t[g].ty === "el" || t[g].ty === "sr" ? (p || (e[g] = this.createShapeElement(t[g], C, o)), this.setElementStyles(e[g])) : t[g].ty === "tm" || t[g].ty === "rd" || t[g].ty === "ms" || t[g].ty === "pb" ? (p ? (E = e[g], E.closed = !1) : (E = $e.getModifier(t[g].ty), E.init(this, t[g]), e[g] = E, this.shapeModifiers.push(E)), _.push(E)) : t[g].ty === "rp" && (p ? (E = e[g], E.closed = !0) : (E = $e.getModifier(t[g].ty), e[g] = E, E.init(this, t, g, e), this.shapeModifiers.push(E), m = !1), _.push(E));
        this.addProcessedElement(t[g], g + 1);
      }
      for (M = k.length, g = 0; g < M; g += 1)
        k[g].closed = !0;
      for (M = _.length, g = 0; g < M; g += 1)
        _[g].closed = !0;
    }, Rt.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var t, e = this.stylesList.length;
      for (t = 0; t < e; t += 1)
        this.stylesList[t].reset();
      for (this.renderShape(), t = 0; t < e; t += 1)
        (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
    }, Rt.prototype.renderShape = function() {
      var t, e = this.animatedContents.length, i;
      for (t = 0; t < e; t += 1)
        i = this.animatedContents[t], (this._isFirstFrame || i.element._isAnimated) && i.data !== !0 && i.fn(i.data, i.element, this._isFirstFrame);
    }, Rt.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function cs() {
    }
    var jt = function() {
      var t = {}, e = [], i = 0, r = 0, o = 0, s = !0, m = !1;
      function C(I) {
        for (var w = 0, x = I.target; w < r; )
          e[w].animation === x && (e.splice(w, 1), w -= 1, r -= 1, x.isPaused || S()), w += 1;
      }
      function g(I, w) {
        if (!I)
          return null;
        for (var x = 0; x < r; ) {
          if (e[x].elem === I && e[x].elem !== null)
            return e[x].animation;
          x += 1;
        }
        var V = new ot();
        return k(V, I), V.setData(I, w), V;
      }
      function M() {
        var I, w = e.length, x = [];
        for (I = 0; I < w; I += 1)
          x.push(e[I].animation);
        return x;
      }
      function T() {
        o += 1, $();
      }
      function S() {
        o -= 1;
      }
      function k(I, w) {
        I.addEventListener("destroy", C), I.addEventListener("_active", T), I.addEventListener("_idle", S), e.push({ elem: w, animation: I }), r += 1;
      }
      function _(I) {
        var w = new ot();
        return k(w, null), w.setParams(I), w;
      }
      function P(I, w) {
        var x;
        for (x = 0; x < r; x += 1)
          e[x].animation.setSpeed(I, w);
      }
      function E(I, w) {
        var x;
        for (x = 0; x < r; x += 1)
          e[x].animation.setDirection(I, w);
      }
      function p(I) {
        var w;
        for (w = 0; w < r; w += 1)
          e[w].animation.play(I);
      }
      function f(I) {
        var w = I - i, x;
        for (x = 0; x < r; x += 1)
          e[x].animation.advanceTime(w);
        i = I, o && !m ? c.requestAnimationFrame(f) : s = !0;
      }
      function h(I) {
        i = I, c.requestAnimationFrame(f);
      }
      function a(I) {
        var w;
        for (w = 0; w < r; w += 1)
          e[w].animation.pause(I);
      }
      function n(I, w, x) {
        var V;
        for (V = 0; V < r; V += 1)
          e[V].animation.goToAndStop(I, w, x);
      }
      function u(I) {
        var w;
        for (w = 0; w < r; w += 1)
          e[w].animation.stop(I);
      }
      function v(I) {
        var w;
        for (w = 0; w < r; w += 1)
          e[w].animation.togglePause(I);
      }
      function d(I) {
        var w;
        for (w = r - 1; w >= 0; w -= 1)
          e[w].animation.destroy(I);
      }
      function b(I, w, x) {
        var V = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), H, N = V.length;
        for (H = 0; H < N; H += 1)
          x && V[H].setAttribute("data-bm-type", x), g(V[H], I);
        if (w && N === 0) {
          x || (x = "svg");
          var vt = document.getElementsByTagName("body")[0];
          vt.innerText = "";
          var ct = at("div");
          ct.style.width = "100%", ct.style.height = "100%", ct.setAttribute("data-bm-type", x), vt.appendChild(ct), g(ct, I);
        }
      }
      function B() {
        var I;
        for (I = 0; I < r; I += 1)
          e[I].animation.resize();
      }
      function $() {
        !m && o && s && (c.requestAnimationFrame(h), s = !1);
      }
      function X() {
        m = !0;
      }
      function q() {
        m = !1, $();
      }
      function K(I, w) {
        var x;
        for (x = 0; x < r; x += 1)
          e[x].animation.setVolume(I, w);
      }
      function U(I) {
        var w;
        for (w = 0; w < r; w += 1)
          e[w].animation.mute(I);
      }
      function Z(I) {
        var w;
        for (w = 0; w < r; w += 1)
          e[w].animation.unmute(I);
      }
      return t.registerAnimation = g, t.loadAnimation = _, t.setSpeed = P, t.setDirection = E, t.play = p, t.pause = a, t.stop = u, t.togglePause = v, t.searchAnimations = b, t.resize = B, t.goToAndStop = n, t.destroy = d, t.freeze = X, t.unfreeze = q, t.setVolume = K, t.mute = U, t.unmute = Z, t.getRegisteredAnimations = M, t;
    }(), ot = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = Ft(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = L, this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = wt(), this.imagePreloader = new ss(), this.audioController = rs(), this.markers = [];
    };
    _t([ut], ot), ot.prototype.setParams = function(t) {
      (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
      var e = "svg";
      switch (t.animType ? e = t.animType : t.renderer && (e = t.renderer), e) {
        case "canvas":
          this.renderer = new CanvasRenderer(this, t.rendererSettings);
          break;
        case "svg":
          this.renderer = new Dt(this, t.rendererSettings);
          break;
        default:
          this.renderer = new HybridRenderer(this, t.rendererSettings);
          break;
      }
      this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, t.loop === "" || t.loop === null || t.loop === void 0 || t.loop === !0 ? this.loop = !0 : t.loop === !1 ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = "autoplay" in t ? t.autoplay : !0, this.name = t.name ? t.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(t, "autoloadSegments") ? t.autoloadSegments : !0, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.configAnimation(t.animationData) : t.path && (t.path.lastIndexOf("\\") !== -1 ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), zi.load(t.path, this.configAnimation.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this)));
    }, ot.prototype.setData = function(t, e) {
      e && typeof e != "object" && (e = JSON.parse(e));
      var i = {
        wrapper: t,
        animationData: e
      }, r = t.attributes;
      i.path = r.getNamedItem("data-animation-path") ? r.getNamedItem("data-animation-path").value : r.getNamedItem("data-bm-path") ? r.getNamedItem("data-bm-path").value : r.getNamedItem("bm-path") ? r.getNamedItem("bm-path").value : "", i.animType = r.getNamedItem("data-anim-type") ? r.getNamedItem("data-anim-type").value : r.getNamedItem("data-bm-type") ? r.getNamedItem("data-bm-type").value : r.getNamedItem("bm-type") ? r.getNamedItem("bm-type").value : r.getNamedItem("data-bm-renderer") ? r.getNamedItem("data-bm-renderer").value : r.getNamedItem("bm-renderer") ? r.getNamedItem("bm-renderer").value : "canvas";
      var o = r.getNamedItem("data-anim-loop") ? r.getNamedItem("data-anim-loop").value : r.getNamedItem("data-bm-loop") ? r.getNamedItem("data-bm-loop").value : r.getNamedItem("bm-loop") ? r.getNamedItem("bm-loop").value : "";
      o === "false" ? i.loop = !1 : o === "true" ? i.loop = !0 : o !== "" && (i.loop = parseInt(o, 10));
      var s = r.getNamedItem("data-anim-autoplay") ? r.getNamedItem("data-anim-autoplay").value : r.getNamedItem("data-bm-autoplay") ? r.getNamedItem("data-bm-autoplay").value : r.getNamedItem("bm-autoplay") ? r.getNamedItem("bm-autoplay").value : !0;
      i.autoplay = s !== "false", i.name = r.getNamedItem("data-name") ? r.getNamedItem("data-name").value : r.getNamedItem("data-bm-name") ? r.getNamedItem("data-bm-name").value : r.getNamedItem("bm-name") ? r.getNamedItem("bm-name").value : "";
      var m = r.getNamedItem("data-anim-prerender") ? r.getNamedItem("data-anim-prerender").value : r.getNamedItem("data-bm-prerender") ? r.getNamedItem("data-bm-prerender").value : r.getNamedItem("bm-prerender") ? r.getNamedItem("bm-prerender").value : "";
      m === "false" && (i.prerender = !1), this.setParams(i);
    }, ot.prototype.includeLayers = function(t) {
      t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
      var e = this.animationData.layers, i, r = e.length, o = t.layers, s, m = o.length;
      for (s = 0; s < m; s += 1)
        for (i = 0; i < r; ) {
          if (e[i].id === o[s].id) {
            e[i] = o[s];
            break;
          }
          i += 1;
        }
      if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets)
        for (r = t.assets.length, i = 0; i < r; i += 1)
          this.animationData.assets.push(t.assets[i]);
      this.animationData.__complete = !1, li.completeData(this.animationData, this.renderer.globalData.fontManager), this.renderer.includeLayers(t.layers), R && R.initExpressions(this), this.loadNextSegment();
    }, ot.prototype.loadNextSegment = function() {
      var t = this.animationData.segments;
      if (!t || t.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var e = t.shift();
      this.timeCompleted = e.time * this.frameRate;
      var i = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, zi.load(i, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, ot.prototype.loadSegments = function() {
      var t = this.animationData.segments;
      t || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, ot.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, ot.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, ot.prototype.configAnimation = function(t) {
      if (!!this.renderer)
        try {
          this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = os(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (e) {
          this.triggerConfigError(e);
        }
    }, ot.prototype.waitForFontsLoaded = function() {
      !this.renderer || (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, ot.prototype.checkLoaded = function() {
      !this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages() && (this.isLoaded = !0, li.completeData(this.animationData, this.renderer.globalData.fontManager), R && R.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
        this.trigger("DOMLoaded");
      }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play());
    }, ot.prototype.resize = function() {
      this.renderer.updateContainerSize();
    }, ot.prototype.setSubframe = function(t) {
      this.isSubframeEnabled = !!t;
    }, ot.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame();
    }, ot.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (t) {
          this.triggerRenderFrameError(t);
        }
    }, ot.prototype.play = function(t) {
      t && this.name !== t || this.isPaused === !0 && (this.isPaused = !1, this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, ot.prototype.pause = function(t) {
      t && this.name !== t || this.isPaused === !1 && (this.isPaused = !0, this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, ot.prototype.togglePause = function(t) {
      t && this.name !== t || (this.isPaused === !0 ? this.play() : this.pause());
    }, ot.prototype.stop = function(t) {
      t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, ot.prototype.getMarkerData = function(t) {
      for (var e, i = 0; i < this.markers.length; i += 1)
        if (e = this.markers[i], e.payload && e.payload.name === t)
          return e;
      return null;
    }, ot.prototype.goToAndStop = function(t, e, i) {
      if (!(i && this.name !== i)) {
        var r = Number(t);
        if (isNaN(r)) {
          var o = this.getMarkerData(t);
          o && this.goToAndStop(o.time, !0);
        } else
          e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
        this.pause();
      }
    }, ot.prototype.goToAndPlay = function(t, e, i) {
      if (!(i && this.name !== i)) {
        var r = Number(t);
        if (isNaN(r)) {
          var o = this.getMarkerData(t);
          o && (o.duration ? this.playSegments([o.time, o.time + o.duration], !0) : this.goToAndStop(o.time, !0));
        } else
          this.goToAndStop(r, e, i);
        this.play();
      }
    }, ot.prototype.advanceTime = function(t) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var e = this.currentRawFrame + t * this.frameModifier, i = !1;
        e >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (i = !0, e = this.totalFrames - 1) : e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : e < 0 ? this.checkSegments(e % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (i = !0, e = 0)) : this.setCurrentRawFrameValue(e), i && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
      }
    }, ot.prototype.adjustSegment = function(t, e) {
      this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(1e-3 + e)), this.trigger("segmentStart");
    }, ot.prototype.setSegment = function(t, e) {
      var i = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < t ? i = t : this.currentRawFrame + this.firstFrame > e && (i = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, i !== -1 && this.goToAndStop(i, !0);
    }, ot.prototype.playSegments = function(t, e) {
      if (e && (this.segments.length = 0), typeof t[0] == "object") {
        var i, r = t.length;
        for (i = 0; i < r; i += 1)
          this.segments.push(t[i]);
      } else
        this.segments.push(t);
      this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, ot.prototype.resetSegments = function(t) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
    }, ot.prototype.checkSegments = function(t) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), t), !0) : !1;
    }, ot.prototype.destroy = function(t) {
      t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
    }, ot.prototype.setCurrentRawFrameValue = function(t) {
      this.currentRawFrame = t, this.gotoFrame();
    }, ot.prototype.setSpeed = function(t) {
      this.playSpeed = t, this.updaFrameModifier();
    }, ot.prototype.setDirection = function(t) {
      this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
    }, ot.prototype.setVolume = function(t, e) {
      e && this.name !== e || this.audioController.setVolume(t);
    }, ot.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, ot.prototype.mute = function(t) {
      t && this.name !== t || this.audioController.mute();
    }, ot.prototype.unmute = function(t) {
      t && this.name !== t || this.audioController.unmute();
    }, ot.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, ot.prototype.getPath = function() {
      return this.path;
    }, ot.prototype.getAssetsPath = function(t) {
      var e = "";
      if (t.e)
        e = t.p;
      else if (this.assetsPath) {
        var i = t.p;
        i.indexOf("images/") !== -1 && (i = i.split("/")[1]), e = this.assetsPath + i;
      } else
        e = this.path, e += t.u ? t.u : "", e += t.p;
      return e;
    }, ot.prototype.getAssetData = function(t) {
      for (var e = 0, i = this.assets.length; e < i; ) {
        if (t === this.assets[e].id)
          return this.assets[e];
        e += 1;
      }
      return null;
    }, ot.prototype.hide = function() {
      this.renderer.hide();
    }, ot.prototype.show = function() {
      this.renderer.show();
    }, ot.prototype.getDuration = function(t) {
      return t ? this.totalFrames : this.totalFrames / this.frameRate;
    }, ot.prototype.trigger = function(t) {
      if (this._cbs && this._cbs[t])
        switch (t) {
          case "enterFrame":
            this.triggerEvent(t, new xt(t, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "loopComplete":
            this.triggerEvent(t, new Yt(t, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(t, new Mt(t, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(t, new Ot(t, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(t, new tt(t, this));
            break;
          default:
            this.triggerEvent(t);
        }
      t === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new xt(t, this.currentFrame, this.totalFrames, this.frameMult)), t === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new Yt(t, this.loop, this.playCount, this.frameMult)), t === "complete" && this.onComplete && this.onComplete.call(this, new Mt(t, this.frameMult)), t === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new Ot(t, this.firstFrame, this.totalFrames)), t === "destroy" && this.onDestroy && this.onDestroy.call(this, new tt(t, this));
    }, ot.prototype.triggerRenderFrameError = function(t) {
      var e = new yt(t, this.currentFrame);
      this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
    }, ot.prototype.triggerConfigError = function(t) {
      var e = new Ct(t, this.currentFrame);
      this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
    };
    function ps() {
      this.effectElements = [];
    }
    var Et = {};
    function ds(t) {
      A = t;
    }
    function br() {
      jt.searchAnimations();
    }
    function vs(t) {
      L = t;
    }
    function ms(t) {
      O = t;
    }
    function ys(t) {
      return jt.loadAnimation(t);
    }
    function gs(t) {
      if (typeof t == "string")
        switch (t) {
          case "high":
            nt = 200;
            break;
          default:
          case "medium":
            nt = 50;
            break;
          case "low":
            nt = 10;
            break;
        }
      else
        !isNaN(t) && t > 1 && (nt = t);
    }
    function bs() {
      return typeof navigator < "u";
    }
    function _s(t, e) {
      t === "expressions" && (R = e);
    }
    function ks(t) {
      switch (t) {
        case "propertyFactory":
          return D;
        case "shapePropertyFactory":
          return Le;
        case "matrix":
          return At;
        default:
          return null;
      }
    }
    Et.play = jt.play, Et.pause = jt.pause, Et.setLocationHref = ds, Et.togglePause = jt.togglePause, Et.setSpeed = jt.setSpeed, Et.setDirection = jt.setDirection, Et.stop = jt.stop, Et.searchAnimations = br, Et.registerAnimation = jt.registerAnimation, Et.loadAnimation = ys, Et.setSubframeRendering = vs, Et.resize = jt.resize, Et.goToAndStop = jt.goToAndStop, Et.destroy = jt.destroy, Et.setQuality = gs, Et.inBrowser = bs, Et.installPlugin = _s, Et.freeze = jt.freeze, Et.unfreeze = jt.unfreeze, Et.setVolume = jt.setVolume, Et.mute = jt.mute, Et.unmute = jt.unmute, Et.getRegisteredAnimations = jt.getRegisteredAnimations, Et.setIDPrefix = ms, Et.__getFactory = ks, Et.version = "5.7.14";
    function xs() {
      document.readyState === "complete" && (clearInterval(ws), br());
    }
    function Ss(t) {
      for (var e = _r.split("&"), i = 0; i < e.length; i += 1) {
        var r = e[i].split("=");
        if (decodeURIComponent(r[0]) == t)
          return decodeURIComponent(r[1]);
      }
      return null;
    }
    var _r;
    {
      var kr = document.getElementsByTagName("script"), As = kr.length - 1, Es = kr[As] || {
        src: ""
      };
      _r = Es.src.replace(/^[^\?]+\??/, ""), Ss("renderer");
    }
    var ws = setInterval(xs, 100);
    return Et;
  });
})(Zr);
var wn = function l(c, y) {
  if (c === y)
    return !0;
  if (c && y && typeof c == "object" && typeof y == "object") {
    if (c.constructor !== y.constructor)
      return !1;
    var A, F, L;
    if (Array.isArray(c)) {
      if (A = c.length, A != y.length)
        return !1;
      for (F = A; F-- !== 0; )
        if (!l(c[F], y[F]))
          return !1;
      return !0;
    }
    if (c instanceof Map && y instanceof Map) {
      if (c.size !== y.size)
        return !1;
      for (F of c.entries())
        if (!y.has(F[0]))
          return !1;
      for (F of c.entries())
        if (!l(F[1], y.get(F[0])))
          return !1;
      return !0;
    }
    if (c instanceof Set && y instanceof Set) {
      if (c.size !== y.size)
        return !1;
      for (F of c.entries())
        if (!y.has(F[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(c) && ArrayBuffer.isView(y)) {
      if (A = c.length, A != y.length)
        return !1;
      for (F = A; F-- !== 0; )
        if (c[F] !== y[F])
          return !1;
      return !0;
    }
    if (c.constructor === RegExp)
      return c.source === y.source && c.flags === y.flags;
    if (c.valueOf !== Object.prototype.valueOf)
      return c.valueOf() === y.valueOf();
    if (c.toString !== Object.prototype.toString)
      return c.toString() === y.toString();
    if (L = Object.keys(c), A = L.length, A !== Object.keys(y).length)
      return !1;
    for (F = A; F-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(y, L[F]))
        return !1;
    for (F = A; F-- !== 0; ) {
      var O = L[F];
      if (!(O === "_owner" && c.$$typeof) && !l(c[O], y[O]))
        return !1;
    }
    return !0;
  }
  return c !== c && y !== y;
}, Pn = Cn;
function He(l) {
  return l instanceof Buffer ? Buffer.from(l) : new l.constructor(l.buffer.slice(), l.byteOffset, l.length);
}
function Cn(l) {
  if (l = l || {}, l.circles)
    return Tn(l);
  return l.proto ? A : y;
  function c(F, L) {
    for (var O = Object.keys(F), R = new Array(O.length), z = 0; z < O.length; z++) {
      var j = O[z], Y = F[j];
      typeof Y != "object" || Y === null ? R[j] = Y : Y instanceof Date ? R[j] = new Date(Y) : ArrayBuffer.isView(Y) ? R[j] = He(Y) : R[j] = L(Y);
    }
    return R;
  }
  function y(F) {
    if (typeof F != "object" || F === null)
      return F;
    if (F instanceof Date)
      return new Date(F);
    if (Array.isArray(F))
      return c(F, y);
    if (F instanceof Map)
      return new Map(c(Array.from(F), y));
    if (F instanceof Set)
      return new Set(c(Array.from(F), y));
    var L = {};
    for (var O in F)
      if (Object.hasOwnProperty.call(F, O) !== !1) {
        var R = F[O];
        typeof R != "object" || R === null ? L[O] = R : R instanceof Date ? L[O] = new Date(R) : R instanceof Map ? L[O] = new Map(c(Array.from(R), y)) : R instanceof Set ? L[O] = new Set(c(Array.from(R), y)) : ArrayBuffer.isView(R) ? L[O] = He(R) : L[O] = y(R);
      }
    return L;
  }
  function A(F) {
    if (typeof F != "object" || F === null)
      return F;
    if (F instanceof Date)
      return new Date(F);
    if (Array.isArray(F))
      return c(F, A);
    if (F instanceof Map)
      return new Map(c(Array.from(F), A));
    if (F instanceof Set)
      return new Set(c(Array.from(F), A));
    var L = {};
    for (var O in F) {
      var R = F[O];
      typeof R != "object" || R === null ? L[O] = R : R instanceof Date ? L[O] = new Date(R) : R instanceof Map ? L[O] = new Map(c(Array.from(R), A)) : R instanceof Set ? L[O] = new Set(c(Array.from(R), A)) : ArrayBuffer.isView(R) ? L[O] = He(R) : L[O] = A(R);
    }
    return L;
  }
}
function Tn(l) {
  var c = [], y = [];
  return l.proto ? L : F;
  function A(O, R) {
    for (var z = Object.keys(O), j = new Array(z.length), Y = 0; Y < z.length; Y++) {
      var rt = z[Y], lt = O[rt];
      if (typeof lt != "object" || lt === null)
        j[rt] = lt;
      else if (lt instanceof Date)
        j[rt] = new Date(lt);
      else if (ArrayBuffer.isView(lt))
        j[rt] = He(lt);
      else {
        var mt = c.indexOf(lt);
        mt !== -1 ? j[rt] = y[mt] : j[rt] = R(lt);
      }
    }
    return j;
  }
  function F(O) {
    if (typeof O != "object" || O === null)
      return O;
    if (O instanceof Date)
      return new Date(O);
    if (Array.isArray(O))
      return A(O, F);
    if (O instanceof Map)
      return new Map(A(Array.from(O), F));
    if (O instanceof Set)
      return new Set(A(Array.from(O), F));
    var R = {};
    c.push(O), y.push(R);
    for (var z in O)
      if (Object.hasOwnProperty.call(O, z) !== !1) {
        var j = O[z];
        if (typeof j != "object" || j === null)
          R[z] = j;
        else if (j instanceof Date)
          R[z] = new Date(j);
        else if (j instanceof Map)
          R[z] = new Map(A(Array.from(j), F));
        else if (j instanceof Set)
          R[z] = new Set(A(Array.from(j), F));
        else if (ArrayBuffer.isView(j))
          R[z] = He(j);
        else {
          var Y = c.indexOf(j);
          Y !== -1 ? R[z] = y[Y] : R[z] = F(j);
        }
      }
    return c.pop(), y.pop(), R;
  }
  function L(O) {
    if (typeof O != "object" || O === null)
      return O;
    if (O instanceof Date)
      return new Date(O);
    if (Array.isArray(O))
      return A(O, L);
    if (O instanceof Map)
      return new Map(A(Array.from(O), L));
    if (O instanceof Set)
      return new Set(A(Array.from(O), L));
    var R = {};
    c.push(O), y.push(R);
    for (var z in O) {
      var j = O[z];
      if (typeof j != "object" || j === null)
        R[z] = j;
      else if (j instanceof Date)
        R[z] = new Date(j);
      else if (j instanceof Map)
        R[z] = new Map(A(Array.from(j), L));
      else if (j instanceof Set)
        R[z] = new Set(A(Array.from(j), L));
      else if (ArrayBuffer.isView(j))
        R[z] = He(j);
      else {
        var Y = c.indexOf(j);
        Y !== -1 ? R[z] = y[Y] : R[z] = L(j);
      }
    }
    return c.pop(), y.pop(), R;
  }
}
var Mn = Pn();
function wi(l) {
  return l && typeof l == "object" && "default" in l ? l.default : l;
}
var Fn = wi(Zr.exports), Pt = Ps, In = wi(Pt), Ir = wi(wn), Lr = wi(Mn);
function Hi() {
  return Hi = Object.assign || function(l) {
    for (var c = 1; c < arguments.length; c++) {
      var y = arguments[c];
      for (var A in y)
        Object.prototype.hasOwnProperty.call(y, A) && (l[A] = y[A]);
    }
    return l;
  }, Hi.apply(this, arguments);
}
function Ln(l, c) {
  if (l == null)
    return {};
  var y = {}, A = Object.keys(l), F, L;
  for (L = 0; L < A.length; L++)
    F = A[L], !(c.indexOf(F) >= 0) && (y[F] = l[F]);
  return y;
}
function rr(l, c) {
  return c = { exports: {} }, l(c, c.exports), c.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zt = typeof Symbol == "function" && Symbol.for, sr = zt ? Symbol.for("react.element") : 60103, nr = zt ? Symbol.for("react.portal") : 60106, Pi = zt ? Symbol.for("react.fragment") : 60107, Ci = zt ? Symbol.for("react.strict_mode") : 60108, Ti = zt ? Symbol.for("react.profiler") : 60114, Mi = zt ? Symbol.for("react.provider") : 60109, Fi = zt ? Symbol.for("react.context") : 60110, ar = zt ? Symbol.for("react.async_mode") : 60111, Ii = zt ? Symbol.for("react.concurrent_mode") : 60111, Li = zt ? Symbol.for("react.forward_ref") : 60112, Oi = zt ? Symbol.for("react.suspense") : 60113, On = zt ? Symbol.for("react.suspense_list") : 60120, Ri = zt ? Symbol.for("react.memo") : 60115, Vi = zt ? Symbol.for("react.lazy") : 60116, Rn = zt ? Symbol.for("react.block") : 60121, Vn = zt ? Symbol.for("react.fundamental") : 60117, Bn = zt ? Symbol.for("react.responder") : 60118, Dn = zt ? Symbol.for("react.scope") : 60119;
function ne(l) {
  if (typeof l == "object" && l !== null) {
    var c = l.$$typeof;
    switch (c) {
      case sr:
        switch (l = l.type, l) {
          case ar:
          case Ii:
          case Pi:
          case Ti:
          case Ci:
          case Oi:
            return l;
          default:
            switch (l = l && l.$$typeof, l) {
              case Fi:
              case Li:
              case Vi:
              case Ri:
              case Mi:
                return l;
              default:
                return c;
            }
        }
      case nr:
        return c;
    }
  }
}
function Jr(l) {
  return ne(l) === Ii;
}
var jn = ar, Nn = Ii, zn = Fi, $n = Mi, qn = sr, Gn = Li, Wn = Pi, Yn = Vi, Xn = Ri, Un = nr, Hn = Ti, Kn = Ci, Zn = Oi, Jn = function(l) {
  return Jr(l) || ne(l) === ar;
}, Qn = Jr, ta = function(l) {
  return ne(l) === Fi;
}, ea = function(l) {
  return ne(l) === Mi;
}, ia = function(l) {
  return typeof l == "object" && l !== null && l.$$typeof === sr;
}, ra = function(l) {
  return ne(l) === Li;
}, sa = function(l) {
  return ne(l) === Pi;
}, na = function(l) {
  return ne(l) === Vi;
}, aa = function(l) {
  return ne(l) === Ri;
}, oa = function(l) {
  return ne(l) === nr;
}, ha = function(l) {
  return ne(l) === Ti;
}, la = function(l) {
  return ne(l) === Ci;
}, fa = function(l) {
  return ne(l) === Oi;
}, ua = function(l) {
  return typeof l == "string" || typeof l == "function" || l === Pi || l === Ii || l === Ti || l === Ci || l === Oi || l === On || typeof l == "object" && l !== null && (l.$$typeof === Vi || l.$$typeof === Ri || l.$$typeof === Mi || l.$$typeof === Fi || l.$$typeof === Li || l.$$typeof === Vn || l.$$typeof === Bn || l.$$typeof === Dn || l.$$typeof === Rn);
}, ca = ne, pa = {
  AsyncMode: jn,
  ConcurrentMode: Nn,
  ContextConsumer: zn,
  ContextProvider: $n,
  Element: qn,
  ForwardRef: Gn,
  Fragment: Wn,
  Lazy: Yn,
  Memo: Xn,
  Portal: Un,
  Profiler: Hn,
  StrictMode: Kn,
  Suspense: Zn,
  isAsyncMode: Jn,
  isConcurrentMode: Qn,
  isContextConsumer: ta,
  isContextProvider: ea,
  isElement: ia,
  isForwardRef: ra,
  isFragment: sa,
  isLazy: na,
  isMemo: aa,
  isPortal: oa,
  isProfiler: ha,
  isStrictMode: la,
  isSuspense: fa,
  isValidElementType: ua,
  typeOf: ca
}, da = rr(function(l, c) {
  process.env.NODE_ENV !== "production" && function() {
    var y = typeof Symbol == "function" && Symbol.for, A = y ? Symbol.for("react.element") : 60103, F = y ? Symbol.for("react.portal") : 60106, L = y ? Symbol.for("react.fragment") : 60107, O = y ? Symbol.for("react.strict_mode") : 60108, R = y ? Symbol.for("react.profiler") : 60114, z = y ? Symbol.for("react.provider") : 60109, j = y ? Symbol.for("react.context") : 60110, Y = y ? Symbol.for("react.async_mode") : 60111, rt = y ? Symbol.for("react.concurrent_mode") : 60111, lt = y ? Symbol.for("react.forward_ref") : 60112, mt = y ? Symbol.for("react.suspense") : 60113, wt = y ? Symbol.for("react.suspense_list") : 60120, nt = y ? Symbol.for("react.memo") : 60115, ht = y ? Symbol.for("react.lazy") : 60116, pt = y ? Symbol.for("react.block") : 60121, xt = y ? Symbol.for("react.fundamental") : 60117, Mt = y ? Symbol.for("react.responder") : 60118, Yt = y ? Symbol.for("react.scope") : 60119;
    function Ot(D) {
      return typeof D == "string" || typeof D == "function" || D === L || D === rt || D === R || D === O || D === mt || D === wt || typeof D == "object" && D !== null && (D.$$typeof === ht || D.$$typeof === nt || D.$$typeof === z || D.$$typeof === j || D.$$typeof === lt || D.$$typeof === xt || D.$$typeof === Mt || D.$$typeof === Yt || D.$$typeof === pt);
    }
    function tt(D) {
      if (typeof D == "object" && D !== null) {
        var Ie = D.$$typeof;
        switch (Ie) {
          case A:
            var ee = D.type;
            switch (ee) {
              case Y:
              case rt:
              case L:
              case R:
              case O:
              case mt:
                return ee;
              default:
                var Le = ee && ee.$$typeof;
                switch (Le) {
                  case j:
                  case lt:
                  case ht:
                  case nt:
                  case z:
                    return Le;
                  default:
                    return Ie;
                }
            }
          case F:
            return Ie;
        }
      }
    }
    var yt = Y, Ct = rt, Ft = j, de = z, Xt = A, G = lt, Q = L, ft = ht, ut = nt, et = F, it = R, W = O, at = mt, st = !1;
    function dt(D) {
      return st || (st = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), gt(D) || tt(D) === Y;
    }
    function gt(D) {
      return tt(D) === rt;
    }
    function te(D) {
      return tt(D) === j;
    }
    function At(D) {
      return tt(D) === z;
    }
    function ae(D) {
      return typeof D == "object" && D !== null && D.$$typeof === A;
    }
    function _t(D) {
      return tt(D) === lt;
    }
    function Bi(D) {
      return tt(D) === L;
    }
    function Di(D) {
      return tt(D) === ht;
    }
    function oe(D) {
      return tt(D) === nt;
    }
    function ji(D) {
      return tt(D) === F;
    }
    function li(D) {
      return tt(D) === R;
    }
    function fi(D) {
      return tt(D) === O;
    }
    function Fe(D) {
      return tt(D) === mt;
    }
    c.AsyncMode = yt, c.ConcurrentMode = Ct, c.ContextConsumer = Ft, c.ContextProvider = de, c.Element = Xt, c.ForwardRef = G, c.Fragment = Q, c.Lazy = ft, c.Memo = ut, c.Portal = et, c.Profiler = it, c.StrictMode = W, c.Suspense = at, c.isAsyncMode = dt, c.isConcurrentMode = gt, c.isContextConsumer = te, c.isContextProvider = At, c.isElement = ae, c.isForwardRef = _t, c.isFragment = Bi, c.isLazy = Di, c.isMemo = oe, c.isPortal = ji, c.isProfiler = li, c.isStrictMode = fi, c.isSuspense = Fe, c.isValidElementType = Ot, c.typeOf = tt;
  }();
}), Qr = rr(function(l) {
  process.env.NODE_ENV === "production" ? l.exports = pa : l.exports = da;
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Or = Object.getOwnPropertySymbols, va = Object.prototype.hasOwnProperty, ma = Object.prototype.propertyIsEnumerable;
function ya(l) {
  if (l == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(l);
}
function ga() {
  try {
    if (!Object.assign)
      return !1;
    var l = new String("abc");
    if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
      return !1;
    for (var c = {}, y = 0; y < 10; y++)
      c["_" + String.fromCharCode(y)] = y;
    var A = Object.getOwnPropertyNames(c).map(function(L) {
      return c[L];
    });
    if (A.join("") !== "0123456789")
      return !1;
    var F = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(L) {
      F[L] = L;
    }), Object.keys(Object.assign({}, F)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var ba = ga() ? Object.assign : function(l, c) {
  for (var y, A = ya(l), F, L = 1; L < arguments.length; L++) {
    y = Object(arguments[L]);
    for (var O in y)
      va.call(y, O) && (A[O] = y[O]);
    if (Or) {
      F = Or(y);
      for (var R = 0; R < F.length; R++)
        ma.call(y, F[R]) && (A[F[R]] = y[F[R]]);
    }
  }
  return A;
}, _a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Me = _a, Ki = function() {
};
if (process.env.NODE_ENV !== "production") {
  var ka = Me, Zi = {}, xa = Function.call.bind(Object.prototype.hasOwnProperty);
  Ki = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  };
}
function ts(l, c, y, A, F) {
  if (process.env.NODE_ENV !== "production") {
    for (var L in l)
      if (xa(l, L)) {
        var O;
        try {
          if (typeof l[L] != "function") {
            var R = Error((A || "React class") + ": " + y + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[L] + "`.");
            throw R.name = "Invariant Violation", R;
          }
          O = l[L](c, L, A, y, null, ka);
        } catch (j) {
          O = j;
        }
        if (O && !(O instanceof Error) && Ki((A || "React class") + ": type specification of " + y + " `" + L + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof O + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), O instanceof Error && !(O.message in Zi)) {
          Zi[O.message] = !0;
          var z = F ? F() : "";
          Ki("Failed " + y + " type: " + O.message + (z != null ? z : ""));
        }
      }
  }
}
ts.resetWarningCache = function() {
  process.env.NODE_ENV !== "production" && (Zi = {});
};
var Rr = ts, Sa = Function.call.bind(Object.prototype.hasOwnProperty), Xe = function() {
};
process.env.NODE_ENV !== "production" && (Xe = function(l) {
  var c = "Warning: " + l;
  typeof console < "u" && console.error(c);
  try {
    throw new Error(c);
  } catch {
  }
});
function yi() {
  return null;
}
var Aa = function(l, c) {
  var y = typeof Symbol == "function" && Symbol.iterator, A = "@@iterator";
  function F(G) {
    var Q = G && (y && G[y] || G[A]);
    if (typeof Q == "function")
      return Q;
  }
  var L = "<<anonymous>>", O = {
    array: Y("array"),
    bool: Y("boolean"),
    func: Y("function"),
    number: Y("number"),
    object: Y("object"),
    string: Y("string"),
    symbol: Y("symbol"),
    any: rt(),
    arrayOf: lt,
    element: mt(),
    elementType: wt(),
    instanceOf: nt,
    node: Mt(),
    objectOf: pt,
    oneOf: ht,
    oneOfType: xt,
    shape: Yt,
    exact: Ot
  };
  function R(G, Q) {
    return G === Q ? G !== 0 || 1 / G === 1 / Q : G !== G && Q !== Q;
  }
  function z(G) {
    this.message = G, this.stack = "";
  }
  z.prototype = Error.prototype;
  function j(G) {
    if (process.env.NODE_ENV !== "production")
      var Q = {}, ft = 0;
    function ut(it, W, at, st, dt, gt, te) {
      if (st = st || L, gt = gt || at, te !== Me) {
        if (c) {
          var At = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw At.name = "Invariant Violation", At;
        } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
          var ae = st + ":" + at;
          !Q[ae] && ft < 3 && (Xe("You are manually calling a React.PropTypes validation function for the `" + gt + "` prop on `" + st + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), Q[ae] = !0, ft++);
        }
      }
      return W[at] == null ? it ? W[at] === null ? new z("The " + dt + " `" + gt + "` is marked as required " + ("in `" + st + "`, but its value is `null`.")) : new z("The " + dt + " `" + gt + "` is marked as required in " + ("`" + st + "`, but its value is `undefined`.")) : null : G(W, at, st, dt, gt);
    }
    var et = ut.bind(null, !1);
    return et.isRequired = ut.bind(null, !0), et;
  }
  function Y(G) {
    function Q(ft, ut, et, it, W, at) {
      var st = ft[ut], dt = Ct(st);
      if (dt !== G) {
        var gt = Ft(st);
        return new z("Invalid " + it + " `" + W + "` of type " + ("`" + gt + "` supplied to `" + et + "`, expected ") + ("`" + G + "`."));
      }
      return null;
    }
    return j(Q);
  }
  function rt() {
    return j(yi);
  }
  function lt(G) {
    function Q(ft, ut, et, it, W) {
      if (typeof G != "function")
        return new z("Property `" + W + "` of component `" + et + "` has invalid PropType notation inside arrayOf.");
      var at = ft[ut];
      if (!Array.isArray(at)) {
        var st = Ct(at);
        return new z("Invalid " + it + " `" + W + "` of type " + ("`" + st + "` supplied to `" + et + "`, expected an array."));
      }
      for (var dt = 0; dt < at.length; dt++) {
        var gt = G(at, dt, et, it, W + "[" + dt + "]", Me);
        if (gt instanceof Error)
          return gt;
      }
      return null;
    }
    return j(Q);
  }
  function mt() {
    function G(Q, ft, ut, et, it) {
      var W = Q[ft];
      if (!l(W)) {
        var at = Ct(W);
        return new z("Invalid " + et + " `" + it + "` of type " + ("`" + at + "` supplied to `" + ut + "`, expected a single ReactElement."));
      }
      return null;
    }
    return j(G);
  }
  function wt() {
    function G(Q, ft, ut, et, it) {
      var W = Q[ft];
      if (!Qr.isValidElementType(W)) {
        var at = Ct(W);
        return new z("Invalid " + et + " `" + it + "` of type " + ("`" + at + "` supplied to `" + ut + "`, expected a single ReactElement type."));
      }
      return null;
    }
    return j(G);
  }
  function nt(G) {
    function Q(ft, ut, et, it, W) {
      if (!(ft[ut] instanceof G)) {
        var at = G.name || L, st = Xt(ft[ut]);
        return new z("Invalid " + it + " `" + W + "` of type " + ("`" + st + "` supplied to `" + et + "`, expected ") + ("instance of `" + at + "`."));
      }
      return null;
    }
    return j(Q);
  }
  function ht(G) {
    if (!Array.isArray(G))
      return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? Xe("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : Xe("Invalid argument supplied to oneOf, expected an array.")), yi;
    function Q(ft, ut, et, it, W) {
      for (var at = ft[ut], st = 0; st < G.length; st++)
        if (R(at, G[st]))
          return null;
      var dt = JSON.stringify(G, function(te, At) {
        var ae = Ft(At);
        return ae === "symbol" ? String(At) : At;
      });
      return new z("Invalid " + it + " `" + W + "` of value `" + String(at) + "` " + ("supplied to `" + et + "`, expected one of " + dt + "."));
    }
    return j(Q);
  }
  function pt(G) {
    function Q(ft, ut, et, it, W) {
      if (typeof G != "function")
        return new z("Property `" + W + "` of component `" + et + "` has invalid PropType notation inside objectOf.");
      var at = ft[ut], st = Ct(at);
      if (st !== "object")
        return new z("Invalid " + it + " `" + W + "` of type " + ("`" + st + "` supplied to `" + et + "`, expected an object."));
      for (var dt in at)
        if (Sa(at, dt)) {
          var gt = G(at, dt, et, it, W + "." + dt, Me);
          if (gt instanceof Error)
            return gt;
        }
      return null;
    }
    return j(Q);
  }
  function xt(G) {
    if (!Array.isArray(G))
      return process.env.NODE_ENV !== "production" && Xe("Invalid argument supplied to oneOfType, expected an instance of array."), yi;
    for (var Q = 0; Q < G.length; Q++) {
      var ft = G[Q];
      if (typeof ft != "function")
        return Xe("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + de(ft) + " at index " + Q + "."), yi;
    }
    function ut(et, it, W, at, st) {
      for (var dt = 0; dt < G.length; dt++) {
        var gt = G[dt];
        if (gt(et, it, W, at, st, Me) == null)
          return null;
      }
      return new z("Invalid " + at + " `" + st + "` supplied to " + ("`" + W + "`."));
    }
    return j(ut);
  }
  function Mt() {
    function G(Q, ft, ut, et, it) {
      return tt(Q[ft]) ? null : new z("Invalid " + et + " `" + it + "` supplied to " + ("`" + ut + "`, expected a ReactNode."));
    }
    return j(G);
  }
  function Yt(G) {
    function Q(ft, ut, et, it, W) {
      var at = ft[ut], st = Ct(at);
      if (st !== "object")
        return new z("Invalid " + it + " `" + W + "` of type `" + st + "` " + ("supplied to `" + et + "`, expected `object`."));
      for (var dt in G) {
        var gt = G[dt];
        if (!!gt) {
          var te = gt(at, dt, et, it, W + "." + dt, Me);
          if (te)
            return te;
        }
      }
      return null;
    }
    return j(Q);
  }
  function Ot(G) {
    function Q(ft, ut, et, it, W) {
      var at = ft[ut], st = Ct(at);
      if (st !== "object")
        return new z("Invalid " + it + " `" + W + "` of type `" + st + "` " + ("supplied to `" + et + "`, expected `object`."));
      var dt = ba({}, ft[ut], G);
      for (var gt in dt) {
        var te = G[gt];
        if (!te)
          return new z("Invalid " + it + " `" + W + "` key `" + gt + "` supplied to `" + et + "`.\nBad object: " + JSON.stringify(ft[ut], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(G), null, "  "));
        var At = te(at, gt, et, it, W + "." + gt, Me);
        if (At)
          return At;
      }
      return null;
    }
    return j(Q);
  }
  function tt(G) {
    switch (typeof G) {
      case "number":
      case "string":
      case "undefined":
        return !0;
      case "boolean":
        return !G;
      case "object":
        if (Array.isArray(G))
          return G.every(tt);
        if (G === null || l(G))
          return !0;
        var Q = F(G);
        if (Q) {
          var ft = Q.call(G), ut;
          if (Q !== G.entries) {
            for (; !(ut = ft.next()).done; )
              if (!tt(ut.value))
                return !1;
          } else
            for (; !(ut = ft.next()).done; ) {
              var et = ut.value;
              if (et && !tt(et[1]))
                return !1;
            }
        } else
          return !1;
        return !0;
      default:
        return !1;
    }
  }
  function yt(G, Q) {
    return G === "symbol" ? !0 : Q ? Q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Q instanceof Symbol : !1;
  }
  function Ct(G) {
    var Q = typeof G;
    return Array.isArray(G) ? "array" : G instanceof RegExp ? "object" : yt(Q, G) ? "symbol" : Q;
  }
  function Ft(G) {
    if (typeof G > "u" || G === null)
      return "" + G;
    var Q = Ct(G);
    if (Q === "object") {
      if (G instanceof Date)
        return "date";
      if (G instanceof RegExp)
        return "regexp";
    }
    return Q;
  }
  function de(G) {
    var Q = Ft(G);
    switch (Q) {
      case "array":
      case "object":
        return "an " + Q;
      case "boolean":
      case "date":
      case "regexp":
        return "a " + Q;
      default:
        return Q;
    }
  }
  function Xt(G) {
    return !G.constructor || !G.constructor.name ? L : G.constructor.name;
  }
  return O.checkPropTypes = Rr, O.resetWarningCache = Rr.resetWarningCache, O.PropTypes = O, O;
};
function es() {
}
function is() {
}
is.resetWarningCache = es;
var Ea = function() {
  function l(A, F, L, O, R, z) {
    if (z !== Me) {
      var j = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw j.name = "Invariant Violation", j;
    }
  }
  l.isRequired = l;
  function c() {
    return l;
  }
  var y = {
    array: l,
    bool: l,
    func: l,
    number: l,
    object: l,
    string: l,
    symbol: l,
    any: l,
    arrayOf: c,
    element: l,
    elementType: l,
    instanceOf: c,
    node: l,
    objectOf: c,
    oneOf: c,
    oneOfType: c,
    shape: c,
    exact: c,
    checkPropTypes: is,
    resetWarningCache: es
  };
  return y.PropTypes = y, y;
}, It = rr(function(l) {
  if (process.env.NODE_ENV !== "production") {
    var c = Qr, y = !0;
    l.exports = Aa(c.isElement, y);
  } else
    l.exports = Ea();
}), wa = function(c) {
  var y = Pt.memo(function(A) {
    var F = A.animationData, L = A.path, O = A.play, R = A.speed, z = A.direction, j = A.segments, Y = A.goTo, rt = A.renderer, lt = A.loop, mt = A.rendererSettings, wt = A.audioFactory, nt = A.onLoad, ht = A.onComplete, pt = A.onLoopComplete, xt = A.onEnterFrame, Mt = A.onSegmentStart, Yt = Ln(A, ["animationData", "path", "play", "speed", "direction", "segments", "goTo", "renderer", "loop", "rendererSettings", "audioFactory", "onLoad", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart"]), Ot = Pt.useRef(), tt = Pt.useRef(), yt = Pt.useState(!1), Ct = yt[0], Ft = yt[1], de = Pt.useState(j), Xt = de[0], G = de[1];
    Pt.useEffect(function() {
      Ir(Xt, j) || G(j);
    }, [j, Xt]);
    var Q = Pt.useState(mt), ft = Q[0], ut = Q[1];
    Pt.useEffect(function() {
      Ir(ft, mt) || ut(mt);
    }, [mt, ft]), Pt.useEffect(function() {
      return function() {
        return tt.current.removeEventListener("complete", ht);
      };
    }, [ht]), Pt.useEffect(function() {
      return function() {
        return tt.current.removeEventListener("loopComplete", pt);
      };
    }, [pt]), Pt.useEffect(function() {
      return function() {
        return tt.current.removeEventListener("enterFrame", xt);
      };
    }, [xt]), Pt.useEffect(function() {
      return function() {
        return tt.current.removeEventListener("segmentStart", Mt);
      };
    }, [Mt]), Pt.useEffect(function() {
      function it() {
        return F == null || typeof F != "object" ? F : typeof F.default == "object" ? Lr(F.default) : Lr(F);
      }
      tt.current = c.loadAnimation({
        animationData: it(),
        path: L,
        container: Ot.current,
        renderer: rt,
        loop: !1,
        autoplay: !1,
        rendererSettings: ft,
        audioFactory: wt
      });
      function W() {
        Ft(!0), nt();
      }
      return tt.current.addEventListener("DOMLoaded", W), function() {
        tt.current.removeEventListener("DOMLoaded", W), Ft(!1), tt.current.destroy(), tt.current = void 0;
      };
    }, [lt, rt, ft, F, L, wt]), Pt.useEffect(function() {
      tt.current.addEventListener("complete", ht);
    }, [ht]), Pt.useEffect(function() {
      tt.current.addEventListener("loopComplete", pt);
    }, [pt]), Pt.useEffect(function() {
      tt.current.addEventListener("enterFrame", xt);
    }, [xt]), Pt.useEffect(function() {
      tt.current.addEventListener("segmentStart", Mt);
    }, [Mt]), Pt.useEffect(function() {
      !Ct || (tt.current.loop = lt);
    }, [Ct, lt]);
    var et = Pt.useRef(!1);
    return Pt.useEffect(function() {
      if (!Ct)
        return;
      function it(dt) {
        tt.current.goToAndPlay(dt, !0), tt.current.setDirection(z);
      }
      if (O === !0) {
        var W = !0;
        if (Xt) {
          if (tt.current.playSegments(Xt, W), et.current = !0, z === -1) {
            var at = Xt[1];
            it(at);
          }
        } else if (et.current && tt.current.resetSegments(W), et.current = !1, z === -1) {
          var st = tt.current.getDuration(!0);
          it(st);
        } else
          tt.current.play();
      } else
        O === !1 && tt.current.pause();
    }, [O, Xt, Ct]), Pt.useEffect(function() {
      !Ct || Number.isNaN(R) || tt.current.setSpeed(R);
    }, [R, Ct]), Pt.useEffect(function() {
      !Ct || tt.current.setDirection(z);
    }, [z, Ct]), Pt.useEffect(function() {
      if (!!Ct && Y != null) {
        var it = !0;
        O ? tt.current.goToAndPlay(Y, it) : tt.current.goToAndStop(Y, it);
      }
    }, [Y, O, Ct]), /* @__PURE__ */ In.createElement("div", Hi({}, Yt, {
      ref: Ot
    }));
  });
  return y.propTypes = {
    animationData: It.object,
    path: It.string,
    play: It.bool,
    goTo: It.number,
    speed: It.number,
    direction: It.number,
    loop: It.oneOfType([It.number, It.bool]),
    segments: It.oneOfType([It.arrayOf(It.number), It.bool]),
    rendererSettings: It.object,
    renderer: It.string,
    audioFactory: It.func,
    onComplete: It.func,
    onLoopComplete: It.func,
    onEnterFrame: It.func,
    onSegmentStart: It.func
  }, y.defaultProps = {
    animationData: null,
    path: null,
    play: null,
    segments: null,
    goTo: null,
    speed: 1,
    direction: 1,
    loop: !0,
    rendererSettings: {},
    renderer: "svg",
    audioFactory: null,
    onLoad: function() {
    },
    onComplete: function() {
    },
    onLoopComplete: function() {
    },
    onEnterFrame: function() {
    },
    onSegmentStart: function() {
    }
  }, y;
}, Pa = wa(Fn), Ca = Pa;
const Ta = "5.3.4", Ma = 24, Fa = 0, Ia = 96, La = 500, Oa = 500, Ra = "Toggle", Va = 0, Ba = [], Da = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "Shutting Star",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          250,
          250,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -11.168,
                    -2.743
                  ],
                  [
                    -25,
                    -28
                  ]
                ],
                o: [
                  [
                    28.5,
                    7
                  ],
                  [
                    28.361,
                    31.764
                  ]
                ],
                v: [
                  [
                    -126,
                    -24.5
                  ],
                  [
                    -27,
                    37.5
                  ]
                ],
                c: !1
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "tm",
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.833
                    ],
                    y: [
                      0.833
                    ]
                  },
                  o: {
                    x: [
                      0.167
                    ],
                    y: [
                      0.167
                    ]
                  },
                  n: [
                    "0p833_0p833_0p167_0p167"
                  ],
                  t: 32,
                  s: [
                    0
                  ],
                  e: [
                    100
                  ]
                },
                {
                  t: 40
                }
              ],
              ix: 1
            },
            e: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.833
                    ],
                    y: [
                      0.833
                    ]
                  },
                  o: {
                    x: [
                      0.167
                    ],
                    y: [
                      0.167
                    ]
                  },
                  n: [
                    "0p833_0p833_0p167_0p167"
                  ],
                  t: 30,
                  s: [
                    0
                  ],
                  e: [
                    100
                  ]
                },
                {
                  t: 37
                }
              ],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: "Trim Paths 1",
            mn: "ADBE Vector Filter - Trim",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.933333333333,
                0.992156862745,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1,
              ix: 5
            },
            lc: 2,
            lj: 2,
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 30,
    op: 41,
    st: 30,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "Moon",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.1
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.9
              ],
              y: [
                0
              ]
            },
            n: [
              "0p1_1_0p9_0"
            ],
            t: 0,
            s: [
              -175.595
            ],
            e: [
              0
            ]
          },
          {
            i: {
              x: [
                0.1
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.9
              ],
              y: [
                0
              ]
            },
            n: [
              "0p1_1_0p9_0"
            ],
            t: 24,
            s: [
              0
            ],
            e: [
              0
            ]
          },
          {
            i: {
              x: [
                0.1
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.9
              ],
              y: [
                0
              ]
            },
            n: [
              "0p1_1_0p9_0"
            ],
            t: 48,
            s: [
              0
            ],
            e: [
              -175.595
            ]
          },
          {
            t: 72
          }
        ],
        ix: 10
      },
      p: {
        s: !0,
        x: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 0,
              s: [
                170
              ],
              e: [
                330
              ]
            },
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 24,
              s: [
                330
              ],
              e: [
                330
              ]
            },
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 48,
              s: [
                330
              ],
              e: [
                170
              ]
            },
            {
              t: 72
            }
          ],
          ix: 3
        },
        y: {
          a: 0,
          k: 250,
          ix: 4
        }
      },
      a: {
        a: 0,
        k: [
          60.25,
          60.25,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    4.981,
                    1.834
                  ],
                  [
                    0,
                    7.828
                  ],
                  [
                    11.632,
                    0
                  ],
                  [
                    2.39,
                    -0.941
                  ],
                  [
                    -1.477,
                    0
                  ],
                  [
                    0,
                    -11.632
                  ],
                  [
                    6.338,
                    -3.63
                  ],
                  [
                    0,
                    -5.618
                  ],
                  [
                    4.49,
                    -2.06
                  ],
                  [
                    0,
                    6.513
                  ]
                ],
                o: [
                  [
                    6.338,
                    -3.63
                  ],
                  [
                    0,
                    -11.632
                  ],
                  [
                    -2.724,
                    0
                  ],
                  [
                    1.391,
                    -0.289
                  ],
                  [
                    11.632,
                    0
                  ],
                  [
                    0,
                    7.828
                  ],
                  [
                    4.981,
                    1.834
                  ],
                  [
                    0,
                    5.263
                  ],
                  [
                    6.24,
                    -0.973
                  ],
                  [
                    0,
                    -5.619
                  ]
                ],
                v: [
                  [
                    3.775,
                    7.124
                  ],
                  [
                    14.388,
                    -11.16
                  ],
                  [
                    -6.674,
                    -32.221
                  ],
                  [
                    -14.388,
                    -30.757
                  ],
                  [
                    -10.079,
                    -31.2
                  ],
                  [
                    10.983,
                    -10.137
                  ],
                  [
                    0.37,
                    8.146
                  ],
                  [
                    8.911,
                    20.374
                  ],
                  [
                    1.297,
                    32.221
                  ],
                  [
                    12.317,
                    19.353
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    1.534,
                    0
                  ],
                  [
                    0,
                    5.888
                  ],
                  [
                    -1.927,
                    1.929
                  ],
                  [
                    0,
                    -4.354
                  ],
                  [
                    -5.888,
                    0
                  ],
                  [
                    -1.93,
                    1.933
                  ]
                ],
                o: [
                  [
                    -5.887,
                    0
                  ],
                  [
                    0,
                    -2.941
                  ],
                  [
                    -3.74,
                    1.656
                  ],
                  [
                    0,
                    5.887
                  ],
                  [
                    2.946,
                    0
                  ],
                  [
                    -1.319,
                    0.584
                  ]
                ],
                v: [
                  [
                    -57.252,
                    37.674
                  ],
                  [
                    -67.912,
                    27.014
                  ],
                  [
                    -64.794,
                    19.481
                  ],
                  [
                    -71.147,
                    29.228
                  ],
                  [
                    -60.487,
                    39.888
                  ],
                  [
                    -52.944,
                    36.76
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 0,
                  s: [
                    1,
                    0.940106153488,
                    0.53420650959,
                    1
                  ],
                  e: [
                    0.783999992819,
                    0.944999964097,
                    0.969000004787,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 24,
                  s: [
                    0.783999992819,
                    0.944999964097,
                    0.969000004787,
                    1
                  ],
                  e: [
                    0.783999992819,
                    0.944999964097,
                    0.969000004787,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 48,
                  s: [
                    0.783999992819,
                    0.944999964097,
                    0.969000004787,
                    1
                  ],
                  e: [
                    1,
                    0.940106153488,
                    0.53420650959,
                    1
                  ]
                },
                {
                  t: 72
                }
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                86.845,
                53.361
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shadow",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    4.981,
                    1.834
                  ],
                  [
                    0,
                    7.828
                  ],
                  [
                    11.632,
                    0
                  ],
                  [
                    0,
                    -11.632
                  ],
                  [
                    -10.302,
                    -1.374
                  ],
                  [
                    0,
                    -3.827
                  ],
                  [
                    -7.202,
                    0
                  ],
                  [
                    0,
                    7.202
                  ]
                ],
                o: [
                  [
                    6.338,
                    -3.63
                  ],
                  [
                    0,
                    -11.632
                  ],
                  [
                    -11.632,
                    0
                  ],
                  [
                    0,
                    10.679
                  ],
                  [
                    -2.624,
                    2.386
                  ],
                  [
                    0,
                    7.202
                  ],
                  [
                    7.203,
                    0
                  ],
                  [
                    0,
                    -5.619
                  ]
                ],
                v: [
                  [
                    10.449,
                    7.038
                  ],
                  [
                    21.061,
                    -11.246
                  ],
                  [
                    0,
                    -32.307
                  ],
                  [
                    -21.061,
                    -11.246
                  ],
                  [
                    -2.81,
                    9.623
                  ],
                  [
                    -7.092,
                    19.266
                  ],
                  [
                    5.949,
                    32.307
                  ],
                  [
                    18.991,
                    19.266
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    -5.888
                  ],
                  [
                    5.887,
                    0
                  ],
                  [
                    0,
                    5.887
                  ],
                  [
                    -5.888,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    5.887
                  ],
                  [
                    -5.888,
                    0
                  ],
                  [
                    0,
                    -5.888
                  ],
                  [
                    5.887,
                    0
                  ]
                ],
                v: [
                  [
                    -43.153,
                    29.141
                  ],
                  [
                    -53.813,
                    39.801
                  ],
                  [
                    -64.473,
                    29.141
                  ],
                  [
                    -53.813,
                    18.481
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 0,
                  s: [
                    1,
                    0.940106153488,
                    0.53420650959,
                    1
                  ],
                  e: [
                    0.862999949736,
                    0.957000014361,
                    0.969000004787,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 24,
                  s: [
                    0.862999949736,
                    0.957000014361,
                    0.969000004787,
                    1
                  ],
                  e: [
                    0.862999949736,
                    0.957000014361,
                    0.969000004787,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 48,
                  s: [
                    0.862999949736,
                    0.957000014361,
                    0.969000004787,
                    1
                  ],
                  e: [
                    1,
                    0.940106153488,
                    0.53420650959,
                    1
                  ]
                },
                {
                  t: 72
                }
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                80.171,
                53.448
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Crater",
        np: 3,
        cix: 2,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    -33.137
                  ],
                  [
                    33.137,
                    0
                  ],
                  [
                    0,
                    33.137
                  ],
                  [
                    -33.137,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    33.137
                  ],
                  [
                    -33.137,
                    0
                  ],
                  [
                    0,
                    -33.137
                  ],
                  [
                    33.137,
                    0
                  ]
                ],
                v: [
                  [
                    60,
                    0
                  ],
                  [
                    0,
                    60
                  ],
                  [
                    -60,
                    0
                  ],
                  [
                    0,
                    -60
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 0,
                  s: [
                    1,
                    0.940106153488,
                    0.53420650959,
                    1
                  ],
                  e: [
                    0.933000033509,
                    0.991999966491,
                    1,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 24,
                  s: [
                    0.933000033509,
                    0.991999966491,
                    1,
                    1
                  ],
                  e: [
                    0.933000033509,
                    0.991999966491,
                    1,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 48,
                  s: [
                    0.933000033509,
                    0.991999966491,
                    1,
                    1
                  ],
                  e: [
                    1,
                    0.940106153488,
                    0.53420650959,
                    1
                  ]
                },
                {
                  t: 72
                }
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                60.25,
                60.25
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Moon",
        np: 2,
        cix: 2,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "Stars",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 11,
            s: [
              0
            ],
            e: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 13,
            s: [
              100
            ],
            e: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 59,
            s: [
              100
            ],
            e: [
              0
            ]
          },
          {
            t: 61
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        s: !0,
        x: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.101
                ],
                y: [
                  0.954
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p101_0p954_0p9_0"
              ],
              t: 0,
              s: [
                304.75
              ],
              e: [
                190.55
              ]
            },
            {
              i: {
                x: [
                  0.438
                ],
                y: [
                  0.439
                ]
              },
              o: {
                x: [
                  0.397
                ],
                y: [
                  0.396
                ]
              },
              n: [
                "0p438_0p439_0p397_0p396"
              ],
              t: 24,
              s: [
                190.55
              ],
              e: [
                184.75
              ]
            },
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.899
                ],
                y: [
                  -0.043
                ]
              },
              n: [
                "0p1_1_0p899_-0p043"
              ],
              t: 48,
              s: [
                184.75
              ],
              e: [
                304.75
              ]
            },
            {
              t: 72
            }
          ],
          ix: 3
        },
        y: {
          a: 0,
          k: 212.75,
          ix: 4
        }
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            d: 1,
            ty: "el",
            s: {
              a: 0,
              k: [
                10,
                10
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            nm: "Ellipse Path 1",
            mn: "ADBE Vector Shape - Ellipse",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 32,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.933333333333,
                0.992156862745,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                -32.5,
                65
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Star 03",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            d: 1,
            ty: "el",
            s: {
              a: 0,
              k: [
                6,
                6
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            nm: "Ellipse Path 1",
            mn: "ADBE Vector Shape - Ellipse",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 32,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.933333333333,
                0.992156862745,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                47.5,
                45
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Star 02",
        np: 3,
        cix: 2,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            d: 1,
            ty: "el",
            s: {
              a: 0,
              k: [
                8,
                8
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            nm: "Ellipse Path 1",
            mn: "ADBE Vector Shape - Ellipse",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 32,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.933333333333,
                0.992156862745,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Star 01",
        np: 3,
        cix: 2,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: "Cloud 1",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 11,
            s: [
              100
            ],
            e: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 13,
            s: [
              0
            ],
            e: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 59,
            s: [
              0
            ],
            e: [
              100
            ]
          },
          {
            t: 61
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        s: !0,
        x: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 0,
              s: [
                275.5
              ],
              e: [
                184
              ]
            },
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 24,
              s: [
                184
              ],
              e: [
                184
              ]
            },
            {
              i: {
                x: [
                  0.102
                ],
                y: [
                  0.92
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p102_0p92_0p9_0"
              ],
              t: 48,
              s: [
                184
              ],
              e: [
                269.054
              ]
            },
            {
              i: {
                x: [
                  0.731
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.225
                ],
                y: [
                  0.253
                ]
              },
              n: [
                "0p731_1_0p225_0p253"
              ],
              t: 72,
              s: [
                269.054
              ],
              e: [
                275.5
              ]
            },
            {
              t: 95
            }
          ],
          ix: 3
        },
        y: {
          a: 0,
          k: 220,
          ix: 4
        }
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    4.193,
                    0.263
                  ],
                  [
                    4.158,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.688,
                    -3.952
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -4.43
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.43,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    4.43
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    -0.677,
                    -3.965
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.149,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.43,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    4.43
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    4.43,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -4.259
                  ]
                ],
                v: [
                  [
                    11.887,
                    -4.516
                  ],
                  [
                    3.601,
                    -11.5
                  ],
                  [
                    3.601,
                    -11.5
                  ],
                  [
                    -4.68,
                    -4.542
                  ],
                  [
                    -11.38,
                    -4.542
                  ],
                  [
                    -19.401,
                    3.479
                  ],
                  [
                    -19.401,
                    3.479
                  ],
                  [
                    -11.38,
                    11.5
                  ],
                  [
                    11.38,
                    11.5
                  ],
                  [
                    19.401,
                    3.479
                  ],
                  [
                    19.401,
                    3.479
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 32,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: "Cloud 2",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 11,
            s: [
              100
            ],
            e: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 13,
            s: [
              0
            ],
            e: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            n: [
              "0p833_0p833_0p167_0p167"
            ],
            t: 59,
            s: [
              0
            ],
            e: [
              100
            ]
          },
          {
            t: 61
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        s: !0,
        x: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 0,
              s: [
                330.5
              ],
              e: [
                167.5
              ]
            },
            {
              i: {
                x: [
                  0.1
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p1_1_0p9_0"
              ],
              t: 24,
              s: [
                167.5
              ],
              e: [
                167.5
              ]
            },
            {
              i: {
                x: [
                  0.101
                ],
                y: [
                  0.95
                ]
              },
              o: {
                x: [
                  0.9
                ],
                y: [
                  0
                ]
              },
              n: [
                "0p101_0p95_0p9_0"
              ],
              t: 48,
              s: [
                167.5
              ],
              e: [
                324.054
              ]
            },
            {
              i: {
                x: [
                  0.731
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.218
                ],
                y: [
                  0.284
                ]
              },
              n: [
                "0p731_1_0p218_0p284"
              ],
              t: 72,
              s: [
                324.054
              ],
              e: [
                330.5
              ]
            },
            {
              t: 95
            }
          ],
          ix: 3
        },
        y: {
          a: 0,
          k: 265,
          ix: 4
        }
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    6.375,
                    0.399
                  ],
                  [
                    6.322,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.046,
                    -6.009
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -6.736
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -6.736,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    6.736
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    -1.03,
                    -6.029
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -6.308,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -6.736,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    6.736
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    6.736,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -6.476
                  ]
                ],
                v: [
                  [
                    16.075,
                    -1.367
                  ],
                  [
                    3.476,
                    -11.986
                  ],
                  [
                    3.476,
                    -11.986
                  ],
                  [
                    -9.116,
                    -1.406
                  ],
                  [
                    -19.304,
                    -1.406
                  ],
                  [
                    -31.5,
                    10.79
                  ],
                  [
                    -31.5,
                    10.79
                  ],
                  [
                    -19.304,
                    22.986
                  ],
                  [
                    15.304,
                    22.986
                  ],
                  [
                    27.5,
                    10.79
                  ],
                  [
                    27.5,
                    10.79
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 32,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: "Shadow",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 15,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          250,
          180,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          -37.154,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    37.432,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -37.432
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.021,
                    -0.694
                  ],
                  [
                    -36.733,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.105,
                    -36.465
                  ],
                  [
                    0,
                    0.699
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -37.432,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.699
                  ],
                  [
                    1.105,
                    -36.465
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    36.733,
                    0
                  ],
                  [
                    0.021,
                    -0.694
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -37.432
                  ]
                ],
                v: [
                  [
                    82.223,
                    -37.154
                  ],
                  [
                    -82.223,
                    -37.154
                  ],
                  [
                    -150,
                    30.623
                  ],
                  [
                    -150,
                    35.069
                  ],
                  [
                    -149.947,
                    37.154
                  ],
                  [
                    -82.223,
                    -28.538
                  ],
                  [
                    82.223,
                    -28.538
                  ],
                  [
                    149.947,
                    37.154
                  ],
                  [
                    150,
                    35.069
                  ],
                  [
                    150,
                    30.623
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.933333333333,
                0.992156862745,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 4,
    nm: "Base",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          250,
          180,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          -70,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            d: 1,
            s: {
              a: 0,
              k: [
                300,
                140
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 320,
              ix: 4
            },
            nm: "Rectangle Path 1",
            mn: "ADBE Vector Shape - Rect",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 0,
                  s: [
                    0.413832724094,
                    0.784281790257,
                    1,
                    1
                  ],
                  e: [
                    0.0580506064,
                    0.077281616628,
                    0.256188720465,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 24,
                  s: [
                    0.0580506064,
                    0.077281616628,
                    0.256188720465,
                    1
                  ],
                  e: [
                    0.0580506064,
                    0.077281616628,
                    0.256188720465,
                    1
                  ]
                },
                {
                  i: {
                    x: [
                      0.1
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.9
                    ],
                    y: [
                      0
                    ]
                  },
                  n: [
                    "0p1_1_0p9_0"
                  ],
                  t: 48,
                  s: [
                    0.0580506064,
                    0.077281616628,
                    0.256188720465,
                    1
                  ],
                  e: [
                    0.413832724094,
                    0.784281790257,
                    1,
                    1
                  ]
                },
                {
                  t: 72
                }
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Rectangle 1",
        np: 2,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: "BG",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          250,
          250,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            d: 1,
            s: {
              a: 0,
              k: [
                500,
                500
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 4
            },
            nm: "Rectangle Path 1",
            mn: "ADBE Vector Shape - Rect",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 18.8,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !0
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 96,
    st: 0,
    bm: 0
  }
], ja = [], Na = {
  v: Ta,
  fr: Ma,
  ip: Fa,
  op: Ia,
  w: La,
  h: Oa,
  nm: Ra,
  ddd: Va,
  assets: Ba,
  layers: Da,
  markers: ja
}, za = (l) => {
  var F;
  const c = `${l}`, y = parseFloat(c), A = (F = c.match(/[\d.\-+]*\s*(.*)/)) == null ? void 0 : F[1];
  return [isNaN(y) ? 0 : y, A || "px"];
}, Vr = [5, 50], Br = [50, 95], $a = ze.memo(({
  isDarkMode: l,
  onChange: c,
  size: y = 85,
  speed: A = 1.3,
  className: F = ""
}) => {
  const [L, O] = za(y), [R, z] = ze.useState([0, 0]), [j] = ze.useState(l ? Br[0] : Vr[0]), [Y, rt] = ze.useState(!1), [lt, mt] = ze.useState(!1), wt = () => {
    z(l ? Br : Vr), rt(!0), c(!l);
  }, nt = () => {
    mt(!0);
  };
  return ze.createElement("button", {
    onClick: wt,
    "aria-hidden": "true",
    className: En(Ga(L, O), F)
  }, ze.createElement(Ca, {
    className: Wa(lt, L, O),
    loop: !1,
    speed: A,
    play: Y,
    animationData: Na,
    goTo: j,
    segments: R,
    onLoad: nt
  }));
}, qa);
$a.displayName = "DarkModeToggle";
function qa(l, c) {
  return l.size === c.size && l.isDarkMode === c.isDarkMode && l.speed === c.speed && l.className === c.className;
}
function Ga(l, c) {
  return Kr({
    cursor: "pointer",
    overflow: "hidden",
    width: `${l}${c}`,
    height: `${l * 0.5}${c}`,
    appearance: "none",
    border: "none",
    backgroundColor: "transparent",
    padding: 0
  });
}
function Wa(l, c, y) {
  return Kr({
    display: l ? "flex" : "none",
    alignItems: "center",
    justifyContent: "center",
    marginTop: `${c * -0.575}${y}`,
    marginLeft: `${c * -0.32}${y}`,
    width: `${c * 1.65}${y}`,
    height: `${c * 1.65}${y}`
  });
}
export {
  $a as DarkModeToggle
};
